(function() {
  'use strict';

  // ─── Bootstrap ──────────────────────────────────────
  var wrap = document.getElementById('xbb-wrap');
  if (!wrap) return;

  var rawLocale = wrap.dataset.locale || 'nl';
  var lang = rawLocale.indexOf('de') === 0 ? 'de'
           : rawLocale.indexOf('fr') === 0 ? 'fr'
           : rawLocale.indexOf('en') === 0 ? 'en' : 'nl';
  var lp = wrap.dataset.lp || '';
  var currency = wrap.dataset.currency || '€';
  var productsPerPage = parseInt(wrap.dataset.productsPage, 10) || 24;

  // ─── Easy Cord Clip free gift (Option A: dedicated €0 variant) ─────
  // Certain cordless cases (tagged clipCaseTag) can't attach a cord on their
  // own — they need an Easy Cord Clip. When such a case is in the bundle AND
  // the bundle contains at least one cord, we auto-add a FREE clip.
  // The clip is a DERIVED line: it is never stored in S.cases/cords/accessories,
  // so it's automatically excluded from the item count, the totals and the
  // discount math. It's added to the cart WITHOUT the _bundle="true" property,
  // so the discount Shopify Function ignores it too (no count, no % applied).
  // clipVariantId must point at a dedicated €0-priced variant (the standalone
  // clip stays €5,99). Empty setting = feature dormant (safe to ship).
  var clipVariantId = String(wrap.dataset.clipVariantId || '').trim();
  var clipTitle = wrap.dataset.clipTitle || 'Easy Cord Clip';
  // Prefer the plain-URL setting (settable outside the theme editor); fall back
  // to the image_picker setting, then to the gift emoji in the UI.
  var clipImage = String(wrap.dataset.clipImageUrl || wrap.dataset.clipImage || '').trim();
  var clipCaseTag = String(wrap.dataset.clipCaseTag || 'easy-cord-case').trim().toLowerCase();
  // Product whose photos / description / price the clip popup shows (the tile in
  // the cord-step notification). Defaulted in Liquid to the clip's own product.
  var clipInfoHandle = String(wrap.dataset.clipInfoHandle || '').trim();
  // Loox widget key for the quick view's reviews panel. Read off the Loox app
  // embed already on the page (it carries the key in its script URL); the
  // section setting is the fallback. Empty = no reviews panel.
  var looxKey = (function() {
    try {
      var sc = document.querySelector('script[src*="loox.io/widget/"]');
      var m = sc && String(sc.src).match(/\/widget\/([^\/?]+)\//);
      if (m && m[1]) return m[1];
    } catch (e) {}
    return String(wrap.dataset.looxKey || '').trim();
  })();
  // Tracker route that turns Loox's widget page into JSON (see the route's own
  // notes). Empty = the panel embeds Loox's frame instead.
  var reviewsApi = String(wrap.dataset.reviewsApi || '').trim().replace(/\/+$/, '');
  var clipEnabled = clipVariantId !== '' && !isNaN(parseInt(clipVariantId, 10));

  // Normal (non-cord) cases that belong in the "Zonder koord" grid: they can't
  // hold a cord on their own, so they're paired with the free clip above. They
  // live in one automated collection (tag = clipCaseTag). Each is a per-MODEL
  // product (model in the title, single variant), so we fetch the collection
  // once and filter to the selected model by title. Empty = feature off.
  var normalCaseHandle = String(wrap.dataset.normalCaseHandle || '').trim();
  // Collection of the real per-model case products, used to re-point the curated
  // "dropdown" tiles at their actual product (see swapTilesToSourceProducts).
  // Blank disables the swap entirely and the builder behaves exactly as before.
  var caseSourceHandle = String(wrap.dataset.caseSourceHandle || '').trim();
  // Display order of the derived designs, and optional label overrides. Both are
  // merchant-editable so adding/reordering/renaming a design needs no code.
  var caseDesignOrderRaw = String(wrap.dataset.caseDesignOrder || '');
  var caseDesignLabelsRaw = String(wrap.dataset.caseDesignLabels || '');
  var normalCasesEnabled = normalCaseHandle !== '';

  // ─── Bundle discount tiers (visual widget only) ────
  var discEnabled = wrap.dataset.discEnabled === '1';
  var discTiers = [];
  try {
    var parsedTiers = JSON.parse(wrap.dataset.discTiers || '[]');
    var seenTier = {};
    parsedTiers.forEach(function(t) {
      var mn = parseInt(t.min, 10);
      var pc = parseInt(t.pct, 10);
      if (mn > 0 && pc > 0 && !seenTier[mn]) {
        seenTier[mn] = true;
        discTiers.push({ min: mn, pct: pc });
      }
    });
    discTiers.sort(function(a, b) { return a.min - b.min; });
  } catch (e) { discTiers = []; }

  // ─── Translations ───────────────────────────────────
  var T = {
    nl: {
      empty: 'Geen producten gevonden.',
      loadError: 'Kon producten niet laden.',
      addedToCart: 'Toegevoegd aan winkelmandje',
      addError: 'Er ging iets mis. Probeer opnieuw.',
      pickCase: 'Kies eerst een hoesje',
      itemsLabel: function(n) { return n === 1 ? '1 item' : n + ' items'; },
      emptyShort: 'Nog leeg',
      kindCase: 'Hoesje',
      kindCord: 'Koord',
      kindAcc: 'Extra',
      from: 'vanaf',
      remove: 'Verwijderen',
      soldOut: 'Uitverkocht',
      inStock: 'Op voorraad',
      giftLabel: 'Gratis cadeau',
      giftNote: 'Zodat je koord aan je hoesje vastklikt',
      free: 'Gratis',
      nudgeTitle: 'Gratis Easy Cord Clip',
      unlockTitle: 'Nog te ontgrendelen',
      nudgeText: 'Voeg een koord toe en je ontvangt de clip gratis.',
      nudgeCta: 'Koord kiezen',
      clipEarnedEyebrow: 'Toegevoegd',
      clipEarned: 'Zit gratis in je bundel.',
      clipWorth: function(m) { return 't.w.v. ' + m; },
      clipSee: 'Bekijk de clip',
      reviewsSee: 'Bekijk reviews',
      reviewsTitle: 'Reviews',
      reviewsLoading: 'Reviews laden…',
      reviewsMore: 'Meer',
      reviewsLess: 'Minder',
      reviewsPrev: 'Vorige reviews',
      reviewsNext: 'Volgende reviews',
      reviewsShown: function(n, total) { return n + ' van ' + total + ' reviews'; },
      reviewsNone: 'Nog geen reviews met tekst.',
      modelNoMatch: 'Geen telefoon gevonden',
      ctaContinueCord: 'Verder naar koord',
      ctaContinueExtras: "Verder naar extra's",
      ctaAddToCart: 'Naar winkelmandje',
      discAddMore: function(n, pct) { return 'Voeg ' + n + ' ' + (n === 1 ? 'product' : 'producten') + ' toe voor ' + pct + '% korting'; },
      discNextTier: function(n, pct) { return 'Nog ' + n + ' ' + (n === 1 ? 'product' : 'producten') + ' voor ' + pct + '% korting'; },
      discMax: 'Maximale korting ontgrendeld',
      discApplied: function(pct) { return pct + '% korting toegepast'; },
      discUnlocked: function(pct) { return pct + '% korting ontgrendeld'; },
      upsellTitle: function(pct) { return 'Nog 1 product voor ' + pct + '% korting'; },
      upsellSub: 'Voeg 1 extra toe en je hele bundel krijgt direct extra korting bij de checkout.',
      upsellSaving: function(a) { return 'Dat is direct ' + a + ' extra korting op wat er nu al in je set zit.'; }
    },
    de: {
      empty: 'Keine Produkte gefunden.',
      loadError: 'Konnte Produkte nicht laden.',
      addedToCart: 'In den Warenkorb gelegt',
      addError: 'Etwas ist schiefgelaufen.',
      pickCase: 'Wähle zuerst eine Hülle',
      itemsLabel: function(n) { return n === 1 ? '1 Artikel' : n + ' Artikel'; },
      emptyShort: 'Noch leer',
      kindCase: 'Hülle',
      kindCord: 'Band',
      kindAcc: 'Extra',
      from: 'ab',
      remove: 'Entfernen',
      soldOut: 'Ausverkauft',
      inStock: 'Auf Lager',
      giftLabel: 'Gratis Geschenk',
      giftNote: 'Damit sich deine Kordel an der Hülle befestigen lässt',
      free: 'Gratis',
      nudgeTitle: 'Gratis Easy Cord Clip',
      unlockTitle: 'Noch freischaltbar',
      nudgeText: 'Füge eine Kordel hinzu und du erhältst den Clip gratis.',
      nudgeCta: 'Kordel wählen',
      clipEarnedEyebrow: 'Hinzugefügt',
      clipEarned: 'Ist gratis in deinem Bundle.',
      clipWorth: function(m) { return 'im Wert von ' + m; },
      clipSee: 'Clip ansehen',
      reviewsSee: 'Bewertungen ansehen',
      reviewsTitle: 'Bewertungen',
      reviewsLoading: 'Bewertungen werden geladen…',
      reviewsMore: 'Mehr',
      reviewsLess: 'Weniger',
      reviewsPrev: 'Vorherige Bewertungen',
      reviewsNext: 'Weitere Bewertungen',
      reviewsShown: function(n, total) { return n + ' von ' + total + ' Bewertungen'; },
      reviewsNone: 'Noch keine Bewertungen mit Text.',
      modelNoMatch: 'Kein Telefon gefunden',
      ctaContinueCord: 'Weiter zum Band',
      ctaContinueExtras: 'Weiter zu Extras',
      ctaAddToCart: 'Zum Warenkorb',
      discAddMore: function(n, pct) { return n + ' Artikel für ' + pct + '% Rabatt hinzufügen'; },
      discNextTier: function(n, pct) { return 'Noch ' + n + ' Artikel für ' + pct + '% Rabatt'; },
      discMax: 'Maximaler Rabatt erreicht',
      discApplied: function(pct) { return pct + '% Rabatt aktiv'; },
      discUnlocked: function(pct) { return pct + '% Rabatt freigeschaltet'; },
      upsellTitle: function(pct) { return 'Noch 1 Artikel für ' + pct + '% Rabatt'; },
      upsellSub: 'Füge 1 Extra hinzu und dein gesamtes Bundle bekommt direkt zusätzlichen Rabatt beim Checkout.',
      upsellSaving: function(a) { return 'Das sind sofort ' + a + ' extra Rabatt auf alles, was schon in deinem Set liegt.'; }
    },
    en: {
      empty: 'No products found.',
      loadError: 'Could not load products.',
      addedToCart: 'Added to cart',
      addError: 'Something went wrong.',
      pickCase: 'Pick a case first',
      itemsLabel: function(n) { return n === 1 ? '1 item' : n + ' items'; },
      emptyShort: 'Empty',
      kindCase: 'Case',
      kindCord: 'Cord',
      kindAcc: 'Extra',
      from: 'from',
      remove: 'Remove',
      soldOut: 'Sold out',
      inStock: 'In stock',
      giftLabel: 'Free gift',
      giftNote: 'So your cord clips onto your case',
      free: 'Free',
      nudgeTitle: 'Free Easy Cord Clip',
      unlockTitle: 'Still to unlock',
      nudgeText: 'Add a cord and the clip is yours, free.',
      nudgeCta: 'Choose a cord',
      clipEarnedEyebrow: 'Added',
      clipEarned: 'Included free in your bundle.',
      clipWorth: function(m) { return 'worth ' + m; },
      clipSee: 'See the clip',
      reviewsSee: 'See reviews',
      reviewsTitle: 'Reviews',
      reviewsLoading: 'Loading reviews…',
      reviewsMore: 'More',
      reviewsLess: 'Less',
      reviewsPrev: 'Previous reviews',
      reviewsNext: 'Next reviews',
      reviewsShown: function(n, total) { return n + ' of ' + total + ' reviews'; },
      reviewsNone: 'No written reviews yet.',
      modelNoMatch: 'No phone found',
      ctaContinueCord: 'Continue to cord',
      ctaContinueExtras: 'Continue to extras',
      ctaAddToCart: 'Add to cart',
      discAddMore: function(n, pct) { return 'Add ' + n + ' ' + (n === 1 ? 'item' : 'items') + ' for ' + pct + '% off'; },
      discNextTier: function(n, pct) { return n + ' more ' + (n === 1 ? 'item' : 'items') + ' for ' + pct + '% off'; },
      discMax: 'Max discount unlocked',
      discApplied: function(pct) { return pct + '% off applied'; },
      discUnlocked: function(pct) { return pct + '% off unlocked'; },
      upsellTitle: function(pct) { return '1 more item for ' + pct + '% off'; },
      upsellSub: 'Add 1 extra and your whole bundle gets the extra discount automatically at checkout.',
      upsellSaving: function(a) { return 'That is an instant ' + a + ' extra off what is already in your set.'; }
    },
    fr: {
      empty: 'Aucun produit trouvé.',
      loadError: 'Impossible de charger les produits.',
      addedToCart: 'Ajouté au panier',
      addError: 'Une erreur est survenue.',
      pickCase: "Choisissez une coque d'abord",
      itemsLabel: function(n) { return n === 1 ? '1 article' : n + ' articles'; },
      emptyShort: 'Vide',
      kindCase: 'Coque',
      kindCord: 'Cordon',
      kindAcc: 'Extra',
      from: 'à partir de',
      remove: 'Retirer',
      soldOut: 'Épuisé',
      inStock: 'En stock',
      giftLabel: 'Cadeau gratuit',
      giftNote: 'Pour que votre cordon se clipse sur votre coque',
      free: 'Gratuit',
      nudgeTitle: 'Easy Cord Clip offert',
      unlockTitle: 'Encore à débloquer',
      nudgeText: 'Ajoutez un cordon et le clip est offert.',
      nudgeCta: 'Choisir un cordon',
      clipEarnedEyebrow: 'Ajouté',
      clipEarned: 'Inclus gratuitement dans votre pack.',
      clipWorth: function(m) { return "d'une valeur de " + m; },
      clipSee: 'Voir le clip',
      reviewsSee: 'Voir les avis',
      reviewsTitle: 'Avis',
      reviewsLoading: 'Chargement des avis…',
      reviewsMore: 'Plus',
      reviewsLess: 'Moins',
      reviewsPrev: 'Avis précédents',
      reviewsNext: 'Avis suivants',
      reviewsShown: function(n, total) { return n + ' sur ' + total + ' avis'; },
      reviewsNone: "Pas encore d'avis écrits.",
      modelNoMatch: 'Aucun téléphone trouvé',
      ctaContinueCord: 'Continuer au cordon',
      ctaContinueExtras: 'Continuer aux extras',
      ctaAddToCart: 'Au panier',
      discAddMore: function(n, pct) { return 'Ajoutez ' + n + ' ' + (n === 1 ? 'article' : 'articles') + ' pour ' + pct + '% de remise'; },
      discNextTier: function(n, pct) { return n + ' ' + (n === 1 ? 'article' : 'articles') + ' de plus pour ' + pct + '% de remise'; },
      discMax: 'Remise maximale débloquée',
      discApplied: function(pct) { return pct + '% de remise appliquée'; },
      discUnlocked: function(pct) { return pct + '% de remise débloquée'; },
      upsellTitle: function(pct) { return 'Encore 1 article pour ' + pct + '% de remise'; },
      upsellSub: 'Ajoutez 1 extra et tout votre pack reçoit automatiquement la remise au checkout.',
      upsellSaving: function(a) { return 'Soit ' + a + ' de remise en plus, tout de suite, sur ce qui est déjà dans votre set.'; }
    }
  };
  var t = T[lang] || T.nl;

  // The section's inline bootstrap paints the model picker before this file is
  // even fetched (it is deferred, so on a slow phone that is many seconds). This
  // flag tells it to stop queueing taps, because from here on they are handled.
  try { window.__xbbReady = true; } catch (e) {}

  // ─── Config ─────────────────────────────────────────
  var config;
  var configEl = document.getElementById('xbb-config');
  try {
    if (!configEl) throw new Error('config script tag missing');
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('[xoxo-bundle] failed to parse config', e);
    wrap.insertAdjacentHTML('beforeend',
      '<div style="padding:2rem;margin:2rem;text-align:center;background:#fff;border:1px solid #7a2229;border-radius:12px;color:#53181f;font-family:system-ui">' +
      '<strong>Bundle builder failed to load.</strong><br>' +
      '<small style="opacity:.7">' + (e && e.message ? e.message : 'unknown error') + '</small></div>');
    return;
  }
  if (!config || !config.steps) return;
  var stepConfig = {};
  config.steps.forEach(function(s) { stepConfig[s.step_number] = s; });

  // ─── State ──────────────────────────────────────────
  var S = {
    step: 1,
    maxStep: 1,              // furthest step reached — drives progress bar clickability
    gridDensity: '2',        // '2' = side-by-side, '1' = full-width cards
    gridSort: 'default',     // 'default' | 'price_asc' | 'price_desc'
    activeBrand: 'iphone',   // 'iphone' | 'samsung' — filters gen chips + models
    extraCasesModel: null,   // iPhone model handle for the "Extra hoesjes" view
    extraCasesCord: null,    // 'cord' | 'nocord' — cord-type filter in "Extra hoesjes"
    // null = the first generation in the config (renderGenChips resolves it,
    // same idiom as the brand switch), so a new model launch never needs this file.
    activeGen: null,
    modelQuery: '',          // step-1 device-search typeahead text (not persisted)
    model: null,             // { handle, title, image_url }
    caseType: 'without',     // 'without' | 'with' — affects case grid filter + path
    case: null,              // primary case (auto = cases[0] || null); kept for back-compat with code that reads a single case
    cases: [],               // multi-select cases array (mirrors how cords/accessories work)
    cordLength: 'short',
    cords: [],               // [{ handle, variantId, title, price, image, qty }]
    activeSubcat: null,
    accessoryAirpodsModel: null,
    accessories: [],         // [{ handle, variantId, title, price, image, qty, subcat }]
    substep: null,           // last visible substep id, restored on refresh
    filterExtrasByModel: true,
    smartDeviceOverride: ''     // '' = "Mijn model" (use bundle cases). Otherwise a model handle from stepConfig[1].models.
  };

  // ─── Persistence (survives page refresh) ────────────
  var PERSIST_KEY = 'xbb_state_v1';
  var PERSIST_TTL = 1000 * 60 * 60 * 24 * 7; // 7 days
  // While a saved bundle is waiting behind the resume banner (deferred, not
  // yet confirmed), the in-memory state is EMPTY — persisting it would wipe
  // the very bundle the banner offers to restore (init's refreshTray alone
  // used to zero it out, so "Verder met je bundel" always restored nothing).
  // Writes stay blocked until the shopper either resumes (page reloads with
  // the confirm flag) or starts a NEW bundle (first item added) — at that
  // point the new bundle wins, the old snapshot may be overwritten, and the
  // now-stale resume banner is hidden.
  var _deferredResumePending = false;
  function persistState() {
    if (_deferredResumePending) {
      if (itemCount() === 0) return;   // protect the saved bundle
      _deferredResumePending = false;  // new bundle started — take over
      var staleBanner = document.getElementById('xbb-resume');
      if (staleBanner) staleBanner.hidden = true;
    }
    try {
      var snapshot = {
        ts: Date.now(),
        lang: lang,
        step: S.step,
        maxStep: S.maxStep,
        gridDensity: S.gridDensity,
        gridSort: S.gridSort,
        extraCasesModel: S.extraCasesModel,
        extraCasesCord: S.extraCasesCord,
        activeBrand: S.activeBrand,
        activeGen: S.activeGen,
        model: S.model,
        caseType: S.caseType,
        case: S.case,
        cases: S.cases,
        cordLength: S.cordLength,
        cords: S.cords,
        activeSubcat: S.activeSubcat,
        accessoryAirpodsModel: S.accessoryAirpodsModel,
        accessories: S.accessories,
        substep: S.substep
      };
      localStorage.setItem(PERSIST_KEY, JSON.stringify(snapshot));
    } catch (e) { /* quota / private mode — ignore */ }
  }
  function loadPersistedState() {
    try {
      var raw = localStorage.getItem(PERSIST_KEY);
      if (!raw) return null;
      var snap = JSON.parse(raw);
      if (!snap || !snap.ts) return null;
      // Expire after TTL or if language switched (cart prices/translations differ)
      if (Date.now() - snap.ts > PERSIST_TTL) return null;
      if (snap.lang && snap.lang !== lang) return null;
      return snap;
    } catch (e) { return null; }
  }
  function clearPersistedState() {
    try { localStorage.removeItem(PERSIST_KEY); } catch (e) {}
  }

  var productCache = {};         // collectionHandle → products
  var productInflight = {};      // collectionHandle → [callbacks] while fetching
  var visibleCounts = {};        // grid id → currently rendered count
  var descByHandle = {};         // product handle → body_html, for the quick-view
  var fullProductLists = {};     // grid id → currently displayed list (possibly sorted)
  var originalProductLists = {}; // grid id → untouched original order from collection
  var colorFilterState = {};     // grid id → active color family ('pink'…) or null/undefined
  var facetCache = {};           // collectionHandle → { filters, map, products_count }
  var facetState = {};           // grid id → { paramName: [selected keys] } (AND across params, OR within)
  var priceState = {};           // grid id → { min: cents|null, max: cents|null } (price kept separate: range, not keys)
  var gridHandle = {};           // grid id → collectionHandle currently shown (to look facets up)
  var wantsFilters = {};         // grid id → did this grid opt into a filter row?
  // Merged facet indexes, fed by EVERY successful ?view=bundle-json fetch.
  // Grids frequently show a SUBSET or a MERGE of collections (model-resolved
  // designs, with-cord filters, Samsung splits), so facet values and counts
  // must be derived from the grid's actual products via these indexes — the
  // per-collection payload's own values/counts never match what's on screen.
  // A handle appearing in two payloads carries the same data; last write wins.
  var facetRowIndex = {};        // product handle → payload map row ({price, available, f})
  var facetParamMeta = {};       // param → { label, type }
  var facetValueLabels = {};     // param → { key → label }
  var facetValueOrder = {};      // param → [keys in payload order] (stable chip ordering)
  var facetParamOrder = [];      // params in first-seen order

  // ─── Deep-link highlight ────────────────────────────
  // When a customer arrives from a product-card "build a bundle" icon
  // (?model=…&product=…), this holds the product handle to scroll to and
  // pulse once the step-1 case grid finishes rendering. Cleared on match.
  var _pendingHighlightHandle = null;

  // Monotonic token guarding step-1 grid loads. Because a deep-link can flip
  // the cord tab mid-flight (kicking off a 2nd async collection fetch while
  // the 1st is still resolving), a late-returning stale fetch could otherwise
  // overwrite the correct grid. Each loadStep1Products() call captures the
  // current token; its render callbacks bail if a newer load has started.
  var _step1LoadToken = 0;

  // When a deep-link includes ?product, we hold the first step-1 grid render
  // until preselectCaseFromDeepLink() has fetched the product and resolved its
  // real cord tab — so the customer never sees the cordless grid flash before
  // it flips to with-cord. init() shows a skeleton while this is true.
  var _deepLinkPendingCordType = false;

  // Set by a MODEL-ONLY deep-link (?model with no ?product). Consumed once the
  // step-1 grid renders, to smooth-scroll the customer to the model title +
  // case-type toggle + first cases — so they don't land stranded at the page
  // top. Mutually exclusive with _pendingHighlightHandle (product links scroll
  // to the specific card instead), so the two effects never fight.
  var _pendingScrollToGrid = false;

  // True once a collection/banner deep-link (?model=…) has been applied this
  // session. Keeps step 3's "Add a cord" tile available even on the with-cord
  // tab, because a banner arrival isn't the same deliberate all-in-one choice
  // a manual with-cord pick is. (Resets on a plain refresh, which is fine —
  // by then the customer is browsing the builder normally.)
  var _arrivedViaDeepLink = false;

  // ─── "With cord" exclusion set ─────────────────────
  // The per-model iphone-X-cord-cases collections include some products
  // that come bundled WITH a cord. Step 1 should only show bare/cord-ready
  // cases. The master `phone-cords` collection lists every bundled-with-cord
  // product; we use it as a deny-list to filter Step 1 results.
  var phoneCordsHandles = null;
  var phoneCordsLoadPromise = null;
  function loadPhoneCordsHandles() {
    if (phoneCordsHandles !== null) return Promise.resolve(phoneCordsHandles);
    if (phoneCordsLoadPromise) return phoneCordsLoadPromise;
    phoneCordsLoadPromise = fetch(lp + '/collections/phone-cords/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : { products: [] }; })
      .then(function(data) {
        var products = ((data && data.products) || [])
          .filter(function(p) { return !isBundleExcluded(p); });
        var set = {};
        products.forEach(function(p) { set[p.handle] = true; });
        // Only memoize a non-empty result. An empty/transient response would
        // otherwise stick for the whole session and silently break the
        // with-cord filter (Path B step-1) on every subsequent navigation.
        if (products.length > 0) phoneCordsHandles = set;
        phoneCordsLoadPromise = null;
        console.log('[xoxo-bundle] phone-cords exclusion set loaded:', Object.keys(set).length);
        return set;
      })
      .catch(function(err) {
        console.warn('[xoxo-bundle] could not load phone-cords exclusion set', err);
        phoneCordsLoadPromise = null;
        return {};
      });
    return phoneCordsLoadPromise;
  }

  // ─── DOM shortcuts ──────────────────────────────────
  function $(id) { return document.getElementById(id); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cdnImg(src, w) {
    try {
      var s = String(src || '');
      if (!s || (s.indexOf('cdn.shopify.com') === -1 && s.indexOf('/cdn/shop/') === -1)) return s;
      if (/[?&]width=/.test(s)) return s;
      return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 480);
    } catch (e) { return src; }
  }

  // Escape a string for safe use inside a CSS attribute selector.
  function cssEsc(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s).replace(/["\\]/g, '\\$&');
  }

  function money(cents) {
    var n = (cents / 100);
    return currency + n.toFixed(2).replace('.', lang === 'en' ? '.' : ',');
  }

  function subcatTitle(sub) {
    return sub['title_' + lang] || sub.title_en || sub.title_nl || sub.handle;
  }
  function genLabel(g) {
    // Full label including "iPhone" prefix — premium, editorial feel.
    return String(g['label_' + lang] || g.label_en || g.key);
  }

  // ─── Step 1a: generation chips + filtered models ────
  // Brand prefix convention: any gen key / model handle starting with
  // "samsung-" belongs to the samsung brand; otherwise iphone.
  function genBrand(genKey) {
    return (genKey || '').indexOf('samsung-') === 0 ? 'samsung' : 'iphone';
  }
  function modelBrand(handle) {
    return (handle || '').indexOf('samsung-') === 0 ? 'samsung' : 'iphone';
  }

  function syncBrandButtons() {
    $$('.xbb-brand-toggle__btn').forEach(function(b) {
      var match = b.dataset.brand === S.activeBrand;
      b.classList.toggle('active', match);
      b.setAttribute('aria-selected', match ? 'true' : 'false');
    });
  }

  function renderGenChips() {
    var chips = $('xbb-gen-chips');
    var gens = (stepConfig[1].generations || []).filter(function(g) {
      return genBrand(g.key) === S.activeBrand;
    });
    var models = stepConfig[1].models || [];
    var counts = {};
    models.forEach(function(m) { counts[m.gen] = (counts[m.gen] || 0) + 1; });

    // Ensure S.activeGen belongs to current brand — fall back to first gen
    if (!gens.some(function(g) { return g.key === S.activeGen; })) {
      S.activeGen = (gens[0] && gens[0].key) || S.activeGen;
    }

    chips.innerHTML = gens.map(function(g) {
      var c = counts[g.key] || 0;
      var active = g.key === S.activeGen ? ' active' : '';
      // All configured gens (iPhone + Samsung S23/S24/S25) are pre-verified
      // to have bundle products, so chips render visible immediately.
      return '<button type="button" class="xbb-gen-chip' + active + '" data-gen="' + esc(g.key) + '">' +
        '<span>' + esc(genLabel(g)) + '</span>' +
        '<span class="xbb-gen-chip__count">' + c + '</span>' +
      '</button>';
    }).join('');
  }

  // Async-cached eligibility check per model handle — used to hide models
  // that have no bundle-eligible products (e.g. older Samsung Galaxy A
  // collections that only carry normal cases). Resolves to the eligible
  // product count, cached after the first call so subsequent renders
  // reuse the result without re-fetching.
  var modelEligibilityCache = {};
  function checkModelEligibility(handle) {
    // Every model in the config (iPhone + the hardcoded Samsung S23/S24/S25
    // series) has been pre-verified to carry bundle-eligible products, so we
    // skip the runtime per-model fetch entirely. This makes Samsung paint
    // instantly — same as iPhone — instead of flashing while products.json
    // round-trips resolve. If a model ever needs runtime verification again,
    // re-introduce the fetch here.
    return modelEligibilityCache[handle] || (modelEligibilityCache[handle] = Promise.resolve(1));
  }

  // Hide model tiles that have zero bundle-eligible products. For Samsung,
  // the whole grid is held visibility:hidden by renderModels() until all
  // checks resolve — so the model tiles and the gen chips reveal together
  // (no models-appear-before-gens flash). iPhone grids are visible
  // immediately (no fetches).
  function pruneEmptyModels() {
    var grid = $('xbb-models-grid');
    if (!grid) return;
    var tiles = $$('.xbb-tile[data-model]', grid);
    var checks = tiles.map(function(tile) {
      return checkModelEligibility(tile.dataset.model).then(function(count) {
        return { tile: tile, count: count };
      });
    });
    Promise.all(checks).then(function(results) {
      results.forEach(function(r) {
        if (r.count === 0) r.tile.style.display = 'none';
      });
      // Reveal the grid once every tile's verdict is in
      grid.style.visibility = 'visible';
    });
  }

  // Samsung gen chips render with visibility:hidden so they don't flash.
  // This function resolves all model-eligibility checks for the chips on
  // screen, then in a SINGLE batch flips empties to display:none and
  // populated ones to visible. iPhone chips are unaffected (always
  // visible — assumed populated, no fetches).
  function pruneEmptyGens() {
    var allModels = stepConfig[1].models || [];
    var chips = $$('#xbb-gen-chips .xbb-gen-chip');
    var checks = chips.map(function(chip) {
      var genKey = chip.dataset.gen;
      var modelsInGen = allModels.filter(function(m) { return m.gen === genKey; });
      if (!modelsInGen.length) return Promise.resolve({ chip: chip, eligible: false });
      return Promise.all(modelsInGen.map(function(m) { return checkModelEligibility(m.handle); }))
        .then(function(counts) {
          return { chip: chip, eligible: counts.some(function(c) { return c > 0; }) };
        });
    });
    Promise.all(checks).then(function(results) {
      results.forEach(function(r) {
        if (!r.eligible) {
          r.chip.style.display = 'none';
        } else if (r.chip.style.visibility === 'hidden') {
          r.chip.style.visibility = 'visible';
        }
      });
    });
  }

  // Mobile picker mode: the 9-chip generation row is hidden and the model
  // list groups by generation with sub-headers instead — one clean scroll
  // column. Desktop keeps the chip row + flat single-generation grid.
  function isMobilePicker() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  // Model thumbnail <img> attributes. The tile is at most 72 CSS px, so a 3x
  // phone needs ~216 px; 160 alone looked soft there. srcset keeps 1x/2x
  // screens on the 160 px file they already download and only 3x screens fetch
  // 240. width/height reserve the square before the image arrives (CSS still
  // sizes it to the tile: 100% of a 48/72px box).
  // MUST STAY IDENTICAL to tileImg() in the section's #xbb-first-paint script:
  // renderModels() redraws the tiles that script painted, and differing markup
  // would swap the image URL — a visible flash and a second download.
  function modelTileImg(u) {
    var a = cdnImg(u, 160), b = cdnImg(u, 240);
    return '<img src="' + esc(a) + '"' + (a !== b ? ' srcset="' + esc(a) + ' 2x, ' + esc(b) + ' 3x"' : '') +
      ' width="160" height="160" alt="" loading="lazy" decoding="async">';
  }

  // One compact model row (thumb + name + chevron). role=option so the search
  // input can act as a proper combobox over the list.
  function modelTileHtml(m) {
    return '<button type="button" class="xbb-tile xbb-tile--compact" role="option" id="xbb-mopt-' + esc(m.handle) + '"' +
      ' aria-selected="' + ((S.model && S.model.handle === m.handle) ? 'true' : 'false') + '"' +
      ' data-model="' + esc(m.handle) + '" data-title="' + esc(m.title) + '" data-img="' + esc(m.image_url) + '">' +
      '<div class="xbb-tile__img-mini">' +
        (m.image_url ? modelTileImg(m.image_url) : '<span class="xbb-tile__img--empty">' + esc(m.title.charAt(0)) + '</span>') +
      '</div>' +
      '<div class="xbb-tile__title">' + esc(m.title) +
        '<svg class="xbb-tile__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>' +
      '</div>' +
    '</button>';
  }
  // Decorative generation sub-header (spans the grid). aria-hidden so it never
  // reads as a selectable option inside the listbox.
  function modelGroupHead(label) {
    return '<div class="xbb-models-group__head" aria-hidden="true">' + esc(label) + '</div>';
  }

  function renderModels() {
    var grid = $('xbb-models-grid');
    if (!grid) return;
    var brandModels = (stepConfig[1].models || []).filter(function(m) {
      return modelBrand(m.handle) === S.activeBrand;
    });
    var q = normModel(S.modelQuery || '');
    // Group (headers per generation) whenever there's a search OR we're on the
    // mobile picker (no chip row there); otherwise the desktop flat grid of the
    // active generation — unchanged from before.
    var grouped = !!q || isMobilePicker();
    var html = '';
    var count = 0;
    if (grouped) {
      var gens = (stepConfig[1].generations || []).filter(function(g) {
        return genBrand(g.key) === S.activeBrand;
      });
      gens.forEach(function(g) {
        var glabel = genLabel(g);
        var gq = normModel(glabel);
        var ms = brandModels.filter(function(m) {
          if (m.gen !== g.key) return false;
          if (!q) return true;
          // Match the model title OR its generation label, so "15" surfaces
          // every iPhone 15 model and "pro max" surfaces those variants.
          return normModel(m.title).indexOf(q) !== -1 || gq.indexOf(q) !== -1;
        });
        if (!ms.length) return;
        html += modelGroupHead(glabel);
        ms.forEach(function(m) { html += modelTileHtml(m); count++; });
      });
    } else {
      var flat = brandModels.filter(function(m) { return m.gen === S.activeGen; });
      flat.forEach(function(m) { html += modelTileHtml(m); count++; });
    }
    if (!count) {
      var msg = q ? t.modelNoMatch : t.empty;
      grid.innerHTML = '<div class="xbb-empty"><span class="xbb-empty__icon">∅</span><p class="xbb-empty__title">' + esc(msg) + '</p></div>';
      grid.style.visibility = 'visible';
      resetModelActiveOption();
      return;
    }
    grid.innerHTML = html;
    // All configured models are pre-verified, so the grid is visible
    // immediately for both brands — no hide-then-reveal flash.
    grid.style.visibility = 'visible';
    resetModelActiveOption();
  }

  // ── Device-search combobox ──
  // Visible model option buttons, in DOM order, for keyboard navigation.
  function visibleModelOptions() {
    var grid = $('xbb-models-grid');
    if (!grid) return [];
    return $$('.xbb-tile[data-model]', grid).filter(function(el) {
      return el.style.display !== 'none';
    });
  }
  var _modelActiveIdx = -1;
  function resetModelActiveOption() {
    _modelActiveIdx = -1;
    var input = $('xbb-model-search');
    if (input) input.removeAttribute('aria-activedescendant');
    var grid = $('xbb-models-grid');
    if (grid) $$('.xbb-opt--active', grid).forEach(function(el) { el.classList.remove('xbb-opt--active'); });
  }
  function setModelActiveOption(idx) {
    var opts = visibleModelOptions();
    if (!opts.length) { resetModelActiveOption(); return; }
    if (idx < 0) idx = opts.length - 1;
    if (idx >= opts.length) idx = 0;
    _modelActiveIdx = idx;
    opts.forEach(function(el, i) { el.classList.toggle('xbb-opt--active', i === idx); });
    var active = opts[idx];
    var input = $('xbb-model-search');
    if (input && active.id) input.setAttribute('aria-activedescendant', active.id);
    try { active.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }
  function syncModelSearchClear() {
    var clear = $('xbb-model-search-clear');
    if (clear) clear.classList.toggle('xbb-hidden', !(S.modelQuery && S.modelQuery.length));
  }
  // Gen chips are only a filter when NOT searching; deactivate them while a
  // query is live so the desktop chip row never contradicts the results.
  function syncGenChipActive() {
    var q = S.modelQuery && S.modelQuery.length;
    $$('.xbb-gen-chip', $('xbb-gen-chips') || document).forEach(function(c) {
      c.classList.toggle('active', !q && c.dataset.gen === S.activeGen);
    });
  }
  function clearModelSearch(skipRender) {
    S.modelQuery = '';
    var input = $('xbb-model-search');
    if (input) { input.value = ''; input.setAttribute('aria-expanded', 'true'); }
    syncModelSearchClear();
    if (!skipRender) { renderModels(); syncGenChipActive(); }
  }

  // Injected "add a cord" tile. Action-labelled (not "Extra…") so it reads
  // correctly whether the set already has cords or none. Only shown on the
  // cordless paths (see renderSubcats) — a with-cord case already includes
  // its cord, so offering loose cords there is contradictory.
  var EXTRA_CORDS_SUBCAT = {
    handle: 'cords',
    title_nl: 'Koord toevoegen',
    title_en: 'Add a cord',
    title_de: 'Band hinzufügen',
    title_fr: 'Ajouter un cordon',
    image_url: 'https://cdn.shopify.com/s/files/1/0571/6118/7482/collections/Cords_d175642a-e534-422c-acb7-40c9835ddfce.jpg?v=1769069600'
  };

  // Injected "add a case" tile. Loads a per-model case collection (model
  // switcher lets them pick any phone), so a single tap adds another case —
  // valuable in every path, including a "build without a case" start. Action-
  // labelled so it's correct whether the set has 0 or several cases.
  var EXTRA_CASES_SUBCAT = {
    handle: 'cases',
    title_nl: 'Hoesje toevoegen',
    title_en: 'Add a case',
    title_de: 'Hülle hinzufügen',
    title_fr: 'Ajouter une coque',
    image_url: 'https://cdn.shopify.com/s/files/1/0571/6118/7482/collections/Pearlfection-Long-17pro-promax_9cb6c030-83e4-4de5-8b51-24b984f8c68a.jpg?v=1758029559'
  };

  function renderSubcats() {
    var grid = $('xbb-subcats-grid');
    var subs = (stepConfig[3].subcollections || []).slice();
    subs.unshift(EXTRA_CORDS_SUBCAT);
    subs.unshift(EXTRA_CASES_SUBCAT);
    grid.innerHTML = subs.map(function(s) {
      return '<button type="button" class="xbb-tile" data-subcat="' + esc(s.handle) + '" data-nested="' + esc(s.nested || '') + '" role="listitem">' +
        '<div class="xbb-tile__img">' +
          (s.image_url ? '<img src="' + esc(cdnImg(s.image_url, 480)) + '" alt="" loading="lazy" decoding="async">' : '<span class="xbb-tile__img--empty">' + esc(subcatTitle(s).charAt(0)) + '</span>') +
        '</div>' +
        '<div class="xbb-tile__title">' + esc(subcatTitle(s)) + '</div>' +
      '</button>';
    }).join('');
  }

  function renderAirpodsModels() {
    var grid = $('xbb-airpods-models-grid');
    var models = (stepConfig[3].nested || {}).airpods_by_model || [];
    grid.innerHTML = models.map(function(m) {
      return '<button type="button" class="xbb-tile" data-airpods-model="' + esc(m.handle) + '" role="listitem">' +
        '<div class="xbb-tile__img">' +
          (m.image_url ? '<img src="' + esc(cdnImg(m.image_url, 480)) + '" alt="" loading="lazy" decoding="async">' : '<span class="xbb-tile__img--empty">' + esc(m.title.charAt(0)) + '</span>') +
        '</div>' +
        '<div class="xbb-tile__title">' + esc(m.title) + '</div>' +
      '</button>';
    }).join('');
  }

  // ─── Skeleton placeholder ───────────────────────────
  function skeletonHtml(n) {
    var s = '';
    for (var i = 0; i < n; i++) {
      s += '<div class="xbb-pcard"><div class="xbb-pcard__skeleton"></div><div class="xbb-pcard__body"><div style="height:13px;background:var(--x-cream-3);border-radius:3px;margin-bottom:6px"></div><div style="height:13px;width:55%;background:var(--x-cream-3);border-radius:3px"></div></div></div>';
    }
    return s;
  }

  // ─── Cordless source: a single curated Shopify collection ─────
  // "INTERN - Bundle Builder" (handle: intern-bundle-builder) lists each
  // cordless DESIGN once, with variants for every iPhone model it supports.
  // When the user picks a model, we resolve each design's matching variant.
  var INTERN_BB_HANDLE = 'intern-bundle-builder';

  // Normalize a string for fuzzy matching (lowercased, alphanumerics only)
  function normModel(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  // Map any product/variant/model string → the BEST-matching model from
  // stepConfig[1].models (the longest model title that's a substring of the
  // input wins). Solves the iPhone 17 ⊂ iPhone 17 Pro substring bug — every
  // product is now assigned to its single most-specific model and we compare
  // by handle instead of overlapping substrings.
  function findBestMatchModel(text, allModels) {
    if (!text) return null;
    var t = normModel(text);
    if (!t) return null;
    var pool = allModels || (stepConfig[1] && stepConfig[1].models) || [];
    var best = null;
    var bestLen = 0;
    for (var i = 0; i < pool.length; i++) {
      var m = pool[i];
      var target = normModel(m.title);
      if (target && t.indexOf(target) !== -1 && target.length > bestLen) {
        best = m;
        bestLen = target.length;
      }
    }
    return best;
  }

  // Find the variant of a product that corresponds to the user-selected model
  function findVariantForModel(product, modelTitle) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    if (variants.length === 1) return variants[0];

    var target = normModel(modelTitle);
    if (!target) return variants[0];

    // First pass: exact normalized match on variant title or any option value
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (normModel(v.title) === target) return v;
      if (v.option1 && normModel(v.option1) === target) return v;
      if (v.option2 && normModel(v.option2) === target) return v;
      if (v.option3 && normModel(v.option3) === target) return v;
    }
    // Second pass: best-model match. Resolves each variant title to its
    // most-specific model (e.g. "iPhone 17 Pro Max / Pink" → iPhone 17 Pro
    // Max) and compares model HANDLES so "iPhone 17" doesn't accidentally
    // match a variant for "iPhone 17 Pro" via substring.
    var allModels = (stepConfig[1] && stepConfig[1].models) || [];
    var customerModel = findBestMatchModel(modelTitle, allModels);
    if (customerModel) {
      for (var j = 0; j < variants.length; j++) {
        var vv = variants[j];
        var variantModel = findBestMatchModel(vv.title, allModels);
        if (variantModel && variantModel.handle === customerModel.handle) return vv;
      }
    }
    return null; // not available for this model
  }

  // ─── Stock availability ─────────────────────────────
  // /collections/<handle>/products.json variants carry an `available`
  // boolean (verified live on short-cords, 2026-07-16). A variant is only
  // treated as unavailable when the field is EXPLICITLY false — an absent
  // field fails OPEN so a payload shape change can never brick the builder.
  function variantAvailable(v) {
    return !(v && v.available === false);
  }
  // Product-level stock = ANY variant available. This matches the bundle-json
  // payload's row.available / f['filter.v.availability'], which carry
  // Liquid's product-level p.available — so the grid-derived facet counts
  // always sum to the grid total, unlike Shopify's own per-variant facet
  // buckets (a partly-sold-out product lands in both of those).
  function productAvailable(p) {
    var vs = (p && p.variants) || [];
    if (!vs.length) return true;
    for (var i = 0; i < vs.length; i++) {
      if (variantAvailable(vs[i])) return true;
    }
    return false;
  }

  // Convert raw intern-bundle-builder products into model-resolved tiles
  function resolveDesignsForModel(products, modelTitle) {
    return products.map(function(p) {
      var v = findVariantForModel(p, modelTitle);
      if (!v) return null;
      // Variant-specific image if present, else first product image
      var img = '';
      if (v.featured_image) {
        img = (typeof v.featured_image === 'string')
          ? v.featured_image
          : (v.featured_image.src || '');
      }
      if (!img && p.images && p.images[0]) {
        img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
      }
      // ONLY the variant's own photo, deliberately.
      //
      // A curated product's gallery is not a gallery of this case — it is one
      // packshot per phone model (WH-Mirrornocord-12, -17air, -13-14-15_mini…).
      // Showing all of them let a customer on an iPhone 12 page through photos of
      // other phones, which is exactly the bug reported for the sold-out
      // "Glossy Wavy Cord Case (Burgundy) / iPhone 17 Pro Max". Rich galleries
      // now come from the real per-model product via swapTilesToSourceProducts,
      // so keeping this to the single correct photo makes every fallback path
      // model-correct by construction.
      return {
        handle: p.handle,
        title: p.title,
        tags: p.tags,   // preserve tags so productNeedsClip() still works downstream
        variants: [v],
        images: img ? [{ src: img }] : []
      };
    }).filter(Boolean);
  }

  // ─── Entry-source attribution ────────────────────────
  // Which element / page sent the customer into the builder. Stamped onto every
  // bundle cart line as `_bundle_entry`, so the answer shows up on the ORDER in
  // Shopify admin and can be totalled against real revenue.
  //
  // Two levels of precision:
  //   • ?src=<token> on the inbound link identifies the exact ELEMENT (the nav
  //     item, the homepage banner image, its button). The referrer alone can
  //     only ever name the page, and the homepage has three separate links to
  //     the builder, so this is the only way to tell them apart.
  //   • no ?src → fall back to the referring page (collection / product / home).
  //
  // ?src=nav appears on every page, so it is combined with the referring page
  // type ("nav:product") to keep the "came from a PDP" insight.
  //
  // Cached in sessionStorage because document.referrer is only available on the
  // FIRST load: an in-builder step change or a refresh would otherwise lose it.
  var ENTRY_KEY = 'xbb_entry_v1';
  var _entrySource = null;
  function refPageType() {
    var ref = document.referrer;
    if (!ref) return 'direct';
    try {
      var u = new URL(ref, window.location.href);
      if (u.host !== window.location.host) return 'external';
      if (u.pathname === '/' || u.pathname === '') return 'home';
      var m = u.pathname.match(/\/(collections|products|pages|blogs)\/([^\/?#]+)/);
      if (!m) return 'other';
      if (m[1] === 'collections') return 'collection:' + decodeURIComponent(m[2]).toLowerCase();
      if (m[1] === 'products') return 'product:' + decodeURIComponent(m[2]).toLowerCase();
      return 'page:' + decodeURIComponent(m[2]).toLowerCase();
    } catch (e) { return 'unknown'; }
  }
  function entrySource() {
    if (_entrySource) return _entrySource;
    try {
      var stored = sessionStorage.getItem(ENTRY_KEY);
      if (stored) { _entrySource = stored; return _entrySource; }
    } catch (e) {}

    var src = '';
    try { src = (new URLSearchParams(window.location.search).get('src') || '').trim(); }
    catch (e) {}
    // Keep it short and safe for a line-item property.
    src = src.toLowerCase().replace(/[^a-z0-9:_-]/g, '').slice(0, 32);

    var page = refPageType();
    if (src) {
      // A site-wide element (the nav) tells us nothing about where they were, so
      // pair it with the page type; a page-specific element speaks for itself.
      _entrySource = (src === 'nav') ? ('nav:' + page.split(':')[0]) : src;
    } else {
      _entrySource = page;
    }

    try { sessionStorage.setItem(ENTRY_KEY, _entrySource); } catch (e) {}
    // Drop ?src from the address bar so it can't be bookmarked or shared as a
    // false attribution, and so a refresh doesn't look like a fresh entry.
    if (src) {
      try {
        var u2 = new URL(window.location.href);
        u2.searchParams.delete('src');
        history.replaceState(history.state, '', u2.pathname + (u2.search || '') + u2.hash);
      } catch (e) {}
    }
    return _entrySource;
  }

  // ─── Swap curated tiles for their real per-model products ───
  // The curated "dropdown" products (one design, a variant per phone model) exist
  // only to drive this builder. Their photos are per-model PACKSHOTS — a customer
  // on an iPhone 12 would otherwise page through shots of the 17 Air — and they
  // carry no lifestyle imagery, while the real per-model product does.
  //
  // The join is the SKU: a curated variant's SKU is the real product's SKU plus a
  // marker suffix ("-bb" = bundle builder, "-dd" = dropdown), e.g.
  //   XOXO-WAVYHOOK-BLACK-16PM-bb -> XOXO-WAVYHOOK-BLACK-16PM
  //   XOXO-GLAZE-BROWN-17PM-dd    -> XOXO-GLAZE-BROWN-17PM
  // so no per-design mapping needs maintaining in code. Verified against the live
  // catalogue: all 259 curated tiles resolve, at identical price and stock.
  //
  // The tile's DISPLAY TITLE deliberately stays the curated one, so the grid reads
  // exactly as it does today; only the gallery, handle and variant come from the
  // real product.
  var SKU_MARKER_RE = /-(bb|dd)$/i;
  function skuBase(sku) {
    return String(sku || '').trim().replace(SKU_MARKER_RE, '');
  }
  function buildSkuIndex(products) {
    var idx = {};
    (products || []).forEach(function(p) {
      (p.variants || []).forEach(function(v) {
        var k = skuBase(v && v.sku);
        if (k && !idx[k]) idx[k] = { product: p, variant: v };
      });
    });
    return idx;
  }
  // Never lets a tile disappear: anything without a live match keeps the curated
  // tile it has today, so a missing/unpublished source product is invisible to the
  // customer rather than a hole in the grid.
  function swapTilesToSourceProducts(tiles, cb) {
    if (!caseSourceHandle || !tiles || !tiles.length) { cb(tiles); return; }
    // Warm the facet payload for the SOURCE collection too. It carries the
    // metafields (rating, case type) the quick-view panel shows, keyed by the
    // real product handles the tiles are about to adopt — products.json has
    // none of them. Fire-and-forget: the panel degrades to price/stock if it
    // hasn't landed yet, and loadFacets memoises per handle.
    loadFacets(caseSourceHandle);
    fetchProductsJson(caseSourceHandle, 250, function(sourceProducts) {
      if (!sourceProducts || !sourceProducts.length) { cb(tiles); return; }
      var idx = buildSkuIndex(sourceProducts);
      var swapped = 0;
      var out = tiles.map(function(t) {
        var v0 = (t.variants || [])[0];
        if (!v0) return t;
        var hit = idx[skuBase(v0.sku)];
        if (!hit) return t;                              // no source product
        // Being sold out does NOT make the real product's photos wrong, and the
        // curated/source stock always agrees (the duplicates are kept in sync —
        // audited live: 0 disagreements in 259 tiles). An earlier
        // `available === false -> keep curated` guard therefore protected nothing
        // and actively caused a bug: sold-out tiles fell back to the curated
        // gallery, which is packshots of OTHER phone models. Only skip the swap
        // in the one case where it would take a buyable tile and make it dead.
        var curatedAlive = !(v0.available === false);
        if (hit.variant.available === false && curatedAlive) return t;
        var imgs = (hit.product.images || [])
          .map(function(i) { return typeof i === 'string' ? i : (i && i.src) || ''; })
          .filter(Boolean);
        if (!imgs.length) return t;                      // nothing gained
        swapped++;
        return {
          handle: hit.product.handle,
          title: t.title,                 // keep the curated label (grid parity)
          sourceTitle: hit.product.title, // the real product, for debugging
          tags: hit.product.tags,
          variants: [hit.variant],
          images: imgs.map(function(s) { return { src: s }; })
        };
      });
      console.log('[xoxo-bundle] tiles sourced from real products:', swapped, '/', tiles.length);
      cb(out);
    });
  }

  // ─── Design groups, derived from the real products ───
  // The curated "dropdown" products used to define WHICH designs the cordless tab
  // shows. That list can be derived instead: the real products are named
  // "<design> - <model>", so grouping on everything-before-the-model yields the
  // design set (verified live: 258 products → exactly the same 13 designs).
  // That removes the last thing the curated products were needed for, so a new
  // phone model is just "create the product, tag it" — no code, no dropdown edit.
  //
  // Models are keyed by the CONFIGURED model's handle rather than the raw title
  // segment, so naming variants converge ("iPhone 7/8 SE (2020/2022)" and
  // "iPhone 7 / 8 / SE" both land on the same phone).
  function designKeyFromTitle(title) {
    var parts = String(title || '').split(' - ');
    if (parts.length < 2) return '';
    return parts.slice(0, -1).join(' - ').trim();
  }
  function buildDesignGroups(products) {
    var groups = {};
    (products || []).forEach(function(p) {
      if (!p || !p.title) return;
      var key = designKeyFromTitle(p.title);
      if (!key) return;
      var model = matchModelByCollectionHandle(modelSlug(modelFromTitle(p.title)));
      if (!model) return;                 // a phone this builder doesn't offer
      var g = groups[key] || (groups[key] = { key: key, byModel: {} });
      if (!g.byModel[model.handle]) g.byModel[model.handle] = p;
    });
    return groups;
  }
  // Merchant-controlled display order. Anything not listed is appended
  // alphabetically, so a brand-new design appears without editing the setting.
  function designOrderList() {
    return String(caseDesignOrderRaw || '')
      .split(/[\r\n,]+/)
      .map(function(s) { return s.trim(); })
      .filter(Boolean);
  }
  // Optional "derived name = label shown to the customer" overrides, so the grid
  // can keep its existing wording even though the underlying products are named
  // differently ("Phone Cord Case (no cord) Transparant Case" → "Transparant
  // Cord Case").
  var _designLabelMap = null;
  function designLabel(key) {
    if (!_designLabelMap) {
      _designLabelMap = {};
      String(caseDesignLabelsRaw || '').split(/[\r\n]+/).forEach(function(line) {
        var i = line.indexOf('=');
        if (i < 0) return;
        var from = line.slice(0, i).trim();
        var to = line.slice(i + 1).trim();
        if (from && to) _designLabelMap[from.toLowerCase()] = to;
      });
    }
    var hit = _designLabelMap[String(key).toLowerCase()];
    if (hit) return hit;
    // No override: tidy the raw product naming rather than showing "(no cord)".
    return String(key).replace(/\s*\(no cord\)\s*/ig, ' ').replace(/\s{2,}/g, ' ').trim();
  }
  function designTilesForModel(groups) {
    if (!S.model || !S.model.handle) return [];
    var order = designOrderList();
    var rank = {};
    order.forEach(function(k, i) { rank[k.toLowerCase()] = i; });
    var keys = Object.keys(groups).sort(function(a, b) {
      var ra = rank[a.toLowerCase()], rb = rank[b.toLowerCase()];
      if (ra != null && rb != null) return ra - rb;
      if (ra != null) return -1;          // listed designs first, in order
      if (rb != null) return 1;
      return a.localeCompare(b);          // then the rest, alphabetically
    });
    var out = [];
    keys.forEach(function(k) {
      var p = groups[k].byModel[S.model.handle];
      if (!p) return;                     // this design isn't made for this phone
      var vs = (p.variants || []);
      var v = vs.filter(function(x) { return x && x.available !== false; })[0] || vs[0];
      if (!v) return;
      out.push({
        handle: p.handle,
        title: designLabel(k),            // grid wording stays merchant-controlled
        sourceTitle: p.title,
        tags: p.tags,
        variants: [v],
        images: p.images || []
      });
    });
    return out;
  }

  // ─── Tag-based product flags ─────────────────────────
  // Merchant-controlled tags drive two authoritative decisions:
  //   • `no cord` → cordless variant of a cord case (hard-exclude from
  //     "with cord" filters; positive signal for cordless classifiers).
  //   • `easy cord` → product is NOT part of the bundle builder catalog at
  //     all — exclude from every grid (filtered at loadCollection source).
  function readTags(p) {
    if (!p || !p.tags) return [];
    return Array.isArray(p.tags)
      ? p.tags
      : String(p.tags).split(',').map(function(s) { return s.trim(); });
  }
  function hasTag(p, re) {
    var tags = readTags(p);
    for (var i = 0; i < tags.length; i++) {
      if (re.test(String(tags[i]))) return true;
    }
    return false;
  }
  function hasNoCordTag(p)   { return hasTag(p, /^\s*no\s*cord\s*$/i); }
  function hasEasyCordTag(p) { return hasTag(p, /^\s*easy\s*cord\s*$/i); }
  function isBundleExcluded(p) { return hasEasyCordTag(p); }

  // A cordless case that can't attach a cord on its own — it needs a free
  // Easy Cord Clip. Detected by the merchant-set tag (default 'easy-cord-case').
  // Evaluated at card-render time (products carry tags there); the resulting
  // flag is stamped onto the selected line so later stages don't need the tag.
  var clipCaseTagRe = new RegExp('^\\s*' + clipCaseTag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$', 'i');
  function productNeedsClip(p) {
    return clipEnabled && hasTag(p, clipCaseTagRe);
  }

  // ─── "With cord" detection (Path B only) ─────────────
  // Strategy: a product is "with cord" if ANY of the following holds:
  //   1. It belongs to the master `phone-cords` collection.
  //   2. Its title matches an explicit "with cord" pattern (Long Cord,
  //      Short Cord, Easy Cord, "met koord", "with cord", etc.).
  //   3. Its title mentions "cord"/"koord" AND it is NOT explicitly marked
  //      as a cordless variant (by title or by the Bundle Builder tag).
  // BUT: a `no cord` tag overrides everything — those are cordless by
  // merchant decree, and must never leak into the "Met koord" results.
  var WITH_CORD_TITLE_RE = /(\s[-–—]\s*(Long|Short)\s+Cord\b|\bmet\s+koord\b|\bwith\s+cord\b|\bmit\s+(Band|Kordel)\b|\bavec\s+cordon\b|\(\s*with\s+cord\s*\))/i;
  function isWithCordProduct(p) {
    if (!p) return false;
    if (hasNoCordTag(p)) return false; // hard exclusion — authoritative
    if (phoneCordsHandles && phoneCordsHandles[p.handle]) return true;
    if (!p.title) return false;
    if (WITH_CORD_TITLE_RE.test(p.title)) return true;
    if (/\b(cord|koord)\b/i.test(p.title) && !NO_CORD_TITLE_RE.test(p.title) && !hasBundleBuilderTag(p)) {
      return true;
    }
    return false;
  }
  function applyWithCordFilter(products) {
    return products.filter(isWithCordProduct);
  }

  // ─── "Bundle Builder" tag detection (cord-ready cases) ──────────────
  // The intern-bundle-builder collection uses tag = "Bundle Builder" as
  // its rule. Same tag marks Samsung products as bundle-eligible (i.e.
  // cord-ready cordless cases). Products WITHOUT this tag are excluded
  // from the bundle builder (they're "normal" cases sold outside it).
  function hasBundleBuilderTag(p) {
    if (!p || !p.tags) return false;
    if (Array.isArray(p.tags)) return p.tags.indexOf('Bundle Builder') !== -1;
    // /collections/X/products.json can serialize tags either way
    return String(p.tags).split(',').map(function(s) { return s.trim(); }).indexOf('Bundle Builder') !== -1;
  }

  // ─── "No cord" title detection (cord-ready cordless via naming) ─────
  // Many cord-ready cordless cases have explicit "No Cord" / "Without Cord"
  // markers in their title (e.g. "Pearlfection Cord Case - No Cord"). Treat
  // those as bundle-eligible cordless cases without requiring a tag.
  var NO_CORD_TITLE_RE = /(\s[-–—]\s*no\s+cord\b|\bzonder\s+koord\b|\bwithout\s+cord\b|\bohne\s+(Band|Kordel)\b|\bsans\s+cordon\b|\(\s*no\s+cord\s*\)|\(\s*without\s+cord\s*\))/i;
  function isNoCordTitleProduct(p) {
    if (!p || !p.title) return false;
    return NO_CORD_TITLE_RE.test(p.title);
  }

  // Combined: bundle-eligible cord-ready cordless case?
  // Any of: explicit `no cord` tag, Bundle Builder tag, or title marker.
  // Excludes with-cord products (those go in the "Met koord" path).
  function isCordReadyCordlessProduct(p) {
    if (!p) return false;
    if (isWithCordProduct(p)) return false;
    return hasNoCordTag(p) || hasBundleBuilderTag(p) || isNoCordTitleProduct(p);
  }

  // Cord status of a case product — used to badge extras-cases products.
  // Returns 'cord' (ships with a cord), 'nocord' (cord-ready cordless), or null.
  // ─── Samsung product classifier ─────────────────────────────────
  // Samsung per-model collections mix cord cases (with built-in cord),
  // cord-ready cordless cases (sold sans cord), and normal cases all in
  // one place. The naming convention is consistent though: every Cord
  // Case-family product has "Cord Case" in its title. Whether it ships
  // with a cord is determined by a "(no cord)" marker, "Long/Short Cord"
  // suffix, or explicit Bundle Builder tag.
  //
  // Returns 'cordless' | 'withcord' | 'other' (normal/not bundle eligible).
  function classifySamsungProduct(p) {
    if (!p) return 'other';
    // Explicit cordless markers win first
    if (hasNoCordTag(p)) return 'cordless';
    if (hasBundleBuilderTag(p)) return 'cordless';
    if (isNoCordTitleProduct(p)) return 'cordless';
    // Explicit with-cord markers (Long/Short Cord, phone-cords membership)
    if (isWithCordProduct(p)) return 'withcord';
    // Fallback: any product whose title contains "Cord Case" is part of
    // the cord-case family. Default it to with-cord (cord ships included)
    // since cordless variants always carry an explicit no-cord marker.
    if (p.title && /\bcord\s+case\b/i.test(p.title)) return 'withcord';
    // Otherwise it's a normal case — not surfaced in the bundle builder.
    return 'other';
  }

  // ─── Cord-type classifier for the deep-link path ────────────────────
  // Given a product (from /products/<handle>.js OR a collection product),
  // returns 'with' | 'without' | null (null = excluded / not bundle-eligible).
  // Reuses the authoritative helpers above so it can never drift from the
  // grid's own filtering. phone-cords membership is an optional booster
  // (works correctly on tags+title alone when that set isn't loaded yet).
  // Cordless markers are checked FIRST so an explicit "no cord" always wins.
  function detectCordType(p) {
    if (!p) return null;
    if (hasEasyCordTag(p)) return null;                 // hard-excluded from builder
    if (hasNoCordTag(p)) return 'without';              // authoritative cordless tag
    if (hasBundleBuilderTag(p)) return 'without';       // cord-ready cordless
    if (isNoCordTitleProduct(p)) return 'without';      // "(no cord)" title marker
    if (isWithCordProduct(p)) return 'with';            // Long/Short cord, met koord, phone-cords…
    if (p.title && /\bcord\s+case\b/i.test(p.title)) return 'with'; // cord-case family default
    return null;                                        // normal case — not in the builder
  }

  // ─── Color matching (cord recommendations) ────────────────────
  // Group color words into families so e.g. Burgundy ↔ Red, Taupe ↔ Nude,
  // Transparant ↔ Clear are treated as matches. Detects from any text:
  // product title, handle, tags. Words checked are lowercased substrings —
  // works across NL/EN/DE/FR titles since these brand color names are
  // typically the same in every locale.
  var COLOR_FAMILIES = {
    red: ['red', 'burgundy', 'maroon', 'cherry', 'wine', 'crimson', 'rood', 'bordeaux'],
    pink: ['pink', 'rose', 'blush', 'fuchsia', 'roze', 'pinkrose'],
    brown: ['brown', 'taupe', 'tan', 'beige', 'nude', 'chocolate', 'bruin', 'cognac'],
    green: ['green', 'olive', 'emerald', 'mint', 'sage', 'groen'],
    blue: ['blue', 'navy', 'cobalt', 'sky', 'blauw'],
    purple: ['purple', 'violet', 'lavender', 'lilac', 'plum', 'paars', 'lavendel'],
    yellow: ['yellow', 'gold', 'mustard', 'amber', 'geel', 'goud'],
    black: ['black', 'noir', 'onyx', 'zwart'],
    white: ['white', 'cream', 'ivory', 'wit'],
    silver: ['silver', 'grey', 'gray', 'zilver', 'grijs'],
    clear: ['transparant', 'transparent', 'clear', 'crystal']
  };
  function detectColorFamilies(text) {
    var found = {};
    var lower = String(text || '').toLowerCase();
    Object.keys(COLOR_FAMILIES).forEach(function(fam) {
      var syns = COLOR_FAMILIES[fam];
      for (var i = 0; i < syns.length; i++) {
        if (lower.indexOf(syns[i]) !== -1) { found[fam] = true; break; }
      }
    });
    return Object.keys(found);
  }
  function productText(p) {
    if (!p) return '';
    var t = (p.title || '') + ' ' + (p.handle || '');
    if (p.tags) {
      t += ' ' + (Array.isArray(p.tags) ? p.tags.join(' ') : p.tags);
    }
    return t;
  }
  // Transparent + mirror cases are neutral by design — they go with
  // everything, so the "Matcht jouw hoesje" recommendation badge would
  // light up on every cord and become noise rather than signal. Exclude
  // these from the colour-matching source so the badge only appears when
  // there's a meaningful colour to match against.
  function isUniversalCase(p) {
    if (!p || !p.title) return false;
    return /(transparant|transparent|clear|mirror|spiegel|miroir)/i.test(p.title);
  }
  function caseColorFamilies() {
    // Aggregate detected colours across EVERY selected case so cord/extras
    // colour-matching works for multi-case bundles (a Burgundy + a Black
    // case → both burgundy and black cords get a "matches" tag).
    var pool = (S.cases && S.cases.length)
      ? S.cases
      : (S.case ? [S.case] : []);
    pool = pool.filter(function(c) { return !isUniversalCase(c); });
    if (!pool.length) return [];
    var seen = {};
    var out = [];
    pool.forEach(function(c) {
      detectColorFamilies(productText(c)).forEach(function(fam) {
        if (!seen[fam]) { seen[fam] = true; out.push(fam); }
      });
    });
    return out;
  }
  function productMatchesCaseColor(p) {
    var caseColors = caseColorFamilies();
    if (!caseColors.length) return false;
    var prodColors = detectColorFamilies(productText(p));
    for (var i = 0; i < caseColors.length; i++) {
      if (prodColors.indexOf(caseColors[i]) !== -1) return true;
    }
    return false;
  }

  // Best-seller cord designs that should always lead the cord/extras grid
  // (highest sell-through, ample stock, universally matchable). Even when a
  // case colour gets recommended, these stay at the very top.
  var TOP_CORD_TITLE_RE = /(pearlfection|dreamy)/i;
  function isTopCord(p) {
    return !!(p && p.title && TOP_CORD_TITLE_RE.test(p.title));
  }

  // Generic helper: tag products with _recommended where they match the case
  // color family, and sort matches to the top of the list. No-op when there's
  // no case selected or no color detected. Pass-through for any product grid:
  // cords, extra cords, AirPods cases, charms, stickers — anywhere coloured
  // items are surfaced.
  function withColorMatching(products) {
    if (!products || !products.length) return products || [];
    var caseColors = caseColorFamilies();
    var copy = products.slice();
    copy.forEach(function(p) {
      if (p) p._recommended = caseColors.length ? productMatchesCaseColor(p) : false;
    });
    // Sort priority: colour-matched first, then best-sellers (Pearlfection/Dreamy),
    // then everything else. Stable within each band.
    copy.sort(function(a, b) {
      var ta = isTopCord(a) ? 1 : 0;
      var tb = isTopCord(b) ? 1 : 0;
      var ra = a && a._recommended ? 2 : 0;
      var rb = b && b._recommended ? 2 : 0;
      return (tb + rb) - (ta + ra);
    });
    return copy;
  }

  // ─── Color swatch filter (large coloured grids: cords, extras) ──────
  // Reuses the COLOR_FAMILIES engine so there's no second taxonomy to keep
  // in sync. Only surfaces when a grid is big enough to be worth filtering.
  var COLOR_FILTER_THRESHOLD = 24;
  var COLOR_FAMILY_ORDER = ['pink','red','purple','blue','green','yellow','brown','black','white','silver','clear'];
  function colorFamilyLabel(fam) {
    var L = {
      red:    { nl:'Rood',  en:'Red',    de:'Rot',     fr:'Rouge'  },
      pink:   { nl:'Roze',  en:'Pink',   de:'Rosa',    fr:'Rose'   },
      brown:  { nl:'Bruin', en:'Brown',  de:'Braun',   fr:'Brun'   },
      green:  { nl:'Groen', en:'Green',  de:'Grün',    fr:'Vert'   },
      blue:   { nl:'Blauw', en:'Blue',   de:'Blau',    fr:'Bleu'   },
      purple: { nl:'Paars', en:'Purple', de:'Lila',    fr:'Violet' },
      yellow: { nl:'Geel',  en:'Yellow', de:'Gelb',    fr:'Jaune'  },
      black:  { nl:'Zwart', en:'Black',  de:'Schwarz', fr:'Noir'   },
      white:  { nl:'Wit',   en:'White',  de:'Weiß',    fr:'Blanc'  },
      silver: { nl:'Grijs', en:'Grey',   de:'Grau',    fr:'Gris'   },
      clear:  { nl:'Transparant', en:'Clear', de:'Transparent', fr:'Transparent' }
    };
    var row = L[fam];
    if (!row) return fam;
    return row[lang] || row.nl;
  }
  function colorFilterAllLabel() {
    return (lang === 'de') ? 'Alle' : (lang === 'en') ? 'All' : (lang === 'fr') ? 'Tous' : 'Alle';
  }
  // The untouched list for a grid, narrowed to the active filters.
  // Two filter systems can narrow a grid; both are applied, in order:
  //   1. facetState  — real Shopify facets (Kleur / Product Type / Lengte /
  //      MagSafe / voorraad) from the bundle-json view. Preferred when the
  //      collection's facet data has loaded.
  //   2. colorFilterState — the legacy keyword-guessed colour chips. Still the
  //      fallback for grids whose facet fetch failed or hasn't landed yet.
  // Only one of the two is ever surfaced in the UI at a time (see renderGrid),
  // so in practice these don't stack — but applying both is harmless and keeps
  // the function correct whichever one is live.
  function getFilteredBase(gridId) {
    var base = originalProductLists[gridId] || [];

    // 1. Real facets — AND across different filters, OR within one filter.
    // Rows come from facetRowIndex (merged across EVERY fetched payload), not
    // from one collection's payload: grids often show a subset or a merge of
    // collections. The keyword-colour pseudo-param has no rows at all — it
    // filters on detected colour families from titles/tags instead.
    var fstate = facetState[gridId];
    if (fstate) {
      Object.keys(fstate).forEach(function(param) {
        var want = fstate[param];
        if (!want || !want.length) return;
        if (param === KW_COLOR_PARAM) {
          base = base.filter(function(p) {
            var fams = detectColorFamilies(productText(p));
            for (var i = 0; i < want.length; i++) {
              if (fams.indexOf(want[i]) !== -1) return true;
            }
            return false;
          });
          return;
        }
        base = base.filter(function(p) {
          var row = facetRowIndex[p.handle];
          var have = (row && row.f && row.f[param]) || [];
          for (var i = 0; i < want.length; i++) {
            // Compare as strings on both sides. Metaobject ids come back from
            // Liquid as bare numbers while facet keys are strings, and
            // '227875946837' === 227875946837 is false — that mismatch silently
            // matches zero products. The view template already casts, but this
            // keeps filtering correct against an older/other template too.
            if (have.map(String).indexOf(String(want[i])) !== -1) return true;
          }
          return false;
        });
      });
    }

    // 1b. Price range (min/max in cents, either side optional). Read from the
    // merged row index so it uses the same price Shopify facets on, not the
    // variant price the card happens to display.
    var pr = priceState[gridId];
    if (pr && (pr.min != null || pr.max != null)) {
      base = base.filter(function(p) {
        var row = facetRowIndex[p.handle];
        var cents = row && row.price;
        if (typeof cents !== 'number' || !isFinite(cents)) return false;
        if (pr.min != null && cents < pr.min) return false;
        if (pr.max != null && cents > pr.max) return false;
        return true;
      });
    }

    // 2. Legacy colour chips.
    var fam = colorFilterState[gridId];
    if (!fam) return base;
    return base.filter(function(p) {
      return detectColorFamilies(productText(p)).indexOf(fam) !== -1;
    });
  }
  // Walk back from a grid to find a sibling by class (controls / color filter
  // may not be the immediate previous element once both are present).
  function findSiblingByClass(targetEl, cls) {
    var prev = targetEl ? targetEl.previousElementSibling : null;
    while (prev) {
      if (prev.classList && prev.classList.contains(cls)) return prev;
      prev = prev.previousElementSibling;
    }
    return null;
  }
  // Find (or lazily create) the chip row. It is positioned ABOVE the
  // sort/density controls bar (Sorteer / Weergave) on desktop and mobile.
  // Outer = positioned wrapper (anchors the scroll-hint fade); inner track
  // is the horizontally scrollable flex row the chips live in.
  function ensureColorFilterEl(targetEl) {
    var el = findSiblingByClass(targetEl, 'xbb-color-filter');
    if (!el) {
      el = document.createElement('div');
      el.className = 'xbb-color-filter xbb-hidden';
      el.setAttribute('role', 'group');
      el.setAttribute('aria-label', 'Color filter');
      var anchor = findSiblingByClass(targetEl, 'xbb-grid-controls') || targetEl;
      anchor.parentNode.insertBefore(el, anchor);
    }
    if (!el.querySelector('.xbb-color-filter__track')) {
      var track = document.createElement('div');
      track.className = 'xbb-color-filter__track';
      el.appendChild(track);
    }
    // Real, tappable "scroll next" button replacing the decorative chevron —
    // customers expect to click the arrow to advance through colours, not
    // swipe. Without this they tap and land on whichever chip sits beneath
    // the arrow (usually white).
    if (!el.querySelector('.xbb-color-filter__next')) {
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'xbb-color-filter__next';
      nextBtn.setAttribute('aria-label', 'Show more colours');
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>';
      el.appendChild(nextBtn);
    }
    return el;
  }
  // Show the right-edge fade only while the track actually overflows AND
  // hasn't been scrolled to the end — so the hint is honest, not decorative.
  function refreshScrollHint(el) {
    var track = el.querySelector('.xbb-color-filter__track');
    if (!track) return;
    var overflowing = track.scrollWidth - track.clientWidth > 4;
    el.classList.toggle('xbb-color-filter--scroll', overflowing);
    if (!overflowing) { el.classList.remove('xbb-color-filter--end'); return; }
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    el.classList.toggle('xbb-color-filter--end', atEnd);
  }
  // Re-evaluate the scroll hint when the viewport changes (e.g. phone rotate).
  window.addEventListener('resize', function() {
    $$('.xbb-color-filter:not(.xbb-hidden)').forEach(refreshScrollHint);
  }, { passive: true });
  // Build the chip row from the colours actually present in this product set.
  function buildColorFilter(targetEl, gridId, products) {
    var el = ensureColorFilterEl(targetEl);
    var track = el.querySelector('.xbb-color-filter__track');
    var present = {};
    (products || []).forEach(function(p) {
      detectColorFamilies(productText(p)).forEach(function(f) { present[f] = (present[f] || 0) + 1; });
    });
    var fams = COLOR_FAMILY_ORDER.filter(function(f) { return present[f]; });
    // Keep small or single-colour grids clean — no filter row at all.
    if (!products || products.length < COLOR_FILTER_THRESHOLD || fams.length < 2) {
      el.classList.add('xbb-hidden');
      el.classList.remove('xbb-color-filter--scroll', 'xbb-color-filter--end');
      track.innerHTML = '';
      return;
    }
    var active = colorFilterState[gridId] || null;
    var html = '<button type="button" class="xbb-cfilter__chip xbb-cfilter__chip--all' + (active ? '' : ' active') +
      '" data-cfilter="" data-grid="' + gridId + '">' +
      '<span class="xbb-cfilter__name">' + esc(colorFilterAllLabel()) + '</span></button>';
    fams.forEach(function(f) {
      html += '<button type="button" class="xbb-cfilter__chip' + (active === f ? ' active' : '') +
        '" data-cfilter="' + f + '" data-grid="' + gridId + '" aria-label="' + esc(colorFamilyLabel(f)) + '">' +
        '<span class="xbb-cfilter__dot xbb-cfilter__dot--' + f + '"></span>' +
        '<span class="xbb-cfilter__name">' + esc(colorFamilyLabel(f)) + '</span></button>';
    });
    track.innerHTML = html;
    el.classList.remove('xbb-hidden');
    if (!el.dataset.bound) {
      el.dataset.bound = '1';
      el.addEventListener('click', function(e) {
        var btn = e.target.closest('.xbb-cfilter__chip');
        if (!btn) return;
        var g = btn.dataset.grid;
        var fam = btn.dataset.cfilter || null;
        colorFilterState[g] = fam;
        $$('.xbb-cfilter__chip', track).forEach(function(b) {
          b.classList.toggle('active', (b.dataset.cfilter || null) === fam);
        });
        applyGridSort(g); // re-render from the (now filtered) base, keeping sort + pagination
      });
      track.addEventListener('scroll', function() { refreshScrollHint(el); }, { passive: true });
    }
    // Recompute the scroll hint once layout has settled.
    requestAnimationFrame(function() { refreshScrollHint(el); });
  }

  // ─── Real Shopify facets (Kleur / Product Type / Lengte / MagSafe) ──────
  // Source: /collections/<handle>?view=bundle-json (templates/collection.bundle-json.liquid).
  // products.json carries no metafields, and every custom facet on the XOXO
  // collection pages is metafield-backed — so the facet data has to come from
  // a Liquid-rendered endpoint. That endpoint returns Shopify's OWN
  // `collection.filters`, which means the facet set matches the real collection
  // page exactly and prunes itself per collection (silicone-bags genuinely has
  // no MagSafe / no Product Type). There is no relevance table to maintain.

  // Swatch per colour metaobject id. Keyed by ID, not label, so it survives
  // NL/EN/DE/FR — the label from Shopify is already localised. Unknown ids
  // simply render as a text chip with no dot, so a new colour never breaks
  // filtering; it just shows up without a swatch until added here.
  var COLOR_SWATCH = {
    '227877716309': '#d9c6a5',                                  // Beige
    '227875389781': '#3b6fb6',                                  // Blauw
    '227877454165': '#7b4b2a',                                  // Bruin
    '379509604693': '#53181f',                                  // Burgundy
    '225590247765': '#f2c230',                                  // Geel
    '227879420245': 'linear-gradient(135deg,#e6c56a,#a8801f)',  // Goud
    '227875488085': '#3e7a4e',                                  // Groen
    '227430695253': 'linear-gradient(135deg,#d8a45c,#8a5a1f)',  // Luipaard
    '227876503893': '#7b4ba8',                                  // Paars
    '227878404437': 'linear-gradient(90deg,#e35d5d,#f2c230,#3e7a4e,#3b6fb6,#7b4ba8)', // Regenboog
    '227875520853': '#c1272d',                                  // Rood
    '227875946837': '#e77fa3',                                  // Roze
    '227878764885': 'linear-gradient(135deg,#f2f2f2,#b8b8b8,#f2f2f2)', // Spiegel
    '227879059797': 'linear-gradient(135deg,#ffffff 45%,#dfe6ea 55%)', // Transparant
    '227878207829': '#ffffff',                                  // Wit
    '227879518549': '#c0c0c0',                                  // Zilver
    '227875651925': '#1a1a1a'                                   // Zwart
  };

  function clearFiltersLabel() {
    return (lang === 'de') ? 'Filter löschen'
         : (lang === 'en') ? 'Clear filters'
         : (lang === 'fr') ? 'Effacer les filtres'
         : 'Wis filters';
  }
  function filterToggleLabel() {
    return (lang === 'fr') ? 'Filtres' : 'Filter';
  }
  function closeSheetLabel() {
    return (lang === 'de') ? 'Schließen'
         : (lang === 'en') ? 'Close'
         : (lang === 'fr') ? 'Fermer'
         : 'Sluiten';
  }
  function showResultsLabel(n) {
    if (lang === 'de') return n === 1 ? '1 Produkt anzeigen' : n + ' Produkte anzeigen';
    if (lang === 'en') return n === 1 ? 'Show 1 product' : 'Show ' + n + ' products';
    if (lang === 'fr') return n === 1 ? 'Afficher 1 produit' : 'Afficher ' + n + ' produits';
    return n === 1 ? 'Toon 1 product' : 'Toon ' + n + ' producten';
  }
  function noFilterMatchLabel() {
    return (lang === 'de') ? 'Keine Produkte für diese Filter.'
         : (lang === 'en') ? 'No products match these filters.'
         : (lang === 'fr') ? 'Aucun produit pour ces filtres.'
         : 'Geen producten voor deze filters.';
  }

  // Merge one payload into the module-level facet indexes. Called for every
  // successfully fetched payload, so facetRowIndex ends up covering every
  // product any grid can show, regardless of which collection it came from.
  function mergeFacetPayload(data) {
    (data.filters || []).forEach(function(f) {
      if (!facetParamMeta[f.param]) facetParamOrder.push(f.param);
      facetParamMeta[f.param] = { label: f.label, type: f.type };
      if (f.type === 'price_range') return;
      var lbls = facetValueLabels[f.param] || (facetValueLabels[f.param] = {});
      var ord = facetValueOrder[f.param] || (facetValueOrder[f.param] = []);
      (f.values || []).forEach(function(v) {
        var k = String(v.key);
        if (!(k in lbls)) ord.push(k);
        lbls[k] = v.label;
      });
    });
    var map = data.map || {};
    Object.keys(map).forEach(function(h) { facetRowIndex[h] = map[h]; });
    // A quick view that is already open for one of these products gets its
    // videos / translated images NOW, not on the next open. The facet payload is
    // fetched in parallel with products.json and can land seconds later; a
    // shopper who taps the eye icon straight away would otherwise see photos only.
    if (qvActiveCard && qvActiveCard.dataset && !qvActiveCard.dataset.qvMedia) {
      var openH = qvActiveCard.dataset.productHandle || '';
      var r0 = map[openH];
      if (r0 && ((r0.md && r0.md.length) || (r0.li && r0.li.length))) refreshQuickViewGallery();
    }
  }

  // Fetch + memoise the facet payload for a collection. Resolves to null on any
  // failure — filters are a progressive enhancement, so a miss must degrade to
  // "no facet bar" and never block or break the product grid.
  // A second caller while the first is still in flight JOINS it (startup pre-load,
  // then the real grid a second later): one request, never two.
  var facetInflight = {};
  function loadFacets(handle) {
    if (!handle) return Promise.resolve(null);
    if (facetCache[handle]) return Promise.resolve(facetCache[handle]);
    if (facetInflight[handle]) return facetInflight[handle];
    var p = loadFacetsNow(handle);
    facetInflight[handle] = p;
    var clear = function() { delete facetInflight[handle]; };
    p.then(clear, clear);
    return p;
  }
  function loadFacetsNow(handle) {
    var url = lp + '/collections/' + encodeURIComponent(handle) + '?view=bundle-json';
    return fetch(url, { cache: 'no-cache' })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function(txt) {
        // The view renders through Liquid, so it is served as text/html even
        // though the body is JSON — parse it by hand rather than r.json().
        var data = JSON.parse(txt.trim());
        // Same cache-poisoning guard as productCache: only memoise a payload
        // that actually carries filters, so a transient bad response doesn't
        // disable filtering for the rest of the session.
        if (data && data.filters && data.filters.length) {
          facetCache[handle] = data;
          mergeFacetPayload(data);
          // The view paginates at 250, like products.json. Walk the remaining
          // pages so every product in a big collection gets its row (quick-view
          // facts, videos, translated images) — bundle-easy-cord-cases has 294
          // products, so its last 44 had no row at all. Filters are collection-
          // level and identical on every page; only the map is merged.
          var pages = parseInt(data.pages, 10) || 1;
          for (var pg = 2; pg <= Math.min(pages, 8); pg++) {
            (function(n) {
              fetch(url + '&page=' + n, { cache: 'no-cache' })
                .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
                .then(function(t2) {
                  var d2 = JSON.parse(t2.trim());
                  if (!d2 || !d2.map) return;
                  Object.keys(d2.map).forEach(function(h) { data.map[h] = d2.map[h]; });
                  mergeFacetPayload({ filters: [], map: d2.map });
                })
                .catch(function(e) { console.warn('[xoxo-bundle] facet page', n, 'failed for', handle, e); });
            })(pg);
          }
        }
        return data;
      })
      .catch(function(err) {
        console.warn('[xoxo-bundle] facet load failed for', handle, err);
        return null;
      });
  }

  // THE RELEVANCE RULE.
  // Show a facet only where it actually narrows the set:
  //   - at least 2 selectable values, OR a single value that doesn't match
  //     every product (a real toggle, e.g. MagSafe on 6 of 30 stick-on items);
  //   - drop a single value that matches everything (MagSafe inside
  //     magsafe-accessoires is 19/19 — it filters nothing);
  //   - drop empty facets entirely.
  // This replaces a hand-maintained per-step allowlist and keeps working as the
  // catalogue changes, because the counts come from Shopify on every fetch.
  function usefulFilters(facets) {
    if (!facets || !facets.filters) return [];
    var total = facets.products_count || 0;
    return facets.filters.filter(function(f) {
      // Price is a range, not a value list — handled by priceFilterMeta below.
      if (f.type === 'price_range') return false;
      var vals = (f.values || []).filter(function(v) { return v.count > 0; });
      if (!vals.length) return false;
      if (vals.length === 1) return total > 0 && vals[0].count < total;
      return true;
    });
  }

  // ── Grid-derived facets ──
  // Everything the bar shows is computed from the grid's ACTUAL products
  // (originalProductLists) walked through the merged facetRowIndex — never
  // from a single payload's values/counts, which describe the whole
  // collection rather than the (often subset/merged) grid on screen.

  // The pseudo-param for the keyword-colour fallback (no payload rows — it
  // filters via detectColorFamilies over titles/tags, the legacy chip engine).
  var KW_COLOR_PARAM = '_kw_color';
  // The real metafield-backed colour facet.
  var COLOR_META_PARAM = 'filter.p.m.custom.product_color_metaobject';
  // Coverage guard: a metafield-backed facet whose data exists on fewer than
  // half of the grid's products is misleading (e.g. a colour filter over 2/13
  // tagged cases would hide 11 untagged cases that have real colours) — hide
  // it and let the keyword-colour fallback take over where applicable.
  var FACET_COVERAGE_MIN = 0.5;
  // Per-grid facet exclusions. Step 2's own Kort/Lang/Alles tabs ARE the
  // length choice, so the Lengte facet is redundant noise there. It stays on
  // step 1 (cord cases include a cord) and step 3 (extra cords).
  var FACET_EXCLUDE = {
    'xbb-step-2-products': { 'filter.p.m.custom.length': 1 }
  };

  // Colour facets need a minimum grid size to be worth a row: on a handful of
  // products a colour filter is noise. Originally 24 (the legacy chip-row
  // threshold), lowered to 8 on 2026-07-20: the curated cordless-case grids
  // run ~13 products with genuinely useful colour data (live check: keyword
  // detection recovers 8 families over 11/13 intern-bundle-builder cases —
  // the titles carry the colours), and 24 was suppressing that filter on the
  // "Extra hoesjes" and step-1 case grids. Applies to the step-1 gate (real +
  // keyword) and the keyword pseudo-facet on every grid; the real metafield
  // facet on other grids stays ungated as before.
  var COLOR_FACET_MIN = 8;
  function colorFacetAllowed(gridId, total) {
    if (gridId === 'xbb-step-1-products' && total < COLOR_FACET_MIN) return false;
    return true;
  }

  function kwColorLabel() {
    return (lang === 'de') ? 'Farbe'
         : (lang === 'en') ? 'Colour'
         : (lang === 'fr') ? 'Couleur'
         : 'Kleur';
  }

  // Has any facet payload covering this grid landed yet? Gates the keyword
  // fallback so the pre-fetch and fetch-failed states still degrade to the
  // legacy chip row exactly as before.
  function gridHasFacetData(gridId) {
    var list = originalProductLists[gridId] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && facetRowIndex[list[i].handle]) return true;
    }
    return false;
  }

  // Build the value-list facet groups for a grid: values = keys actually
  // present among the grid's products, counts = grid-accurate. Applies the
  // per-grid exclusions and the metafield coverage guard, then feeds the
  // result through usefulFilters so the narrowing rule semantics (>=2 values,
  // or 1 value that doesn't match everything) stay exactly as they were.
  function gridFacetGroups(gridId) {
    var list = originalProductLists[gridId] || [];
    var total = list.length;
    if (!total) return [];
    var excl = FACET_EXCLUDE[gridId] || {};
    var entries = [];
    facetParamOrder.forEach(function(param) {
      var meta = facetParamMeta[param];
      if (!meta || meta.type === 'price_range') return;
      if (excl[param]) return;
      if (param === COLOR_META_PARAM && !colorFacetAllowed(gridId, total)) return;
      var counts = {};
      var covered = 0;
      list.forEach(function(p) {
        var row = p && facetRowIndex[p.handle];
        var have = (row && row.f && row.f[param]) || [];
        if (have.length) covered++;
        have.forEach(function(k) {
          k = String(k);
          counts[k] = (counts[k] || 0) + 1;
        });
      });
      if (param.indexOf('filter.p.m.') === 0 && covered < total * FACET_COVERAGE_MIN) return;
      // Keep the payload's value ordering (matches the collection pages);
      // append any stray keys the payloads never listed.
      var keys = (facetValueOrder[param] || []).filter(function(k) { return counts[k]; });
      Object.keys(counts).forEach(function(k) { if (keys.indexOf(k) === -1) keys.push(k); });
      if (!keys.length) return;
      var lbls = facetValueLabels[param] || {};
      entries.push({
        label: meta.label,
        param: param,
        type: 'list',
        values: keys.map(function(k) {
          return { label: lbls[k] != null ? lbls[k] : k, key: k, count: counts[k] };
        })
      });
    });
    return usefulFilters({ filters: entries, products_count: total });
  }

  // Keyword-colour fallback group: when the REAL colour facet is hidden
  // (coverage guard) or absent, offer the colour families detected in the
  // grid's titles/tags as a pseudo-facet in the SAME UI. Same engine the
  // legacy chips use, so no new taxonomy — and grid-accurate by construction.
  function kwColorGroup(gridId) {
    var list = originalProductLists[gridId] || [];
    // Keyword colours are guessed from titles/tags — needs a minimum grid
    // size to be signal rather than noise (see COLOR_FACET_MIN), and step 1's
    // colour gate applies here too.
    if (list.length < COLOR_FACET_MIN) return null;
    if (!colorFacetAllowed(gridId, list.length)) return null;
    var counts = {};
    list.forEach(function(p) {
      detectColorFamilies(productText(p)).forEach(function(f) {
        counts[f] = (counts[f] || 0) + 1;
      });
    });
    var fams = COLOR_FAMILY_ORDER.filter(function(f) { return counts[f]; });
    if (fams.length < 2) return null;
    return {
      param: KW_COLOR_PARAM,
      label: kwColorLabel(),
      kw: true,
      values: fams.map(function(f) {
        return { label: colorFamilyLabel(f), key: f, count: counts[f] };
      })
    };
  }

  // Price bounds from the grid's own rows. NOT from the Liquid filter object:
  // `min_value`/`max_value` are the ACTIVE selection (verified live — they
  // come back 0 when nothing is filtered). Prices are in cents throughout
  // (Liquid's p.price). Hidden when every product costs the same (min==max).
  function gridPriceMeta(gridId) {
    var pricePar = null;
    facetParamOrder.forEach(function(param) {
      var m = facetParamMeta[param];
      if (m && m.type === 'price_range' && !pricePar) pricePar = { param: param, label: m.label };
    });
    if (!pricePar) return null;
    var list = originalProductLists[gridId] || [];
    var vals = [];
    list.forEach(function(p) {
      var row = p && facetRowIndex[p.handle];
      var n = row && row.price;
      if (typeof n === 'number' && isFinite(n)) vals.push(n);
    });
    if (vals.length < 2) return null;
    var lo = Math.min.apply(null, vals);
    var hi = Math.max.apply(null, vals);
    if (!(hi > lo)) return null;
    return { label: pricePar.label, param: pricePar.param, min: lo, max: hi };
  }

  // cents -> plain major-unit number for the inputs (no symbol, no separators,
  // so the value stays valid for <input type="number"> in every locale).
  function centsToInput(c) {
    if (c == null || !isFinite(c)) return '';
    return String(Math.round(c) / 100);
  }
  function inputToCents(v) {
    var s = String(v == null ? '' : v).trim().replace(',', '.');
    if (!s) return null;
    var n = parseFloat(s);
    if (!isFinite(n) || n < 0) return null;
    return Math.round(n * 100);
  }

  // Collapse the legacy colour chip row (used when real facets take over, and
  // on grids that opt out of filtering altogether).
  function hideLegacyColorChips(targetEl) {
    var cf = findSiblingByClass(targetEl, 'xbb-color-filter');
    if (!cf) return;
    cf.classList.add('xbb-hidden');
    cf.classList.remove('xbb-color-filter--scroll', 'xbb-color-filter--end');
    var track = cf.querySelector('.xbb-color-filter__track');
    if (track) track.innerHTML = '';
  }

  // Locate a grid's facet bar. It normally lives INSIDE the grid-controls row
  // (first flex child, so triggers sit left of the sort/density toggles on one
  // line); older markup had it as a sibling above the controls, so fall back
  // to the sibling scan for safety.
  function findFacetEl(targetEl) {
    var controls = findSiblingByClass(targetEl, 'xbb-grid-controls');
    if (controls) {
      var inEl = controls.querySelector('.xbb-facets');
      if (inEl) return inEl;
    }
    return findSiblingByClass(targetEl, 'xbb-facets');
  }

  // The grid whose facet sheet is currently open (mobile bottom sheet), if any.
  var _openFacetSheetEl = null;


  function hideFacetBar(targetEl) {
    var fb = findFacetEl(targetEl);
    if (!fb) return;
    if (_openFacetSheetEl === fb) closeFacetSheet(fb);
    // Safety: never leave an orphaned sheet host on <body> after a teardown.
    if (fb._xbbPanels && fb._xbbPanels.parentNode === document.body) {
      document.body.removeChild(fb._xbbPanels);
    }
    fb._xbbPanels = null;
    fb._xbbOpenPanel = null;
    fb.classList.add('xbb-hidden');
    fb.classList.remove('is-pending');
    fb.innerHTML = '';
  }

  // Muted, inert stand-in for the filter bar while the facet payload is still
  // loading: the same pill (mobile) / a single trigger (desktop) the real bar
  // will draw, so nothing shifts when it lands.
  function renderFacetPlaceholder(targetEl) {
    var el = ensureFacetBarEl(targetEl);
    if (!el) return;
    el.classList.remove('xbb-hidden');
    el.classList.add('is-pending');
    el.innerHTML = '<div class="xbb-facets__bar">' +
      '<button type="button" class="xbb-facets__toggle" disabled aria-disabled="true">' +
        '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
        '<line x1="4" y1="7" x2="20" y2="7"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="17" x2="14" y2="17"/></svg>' +
        '<span>' + esc(filterToggleLabel()) + '</span></button>' +
      '<button type="button" class="xbb-facet__trigger" disabled aria-disabled="true"><span class="xbb-facet__tname">' + esc(filterToggleLabel()) + '</span></button>' +
    '</div>';
  }
  function ensureFacetBarEl(targetEl) {
    var el = findFacetEl(targetEl);
    if (!el) {
      el = document.createElement('div');
      el.className = 'xbb-facets xbb-hidden';
      el.setAttribute('role', 'group');
      el.setAttribute('aria-label', 'Filters');
      var controls = findSiblingByClass(targetEl, 'xbb-grid-controls');
      if (controls) {
        controls.insertBefore(el, controls.firstChild);
      } else {
        targetEl.parentNode.insertBefore(el, targetEl);
      }
    }
    return el;
  }

  // Does this grid have ANY narrowing applied (facets, price or legacy colour)?
  function gridHasActiveFilters(gridId) {
    var st = facetState[gridId] || {};
    var any = Object.keys(st).some(function(k) { return (st[k] || []).length; });
    var ps = priceState[gridId] || {};
    return any || ps.min != null || ps.max != null || !!colorFilterState[gridId];
  }

  // Reflect the current filter state onto an already-rendered bar WITHOUT
  // rebuilding any DOM. This is what keeps the desktop popover open across
  // multi-select taps and keeps focus in the price inputs while typing —
  // buildFacetBar itself only runs on (re)load, never on a chip toggle.
  function syncFacetBarUI(el, gridId) {
    if (!el) return;
    var state = facetState[gridId] || {};
    var ps = priceState[gridId] || {};
    var host = el._xbbPanels;
    var total = 0;
    Object.keys(state).forEach(function(k) { total += (state[k] || []).length; });
    var priceOn = ps.min != null || ps.max != null;
    if (priceOn) total += 1;

    // Value chips — in the bar (solo toggles) and in the panels. The panels
    // host may be detached to <body> while the mobile sheet is open, so query
    // it separately when it isn't a descendant of the bar.
    var chips = $$('.xbb-facet__chip', el);
    if (host && !el.contains(host)) chips = chips.concat($$('.xbb-facet__chip', host));
    chips.forEach(function(c) {
      var on = (state[c.dataset.param] || []).indexOf(c.dataset.key) !== -1;
      c.classList.toggle('active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Dropdown triggers: badge with the selected-count per facet.
    $$('.xbb-facet__trigger', el).forEach(function(tr) {
      var n = tr.dataset.price ? (priceOn ? 1 : 0) : (state[tr.dataset.panel] || []).length;
      var badge = tr.querySelector('.xbb-facet__tbadge');
      if (badge) {
        badge.textContent = String(n);
        badge.classList.toggle('xbb-hidden', !n);
      }
      tr.classList.toggle('has-active', n > 0);
    });

    // Mobile "Filter" pill badge: total active values across all facets.
    var mb = el.querySelector('.xbb-facets__badge');
    if (mb) {
      mb.textContent = String(total);
      mb.classList.toggle('xbb-hidden', !total);
    }


    // Clear affordance + live result count on the sheet's apply button.
    var cl = el.querySelector('.xbb-facet__clear');
    if (cl) cl.classList.toggle('xbb-hidden', !total);
    if (host) {
      var cl2 = host.querySelector('.xbb-facets__clearall');
      if (cl2) cl2.disabled = !total;
      var ap = host.querySelector('.xbb-facets__apply');
      if (ap) ap.textContent = showResultsLabel(getFilteredBase(gridId).length);
    }
  }

  // Toggle one facet value on/off, then re-render the grid. The bar itself is
  // only synced in place (see syncFacetBarUI) so open popovers stay open.
  function toggleFacetValue(el, gridId, chip) {
    var param = chip.dataset.param;
    var key = chip.dataset.key;
    var st = facetState[gridId] || (facetState[gridId] = {});
    var cur = st[param] || [];
    var at = cur.indexOf(key);
    if (at === -1) cur.push(key); else cur.splice(at, 1);
    st[param] = cur;
    syncFacetBarUI(el, gridId);
    applyGridSort(gridId);
  }

  // Reset every filter on a grid — facets, price AND the legacy colour chip —
  // and bring the bar + grid back in sync. Shared by the bar's clear button,
  // the sheet footer and the filtered-empty-state CTA.
  function clearGridFilters(gridId, elOpt) {
    facetState[gridId] = {};
    priceState[gridId] = {};
    colorFilterState[gridId] = null;
    var target = $(gridId);
    var el = elOpt || (target ? findFacetEl(target) : null);
    if (el && el._xbbPanels) {
      $$('.xbb-facet__num', el._xbbPanels).forEach(function(inp) { inp.value = ''; });
    }
    if (el) syncFacetBarUI(el, gridId);
    if (target) {
      var cf = findSiblingByClass(target, 'xbb-color-filter');
      if (cf) {
        $$('.xbb-cfilter__chip', cf).forEach(function(b) {
          b.classList.toggle('active', !b.dataset.cfilter);
        });
      }
    }
    applyGridSort(gridId);
  }

  // ── Desktop popovers ──
  function closeFacetPanels(el) {
    if (!el) return;
    var host = el._xbbPanels;
    if (host) {
      $$('.xbb-facet__panel.open', host).forEach(function(p) { p.classList.remove('open'); });
    }
    $$('.xbb-facet__trigger', el).forEach(function(tr) {
      tr.classList.remove('open');
      tr.setAttribute('aria-expanded', 'false');
    });
    el._xbbOpenPanel = null;
  }

  function toggleFacetPanel(el, trig) {
    var host = el._xbbPanels;
    if (!host) return;
    var param = trig.dataset.panel;
    var panel = null;
    $$('.xbb-facet__panel', host).forEach(function(p) {
      if (p.dataset.param === param) panel = p;
    });
    if (!panel) return;
    if (panel.classList.contains('open')) {
      closeFacetPanels(el);
      return;
    }
    closeFacetPanels(el);
    panel.classList.add('open');
    trig.classList.add('open');
    trig.setAttribute('aria-expanded', 'true');
    el._xbbOpenPanel = param;
    // Anchor under the trigger, clamped so the panel never spills past the
    // bar's right edge. Inline top too — the pill row can wrap to two lines,
    // so a fixed top:100% would hang the panel off the wrong row.
    var left = trig.offsetLeft;
    var max = el.clientWidth - panel.offsetWidth;
    if (max < 0) max = 0;
    if (left > max) left = max;
    panel.style.left = left + 'px';
    panel.style.top = (trig.offsetTop + trig.offsetHeight + 6) + 'px';
  }

  // ── Mobile bottom sheet ──
  // The panels host is MOVED to <body> while open: ancestors of the grid can
  // carry transforms (step-in animation) which would trap position:fixed and
  // anchor the sheet to the step instead of the viewport — same reason the
  // quick-view modal re-parents itself to <body>.
  function openFacetSheet(el, gridId) {
    var host = el._xbbPanels;
    if (!host) return;
    closeFacetPanels(el);
    if (_openFacetSheetEl && _openFacetSheetEl !== el) closeFacetSheet(_openFacetSheetEl);
    if (host.parentNode !== document.body) document.body.appendChild(host);
    host.classList.add('xbb-facets__panels--open');
    // Reflow so the slide-in transition starts from the off-screen position.
    void host.offsetHeight;
    host.classList.add('xbb-facets__panels--in');
    host.setAttribute('role', 'dialog');
    host.setAttribute('aria-modal', 'true');
    host.setAttribute('aria-label', filterToggleLabel());
    document.body.style.overflow = 'hidden';
    var tog = el.querySelector('.xbb-facets__toggle');
    if (tog) tog.setAttribute('aria-expanded', 'true');
    _openFacetSheetEl = el;
    syncFacetBarUI(el, gridId);
    var sheet = host.querySelector('.xbb-facets__sheet');
    if (sheet) { try { sheet.focus(); } catch (e) {} }
  }

  function closeFacetSheet(el) {
    var host = el && el._xbbPanels;
    if (!host) { _openFacetSheetEl = null; return; }
    host.classList.remove('xbb-facets__panels--in');
    host.classList.remove('xbb-facets__panels--open');
    host.removeAttribute('role');
    host.removeAttribute('aria-modal');
    host.removeAttribute('aria-label');
    if (host.parentNode && host.parentNode !== el) el.appendChild(host);
    document.body.style.overflow = '';
    var tog = el.querySelector('.xbb-facets__toggle');
    if (tog) {
      tog.setAttribute('aria-expanded', 'false');
      if (_openFacetSheetEl === el) { try { tog.focus(); } catch (e) {} }
    }
    _openFacetSheetEl = null;
  }

  // Render the facet bar for a grid. Multi-select within a filter, AND across
  // filters — same semantics as the collection pages. Presentation (2026-07
  // redesign, burga/nomad reference): ONE row of pill triggers that open small
  // popover panels on desktop; on mobile a single "Filter" pill with an
  // active-count badge opens a bottom sheet with every facet. Facets with a
  // single narrowing value ("MagSafe", "Op voorraad") skip the popover and
  // render as direct toggle pills in the bar on both breakpoints.
  function buildFacetBar(targetEl, gridId) {
    var el = ensureFacetBarEl(targetEl);
    el.classList.remove('is-pending');
    // Tear down any live sheet/popover state before re-rendering.
    if (_openFacetSheetEl === el) closeFacetSheet(el);
    if (el._xbbPanels && el._xbbPanels.parentNode === document.body) {
      document.body.removeChild(el._xbbPanels);
    }
    el._xbbPanels = null;
    el._xbbOpenPanel = null;

    // Values, counts and price bounds all derive from the grid's actual
    // products (subset/merge-accurate), not from any one collection payload.
    var groups = gridFacetGroups(gridId);
    var price = gridPriceMeta(gridId);
    // Keyword-colour fallback INSIDE the bar: only when the real colour facet
    // didn't survive (coverage guard or absent) AND facet data has landed for
    // this grid — pre-fetch/failed states keep the legacy chip row fallback.
    var hasRealColor = groups.some(function(g) { return g.param === COLOR_META_PARAM; });
    if (!hasRealColor && gridHasFacetData(gridId)) {
      var kwGroup = kwColorGroup(gridId);
      if (kwGroup) groups.unshift(kwGroup);
    }
    if (!groups.length && !price) {
      el.classList.add('xbb-hidden');
      el.innerHTML = '';
        return false;
    }
    var state = facetState[gridId] || (facetState[gridId] = {});
    var pstate = priceState[gridId] || (priceState[gridId] = {});

    var chevSvg = '<svg class="xbb-facet__chev" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
    var multi = [];
    var solo = [];
    groups.forEach(function(f) {
      var vals = (f.values || []).filter(function(v) { return v.count > 0; });
      if (vals.length === 1) solo.push({ f: f, v: vals[0] });
      else multi.push({ f: f, vals: vals });
    });

    function chipHtml(f, v, extraClass) {
      var on = (state[f.param] || []).indexOf(v.key) !== -1;
      var h = '<button type="button" class="xbb-facet__chip' + (extraClass || '') + (on ? ' active' : '') +
        '" data-param="' + esc(f.param) + '" data-key="' + esc(v.key) + '"' +
        ' aria-pressed="' + (on ? 'true' : 'false') + '">';
      if (f.kw) {
        // Keyword-colour family — swatch colours come from the legacy chip
        // CSS classes so there is a single source for the family palette.
        h += '<span class="xbb-facet__dot xbb-cfilter__dot--' + esc(v.key) + '"></span>';
      } else {
        var sw = COLOR_SWATCH[v.key];
        if (sw) h += '<span class="xbb-facet__dot" style="background:' + esc(sw) + '"></span>';
      }
      h += '<span class="xbb-facet__name">' + esc(v.label) + '</span>';
      h += '<span class="xbb-facet__count">' + v.count + '</span>';
      h += '</button>';
      return h;
    }

    // ── The bar: mobile toggle, dropdown triggers, solo toggles, clear ──
    var bar = '<div class="xbb-facets__bar">';
    bar += '<button type="button" class="xbb-facets__toggle" aria-expanded="false" aria-haspopup="dialog">' +
      '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
      '<line x1="4" y1="7" x2="20" y2="7"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="17" x2="14" y2="17"/></svg>' +
      '<span>' + esc(filterToggleLabel()) + '</span>' +
      '<span class="xbb-facets__badge xbb-hidden" aria-hidden="true"></span>' +
      '</button>';
    var panelIdx = 0;
    multi.forEach(function(g) {
      var pid = gridId + '-fpanel-' + panelIdx;
      panelIdx += 1;
      g.pid = pid;
      bar += '<button type="button" class="xbb-facet__trigger" data-panel="' + esc(g.f.param) + '"' +
        ' aria-expanded="false" aria-haspopup="true" aria-controls="' + esc(pid) + '">' +
        '<span class="xbb-facet__tname">' + esc(g.f.label) + '</span>' +
        '<span class="xbb-facet__tbadge xbb-hidden" aria-hidden="true"></span>' +
        chevSvg + '</button>';
    });
    var pricePid = gridId + '-fpanel-price';
    if (price) {
      bar += '<button type="button" class="xbb-facet__trigger" data-panel="' + esc(price.param) + '" data-price="1"' +
        ' aria-expanded="false" aria-haspopup="true" aria-controls="' + esc(pricePid) + '">' +
        '<span class="xbb-facet__tname">' + esc(price.label) + '</span>' +
        '<span class="xbb-facet__tbadge xbb-hidden" aria-hidden="true"></span>' +
        chevSvg + '</button>';
    }
    solo.forEach(function(s) {
      bar += chipHtml(s.f, s.v, ' xbb-facet__chip--solo');
    });
    // Always rendered, toggled by class — price typing updates it in place.
    bar += '<button type="button" class="xbb-facet__clear xbb-hidden" data-grid="' + esc(gridId) + '">' +
      esc(clearFiltersLabel()) + '</button>';
    bar += '</div>';

    // ── The panels host: popovers on desktop, bottom sheet on mobile ──
    var panels = '<div class="xbb-facets__panels">';
    panels += '<div class="xbb-facets__backdrop"></div>';
    panels += '<div class="xbb-facets__sheet" tabindex="-1">';
    panels += '<div class="xbb-facets__sheethead">' +
      '<span class="xbb-facets__sheettitle">' + esc(filterToggleLabel()) + '</span>' +
      '<button type="button" class="xbb-facets__sheetclose" aria-label="' + esc(closeSheetLabel()) + '">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
      '</button></div>';
    multi.forEach(function(g) {
      panels += '<div class="xbb-facet__panel" id="' + esc(g.pid) + '" data-param="' + esc(g.f.param) + '">';
      panels += '<p class="xbb-facet__ptitle">' + esc(g.f.label) + '</p>';
      panels += '<div class="xbb-facet__chips">';
      g.vals.forEach(function(v) { panels += chipHtml(g.f, v, ''); });
      panels += '</div></div>';
    });
    // Single-value facets also get a group in the sheet: on mobile the solo
    // bar pills are hidden (they crowded the row next to the Filter pill) and
    // this is where they live instead. On desktop these panels never show —
    // there's no trigger for them, and the bar pill remains the control.
    // Same data-param/data-key markup, so state sync and the host's click
    // delegation cover both copies for free.
    solo.forEach(function(s) {
      panels += '<div class="xbb-facet__panel xbb-facet__panel--solo" data-param="' + esc(s.f.param) + '">';
      panels += '<p class="xbb-facet__ptitle">' + esc(s.f.label) + '</p>';
      panels += '<div class="xbb-facet__chips">' + chipHtml(s.f, s.v, '') + '</div></div>';
    });
    if (price) {
      panels += '<div class="xbb-facet__panel xbb-facet__panel--price" id="' + esc(pricePid) + '" data-param="' + esc(price.param) + '">';
      panels += '<p class="xbb-facet__ptitle">' + esc(price.label) + '</p>';
      panels += '<div class="xbb-facet__price">';
      panels += '<span class="xbb-facet__cur">' + esc(currency) + '</span>';
      panels += '<input type="number" class="xbb-facet__num" data-bound="min" inputmode="decimal"' +
        ' min="0" step="1" placeholder="' + esc(centsToInput(price.min)) + '"' +
        ' value="' + esc(centsToInput(pstate.min)) + '"' +
        ' aria-label="' + esc(price.label) + ' min">';
      panels += '<span class="xbb-facet__dash">&ndash;</span>';
      panels += '<span class="xbb-facet__cur">' + esc(currency) + '</span>';
      panels += '<input type="number" class="xbb-facet__num" data-bound="max" inputmode="decimal"' +
        ' min="0" step="1" placeholder="' + esc(centsToInput(price.max)) + '"' +
        ' value="' + esc(centsToInput(pstate.max)) + '"' +
        ' aria-label="' + esc(price.label) + ' max">';
      panels += '</div></div>';
    }
    panels += '<div class="xbb-facets__sheetfoot">' +
      '<button type="button" class="xbb-facets__clearall">' + esc(clearFiltersLabel()) + '</button>' +
      '<button type="button" class="xbb-facets__apply">' + esc(showResultsLabel(getFilteredBase(gridId).length)) + '</button>' +
      '</div>';
    panels += '</div></div>';

    el.innerHTML = bar + panels;
    el.classList.remove('xbb-hidden');
    el._xbbPanels = el.querySelector('.xbb-facets__panels');
    syncFacetBarUI(el, gridId);

    // Bar-level delegation: bound ONCE (the bar element persists across
    // re-renders). Anything inside the panels host is handled by the host's
    // own listeners below — it must keep working while detached to <body>.
    if (!el.dataset.bound) {
      el.dataset.bound = '1';
      el.addEventListener('click', function(e) {
        if (e.target.closest('.xbb-facets__panels')) return;
        var clear = e.target.closest('.xbb-facet__clear');
        if (clear) { clearGridFilters(gridId, el); return; }
        var tog = e.target.closest('.xbb-facets__toggle');
        if (tog) { openFacetSheet(el, gridId); return; }
        var trig = e.target.closest('.xbb-facet__trigger');
        if (trig) { toggleFacetPanel(el, trig); return; }
        var chip = e.target.closest('.xbb-facet__chip');
        if (chip) toggleFacetValue(el, gridId, chip);
      });
    }

    // Host-level listeners: bound on EVERY render — the host node is recreated
    // by the innerHTML above, so these can't live behind the bind-once flag.
    var host = el._xbbPanels;
    host.addEventListener('click', function(e) {
      if (e.target.closest('.xbb-facets__sheetclose') ||
          e.target.closest('.xbb-facets__backdrop') ||
          e.target.closest('.xbb-facets__apply')) {
        closeFacetSheet(el);
        return;
      }
      if (e.target.closest('.xbb-facets__clearall')) { clearGridFilters(gridId, el); return; }
      var chip = e.target.closest('.xbb-facet__chip');
      if (chip) toggleFacetValue(el, gridId, chip);
    });
    // Price: update state + re-filter WITHOUT rebuilding anything, so the
    // field keeps focus while typing. Debounced so each keystroke doesn't
    // re-render the whole grid.
    var priceTimer = null;
    host.addEventListener('input', function(e) {
      var inp = e.target.closest('.xbb-facet__num');
      if (!inp) return;
      var bound = inp.dataset.bound;
      var ps = priceState[gridId] || (priceState[gridId] = {});
      ps[bound] = inputToCents(inp.value);
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function() {
        applyGridSort(gridId);
        syncFacetBarUI(el, gridId);
      }, 250);
    });
    return true;
  }

  // Global facet-bar behaviors, bound once at load:
  // - click outside an open popover closes it
  // - Escape closes popovers and the mobile sheet
  // - a WIDTH resize (breakpoint flip) closes everything; height-only resizes
  //   are ignored so the iOS keyboard opening over a price input doesn't
  //   slam the sheet shut mid-typing
  // - the filtered-empty-state's "clear filters" CTA (rendered inside the
  //   grid, which is re-innerHTML'd constantly, hence delegated here)
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var emptyClear = e.target.closest('.xbb-empty__clear');
    if (emptyClear) {
      clearGridFilters(emptyClear.dataset.grid || '', null);
      return;
    }
    $$('.xbb-facets').forEach(function(bar) {
      if (!bar._xbbOpenPanel) return;
      if (bar.contains(e.target)) return;
      closeFacetPanels(bar);
    });
  });
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    $$('.xbb-facets').forEach(function(bar) {
      if (bar._xbbOpenPanel) closeFacetPanels(bar);
    });
    if (_openFacetSheetEl) closeFacetSheet(_openFacetSheetEl);
  });
  var _facetLastVw = window.innerWidth;
  window.addEventListener('resize', function() {
    if (window.innerWidth === _facetLastVw) return;
    _facetLastVw = window.innerWidth;
    $$('.xbb-facets').forEach(function(bar) {
      if (bar._xbbOpenPanel) closeFacetPanels(bar);
    });
    if (_openFacetSheetEl) closeFacetSheet(_openFacetSheetEl);
  }, { passive: true });

  // Show/hide the case-type toggle buttons based on what's actually
  // available for this model. If only one type exists, hide the toggle
  // entirely and force caseType to the available one.
  function updateCaseTypeAvailability(canWith, canWithout) {
    var caseTypeEl = document.querySelector('.xbb-case-type');
    var withBtn = document.querySelector('.xbb-case-type__btn[data-case-type="with"]');
    var withoutBtn = document.querySelector('.xbb-case-type__btn[data-case-type="without"]');
    if (!caseTypeEl || !withBtn || !withoutBtn) return;
    if (withBtn) withBtn.style.display = canWith ? '' : 'none';
    if (withoutBtn) withoutBtn.style.display = canWithout ? '' : 'none';
    // Hide the whole toggle when only one type is available
    caseTypeEl.style.display = (canWith && canWithout) ? '' : 'none';
  }

  // ─── Fetch collection ──────────────────────────────
  function loadCollection(handle, targetEl, onLoad, opts) {
    opts = opts || {};
    var limit = opts.limit || 250;

    // Stamp the handle so renderGrid / getFilteredBase can resolve this grid's
    // facet payload, and start the facet fetch in PARALLEL with products.json —
    // filters are an enhancement and must never delay the product grid.
    if (targetEl) {
      targetEl.dataset.collectionHandle = handle;
      loadFacets(handle).then(function(fx) {
        // The grid may have moved on to a different collection while we waited.
        if (targetEl.dataset.collectionHandle !== handle) return;
        var gid = targetEl.id;
        if (!gid || !wantsFilters[gid]) return;
        if (!originalProductLists[gid] || !originalProductLists[gid].length) return;
        gridHandle[gid] = handle;
        // The facet fetch has now settled (either way). renderGrid suppressed
        // BOTH filter rows while it was pending — this callback owns the decision:
        //   • real facet bar available → show it;
        //   • otherwise → fall back to the legacy keyword-colour chips.
        // Either way the customer sees exactly one filter row, once, with no flash.
        if (buildFacetBar(targetEl, gid)) {
          hideLegacyColorChips(targetEl);
          if (colorFilterState[gid]) {
            colorFilterState[gid] = null;
            applyGridSort(gid);
          }
        } else {
          buildColorFilter(targetEl, gid, originalProductLists[gid]);
          hideFacetBar(targetEl);
        }
        // The payload also carries popularity + ratings: reorder a grid the
        // shopper hasn't touched yet, and put the stars on cards already drawn.
        resortIfUntouched(gid);
        patchCardRatings();
      });
    }

    var deliver = function(products) {
      if (opts.withCordOnly) {
        // Path B (with cord): use OR-combined filter
        return loadPhoneCordsHandles().then(function() {
          var before = products.length;
          var filtered = applyWithCordFilter(products);
          console.log('[xoxo-bundle] with-cord filter:', filtered.length, '/', before, 'kept from', handle);
          onLoad(filtered);
        });
      }
      onLoad(products);
    };
    // First draw waits for this collection's popularity scores (capped), so the
    // grid is born sorted. No grid or scores already cached: draw straight away.
    var deliverRaw = deliver;
    deliver = function(products) {
      if (!targetEl || facetCache[handle]) { deliverRaw(products); return; }
      whenReadyOrAfter([loadFacets(handle)], RANK_WAIT_MS, function() { deliverRaw(products); });
    };

    if (productCache[handle]) {
      deliver(productCache[handle]);
      return;
    }
    targetEl.innerHTML = skeletonHtml(6);
    // The startup pre-load (prewarmStep1) may already be fetching this collection
    // through fetchProductsJson, which walks every page and applies the same
    // isBundleExcluded filter. Join it instead of starting a second walk. Only for
    // paginated callers, because the pre-load returns ALL pages; if it came back
    // empty, fall through to our own fetch with its retries and error message.
    if (opts.paginate && productInflight[handle]) {
      productInflight[handle].push(function(list) {
        if (list && list.length) deliver(list); else attempt(1);
      });
      return;
    }
    // opts.paginate walks past the 250-per-page cap. Opt-in on purpose: every
    // other caller relies on the single-page behaviour it has always had, and
    // silently widening those grids is not this function's job to decide.
    var collected = [];
    var page = 1;
    function pageUrl(n) {
      return lp + '/collections/' + encodeURIComponent(handle) +
             '/products.json?limit=' + limit + (opts.paginate ? '&page=' + n : '');
    }
    // Retry-on-failure: transient Shopify CDN or network blips are a common
    // cause of the "Er ging iets mis" toast. We try up to 3 times with a
    // short exponential backoff before surfacing an error to the user.
    function attempt(tries) {
      fetchT(pageUrl(page), { headers: { 'Accept': 'application/json' }, cache: 'no-cache' }, 20000)
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(data) {
          var batch = (data && data.products) || [];
          collected = collected.concat(batch);
          // Another full page probably means more to come.
          if (opts.paginate && batch.length >= limit && page < 8) {
            page++;
            attempt(1);
            return;
          }
          var products = collected;
          // Hard-exclude any merchant-blocked products (e.g. `easy cord`
          // tagged items) at the source so they never enter any grid,
          // any cache, or any classifier downstream.
          products = products.filter(function(p) { return !isBundleExcluded(p); });
          // Only memoize NON-empty responses. A transient 200-with-empty-body
          // (Shopify CDN refresh, briefly-unpublished collection, etc.) used to
          // poison productCache permanently for the session — every subsequent
          // tab click hit the empty cache and rendered "no products found".
          // Leaving empties unmemoized lets the next call retry the network.
          if (products.length > 0) productCache[handle] = products;
          deliver(products);
        })
        .catch(function(err) {
          console.warn('[xoxo-bundle] load attempt ' + tries + ' failed', handle, err);
          if (tries < 3) {
            setTimeout(function() { attempt(tries + 1); }, 400 * tries);
          } else {
            console.error('[xoxo-bundle] load failed after retries', handle, err);
            targetEl.innerHTML = '<div class="xbb-empty"><span class="xbb-empty__icon">!</span><p class="xbb-empty__title">' + esc(t.loadError) + '</p></div>';
          }
        });
    }
    attempt(1);
  }

  // ─── Product card ───────────────────────────────────
  // The variant a click on this card would add: auto-matched to any device
  // currently in the bundle (case variant title + product title + selected
  // phone model — so screen protectors / lens products with model variants
  // land on the right one), falling back to the first variant. Shared by
  // productCard (ribbon, price) and sortProducts (sold-out cards sink by the
  // SAME signal the ribbon shows, so the two can never disagree).
  function resolveCardVariant(p) {
    var v = (p.variants && p.variants[0]) || {};
    if ((p.variants || []).length > 1) {
      var activeDeviceStrings = [];
      if (S.case) {
        if (S.case.variantTitle) activeDeviceStrings.push(S.case.variantTitle);
        if (S.case.title) activeDeviceStrings.push(S.case.title);
      }
      if (S.cases && S.cases.length > 0) {
        S.cases.forEach(function(c) {
          if (c.variantTitle) activeDeviceStrings.push(c.variantTitle);
          if (c.title) activeDeviceStrings.push(c.title);
        });
      }
      if (S.model && S.model.title) activeDeviceStrings.push(S.model.title);

      for (var i = 0; i < activeDeviceStrings.length; i++) {
        var matched = findVariantForModel(p, activeDeviceStrings[i]);
        if (matched) return matched;
      }
    }
    return v;
  }

  function productCard(p) {
    var hasMultiVariants = (p.variants || []).length > 1;
    var v = resolveCardVariant(p);

    // Stock state of the RESOLVED variant (the one a click would add).
    var vAvail = variantAvailable(v);

    var img = '';
    if (v.featured_image) {
      img = (typeof v.featured_image === 'string') ? v.featured_image : (v.featured_image.src || '');
    }
    if (!img && p.images && p.images[0]) {
      img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
    }

    // Always store prices as integer cents so float math (19.99 * 100 = 1998.999…)
    // never causes off-by-a-cent drift versus Shopify's checkout totals.
    var price = v.price ? Math.round(parseFloat(v.price) * 100) : 0;
    var compareAt = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;

    // Stash the description for the quick-view panel. Kept in a JS map rather
    // than a data-attribute: body_html runs to ~1.5KB per product and putting
    // that on every card would bloat the grid markup for no benefit.
    if (p.handle && p.body_html) descByHandle[p.handle] = p.body_html;

    // Collect every photo URL for the quick-view gallery
    var allImgs = (p.images || [])
      .map(function(i) { return typeof i === 'string' ? i : (i && i.src) || ''; })
      .filter(Boolean);
    var imagesAttr = '[]';
    try { imagesAttr = esc(JSON.stringify(allImgs)); } catch (e) { imagesAttr = '[]'; }

    var priceHtml = '<span class="xbb-pcard__price">' + money(price) + '</span>';
    if (compareAt > price) {
      priceHtml += '<span class="xbb-pcard__price--compare">' + money(compareAt) + '</span>';
    } else if (hasMultiVariants) {
      priceHtml = '<span class="xbb-pcard__price--from">' + esc(t.from) + '</span>' + priceHtml;
    }

    // Determine selection state + qty across all step lists
    var qty = 0;
    S.cases.forEach(function(c) { if (c.handle === p.handle) qty += c.qty || 1; });
    S.cords.forEach(function(c) { if (c.handle === p.handle) qty += c.qty; });
    S.accessories.forEach(function(a) { if (a.handle === p.handle) qty += a.qty; });
    var selectedClass = qty > 0 ? ' selected' : '';
    var qtyAttr = qty > 0 ? ' data-qty="' + qty + '"' : '';

    var variantSelector = '';
    if (hasMultiVariants) {
      // onclick stopPropagation keeps the select tap from toggling the card;
      // change events MUST bubble though — the delegated document listener
      // syncs the card's stock state when the variant changes.
      variantSelector = '<div class="xbb-pcard__variants"><select data-product="' + esc(p.handle) + '" onclick="event.stopPropagation()">' +
        (p.variants || []).map(function(vv) {
          var isSelected = (vv.id === v.id) ? ' selected' : '';
          // Sold-out variants stay listed (so the range reads complete) but
          // can't be chosen; an in-stock sibling keeps the card buyable.
          var vvAvail = variantAvailable(vv);
          return '<option value="' + esc(vv.id) + '" data-price="' + esc(vv.price || 0) + '" data-variant-title="' + esc(vv.title || '') + '"' +
            ' data-available="' + (vvAvail ? '1' : '0') + '"' + (vvAvail ? '' : ' disabled') + isSelected + '>' +
            esc(vv.title || '') + ' · ' + money(parseFloat(vv.price || 0) * 100) +
            (vvAvail ? '' : ' · ' + esc(t.soldOut)) + '</option>';
        }).join('') +
      '</select></div>';
    }

    // Eye-icon trigger — only render when there's at least one image.
    // Inline size on SVG + button as a defense if the snippet CSS doesn't apply.
    // No inline stopPropagation here — the delegated click handler catches
    // [data-quickview] BEFORE the product-card click handler and returns.
    var quickViewBtn = allImgs.length
      ? '<button type="button" class="xbb-pcard__quickview" data-quickview aria-label="View photos" style="position:absolute;top:8px;left:8px;z-index:4;width:32px;height:32px;border-radius:50%;background:rgba(255,253,251,0.94);border:1px solid rgba(83,24,31,0.18);display:grid;place-items:center;color:#53181f;cursor:pointer;padding:0;box-shadow:0 2px 6px rgba(83,24,31,0.12);">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;"><circle cx="12" cy="12" r="3"/><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/></svg>' +
        '</button>'
      : '';

    // "Matches your case" badge — only when productMatchesCaseColor flagged
    // this product as a smart recommendation (e.g. matching cord color).
    var recoBadge = '';
    if (vAvail && p && p._recommended) {
      var recoLabel = (lang === 'de') ? 'Passt zu deiner Hülle'
        : (lang === 'en') ? 'Matches your case'
        : (lang === 'fr') ? 'Assorti à votre coque'
        : 'Matcht je hoesje';
      recoBadge = '<span class="xbb-pcard__match" aria-hidden="true">' + esc(recoLabel) + '</span>';
    }

    // Sold-out ribbon (replaces the match badge). The card stays in the grid
    // — never silently hidden; the "Op voorraad" facet is the customer's way
    // to hide it — but reads clearly dead and refuses the add (see the stock
    // guard in handleProductClick).
    var oosBadge = vAvail ? '' : '<span class="xbb-pcard__oos">' + esc(t.soldOut) + '</span>';

    // PDP preselect: the case the customer arrived on wears a persistent
    // "Geselecteerd" ribbon so — pinned to the top of the grid — it's obvious
    // which one was brought along.
    var isPinned = !!(_pinnedCaseHandle && p.handle === _pinnedCaseHandle);
    var pinnedBadge = isPinned
      ? '<span class="xbb-pcard__pinned" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          esc((lang === 'de') ? 'Ausgewählt' : (lang === 'fr') ? 'Sélectionnée' : (lang === 'en') ? 'Selected' : 'Geselecteerd') +
        '</span>'
      : '';

    var pcardClass = 'xbb-pcard' + selectedClass +
      (isPinned ? ' xbb-pcard--pinned' : '') +
      (vAvail && p && p._recommended ? ' xbb-pcard--match' : '') +
      (vAvail ? '' : ' xbb-pcard--oos');
    return '<div class="' + pcardClass + '" role="button" tabindex="0"' + qtyAttr +
      (vAvail ? '' : ' aria-disabled="true"') +
      ' data-variant-available="' + (vAvail ? '1' : '0') + '"' +
      ' data-product-handle="' + esc(p.handle) + '"' +
      ' data-variant-id="' + esc(v.id || '') + '"' +
      ' data-variant-title="' + esc(v.title || '') + '"' +
      ' data-product-title="' + esc(p.title) + '"' +
      ' data-product-img="' + esc(img) + '"' +
      ' data-product-price="' + esc(price) + '"' +
      (productNeedsClip(p) ? ' data-needs-clip="1"' : '') +
      ' data-images="' + imagesAttr + '">' +
      '<div class="xbb-pcard__check" aria-hidden="true">' +
        '<svg class="xbb-icon-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="6" x2="12" y2="18"></line><line x1="6" y1="12" x2="18" y2="12"></line></svg>' +
        '<svg class="xbb-icon-heart" viewBox="0 0 24 24"><path d="M12 21s-7-4.5-9-9c-1.5-3.5.5-7 4-7 2 0 3.5 1 5 3 1.5-2 3-3 5-3 3.5 0 5.5 3.5 4 7-2 4.5-9 9-9 9z"/></svg>' +
      '</div>' +
      '<div class="xbb-pcard__qty-badge">' + (qty > 1 ? qty : '') + '</div>' +
      '<div class="xbb-pcard__img" style="position:relative;">' +
        (img ? '<img src="' + esc(cdnImg(img, 480)) + '" alt="" loading="lazy" decoding="async">' : '') +
        quickViewBtn +
        pinnedBadge +
        recoBadge +
        oosBadge +
      '</div>' +
      '<div class="xbb-pcard__body">' +
        '<div class="xbb-pcard__title">' + esc(p.title) + '</div>' +
        // price left, rating right, one row — the rating no longer takes a line of its own
        '<div class="xbb-pcard__meta"><div class="xbb-pcard__pricewrap">' + priceHtml + '</div>' + cardRatingHtml(p.handle) + '</div>' +
        variantSelector +
      '</div>' +
    '</div>';
  }

  // Star + average + review count under the card title (Loox numbers from the
  // facet payload; same source as the quick view). Empty until a product has a
  // review, so the row never shows a bare star. Rows that land after the grid
  // was drawn are filled in by patchCardRatings().
  function cardRatingHtml(handle) {
    var row = facetRowIndex[handle] || null;
    var r = row ? Number(row.r) || 0 : 0;
    var rc = row ? Number(row.rc) || 0 : 0;
    if (!(r > 0 && rc > 0)) return '';
    return '<div class="xbb-pcard__rating" aria-label="' + esc(r.toFixed(1)) + ' / 5, ' + rc + '">' +
      '<span class="xbb-pcard__star" aria-hidden="true">★</span>' +
      '<span class="xbb-pcard__rating-num">' + esc(r.toFixed(1).replace('.', ',')) + '</span>' +
      '<span class="xbb-pcard__rating-count">(' + rc + ')</span>' +
    '</div>';
  }
  function patchCardRatings() {
    var cards = document.querySelectorAll('.xbb-pcard[data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.querySelector('.xbb-pcard__rating')) continue;
      var html = cardRatingHtml(c.dataset.productHandle);
      if (!html) continue;
      var meta = c.querySelector('.xbb-pcard__meta');
      if (meta) meta.insertAdjacentHTML('beforeend', html);
    }
  }

  // Show the sort control above a grid when it has enough products to warrant it.
  var SORT_VISIBILITY_THRESHOLD = 30;
  function findSortControlForGrid(targetEl) {
    if (!targetEl || !targetEl.parentNode) return null;
    // The sort control lives inside the xbb-grid-controls sibling
    // immediately above the pgrid in each step.
    var prev = targetEl.previousElementSibling;
    while (prev) {
      if (prev.classList && prev.classList.contains('xbb-grid-controls')) {
        return prev.querySelector('.xbb-grid-sort');
      }
      prev = prev.previousElementSibling;
    }
    return null;
  }

  // Default order = most popular first. Popularity is the review count the
  // facet payload carries per product (Loox) — a sales proxy products.json
  // cannot give. Ties break on rating, then the collection's own order (stable).
  // Products without a row (payload not landed / not in it) keep their relative
  // order behind the ones that have one. Colour-matched recommendations (step 2)
  // stay in front as a block, exactly as before. If NO product has a review yet,
  // the list is returned untouched, so a fresh collection still shows in the
  // merchant's order.
  // SALES ORDER (2026-10-09): `k` is the product's builder position from
  // custom.bb_rank, set by the dashboard's bundle builder tool from bundle
  // sales (1 = first). Positioned products go first in that order; everything
  // without one keeps the review order behind them. No positions = unchanged.
  function popularityScore(p) {
    var row = facetRowIndex[p && p.handle] || null;
    if (!row) return null;
    return { rc: Number(row.rc) || 0, r: Number(row.r) || 0, k: Number(row.k) || 0 };
  }
  function popularityOrder(list) {
    var any = false;
    for (var i = 0; i < list.length; i++) {
      var s0 = popularityScore(list[i]);
      if (s0 && (s0.rc > 0 || s0.k > 0)) { any = true; break; }
    }
    if (!any) return list;
    var idx = list.map(function(p, i) {
      return { p: p, i: i, s: popularityScore(p) || { rc: 0, r: 0, k: 0 }, rec: !!(p && p._recommended) };
    });
    idx.sort(function(a, b) {
      if (a.rec !== b.rec) return a.rec ? -1 : 1;
      if ((a.s.k > 0) !== (b.s.k > 0)) return a.s.k > 0 ? -1 : 1;
      if (a.s.k !== b.s.k) return a.s.k - b.s.k;
      if (b.s.rc !== a.s.rc) return b.s.rc - a.s.rc;
      if (b.s.r !== a.s.r) return b.s.r - a.s.r;
      return a.i - b.i;
    });
    return idx.map(function(x) { return x.p; });
  }
  // PDP preselect: the pinned case goes to the very front of the CASE grid,
  // whatever the order. Shared by the first render and every re-sort.
  function hoistPinned(ordered, gridId) {
    if (!_pinnedCaseHandle || gridId !== 'xbb-step-1-products') return ordered;
    var pinIdx = -1;
    for (var pi = 0; pi < ordered.length; pi++) {
      if (ordered[pi] && ordered[pi].handle === _pinnedCaseHandle) { pinIdx = pi; break; }
    }
    if (pinIdx <= 0) return ordered;
    var pinned = ordered.splice(pinIdx, 1)[0];
    return [pinned].concat(ordered);
  }
  // Grids the shopper has started using (tapped a card, loaded more): a facet
  // payload landing later must not reshuffle those under their thumb.
  var gridTouched = {};
  function resortIfUntouched(gridId) {
    if (S.gridSort !== 'default' || gridTouched[gridId]) return;
    var grid = $(gridId);
    if (!grid || !(fullProductLists[gridId] || []).length) return;
    if (grid.getBoundingClientRect().top < -40) return;   // already scrolled into the grid
    // Same order as on screen? Then there is nothing to do. Redrawing anyway
    // re-creates every card, which reads as a blink even when nothing moves.
    if (Array.isArray(originalProductLists[gridId]) && originalProductLists[gridId].length) {
      var next = hoistPinned(sortProducts(getFilteredBase(gridId), S.gridSort).slice(), gridId);
      var cur = fullProductLists[gridId];
      if (next.length === cur.length && next.every(function(p, i) { return p === cur[i] || (p && cur[i] && p.handle === cur[i].handle); })) return;
    }
    applyGridSort(gridId);
  }
  function sortProducts(products, mode) {
    if (!Array.isArray(products) || products.length < 2) return products;
    var out = products;
    if (mode === 'default') out = popularityOrder(products);
    if (mode === 'price_asc' || mode === 'price_desc') {
      out = products.slice();
      out.sort(function(a, b) {
        var pa = parseFloat(((a.variants || [])[0] || {}).price || 0);
        var pb = parseFloat(((b.variants || [])[0] || {}).price || 0);
        return mode === 'price_asc' ? (pa - pb) : (pb - pa);
      });
    }
    // Sold-out products always sink to the bottom, whatever the sort mode.
    // "Sold out" = the card's RESOLVED variant (the one a click would add,
    // per the customer's selected model) — the same signal that paints the
    // "Uitverkocht" ribbon, so a ribboned card can never sit above a clean
    // one. Stable partition: relative order is preserved within each group,
    // so the colour-match recommendation order (default mode) and the price
    // order both survive — the sold-out block just moves to the end. They
    // stay visible there (never hidden); the availability facet is the
    // customer's way to remove them entirely.
    var inStock = [];
    var oos = [];
    out.forEach(function(p) {
      (variantAvailable(resolveCardVariant(p)) ? inStock : oos).push(p);
    });
    return oos.length ? inStock.concat(oos) : out;
  }

  function syncSortButtons() {
    $$('.xbb-grid-sort__btn').forEach(function(b) {
      b.classList.toggle('active', b.dataset.sort === S.gridSort);
    });
  }

  function applyGridSort(gridId) {
    var target = $(gridId);
    if (!target) return;
    // Always sort FROM the original (untouched) order so 'default' restores
    // the collection's natural sequence rather than the last-displayed one.
    // getFilteredBase narrows it to the active colour chip (if any).
    if (!Array.isArray(originalProductLists[gridId]) || originalProductLists[gridId].length === 0) return;
    var base = getFilteredBase(gridId);
    if (base.length === 0) {
      // With filters active this is a filter miss, not an empty collection —
      // say so and hand the customer a one-tap way out instead of a bare "∅".
      if (gridHasActiveFilters(gridId)) {
        target.innerHTML = '<div class="xbb-empty xbb-empty--filter">' +
          '<p class="xbb-empty__title">' + esc(noFilterMatchLabel()) + '</p>' +
          '<button type="button" class="xbb-empty__clear" data-grid="' + esc(gridId) + '">' +
          esc(clearFiltersLabel()) + '</button></div>';
      } else {
        target.innerHTML = '<div class="xbb-empty"><span class="xbb-empty__icon">∅</span><p class="xbb-empty__title">' + esc(t.empty) + '</p></div>';
      }
      fullProductLists[gridId] = [];
      visibleCounts[gridId] = 0;
      syncLoadMoreButton(gridId);
      return;
    }
    var sorted = hoistPinned(sortProducts(base, S.gridSort).slice(), gridId);
    visibleCounts[gridId] = Math.min(productsPerPage, sorted.length);
    var visible = sorted.slice(0, visibleCounts[gridId]);
    target.innerHTML = visible.map(productCard).join('');
    // fullProductLists holds the currently displayed (sorted) order so
    // showMore() paginates the same way the user is currently seeing them.
    fullProductLists[gridId] = sorted;
    syncLoadMoreButton(gridId);
  }

  function renderGrid(products, targetEl, gridId, opts) {
    opts = opts || {};
    if (!products || products.length === 0) {
      targetEl.innerHTML = '<div class="xbb-empty"><span class="xbb-empty__icon">∅</span><p class="xbb-empty__title">' + esc(t.empty) + '</p></div>';
      // Hide sort control on empty grids
      var sortCtl0 = findSortControlForGrid(targetEl);
      if (sortCtl0) sortCtl0.classList.add('xbb-hidden');
      // Consume the model-only scroll flag here too — nothing to scroll to on
      // an empty grid, and leaving it armed would mis-fire on a later render
      // (e.g. a cord-tab toggle that loads a non-empty grid).
      if (gridId === 'xbb-step-1-products') _pendingScrollToGrid = false;
      return;
    }
    // Stash the immutable original order so 'Default' sort can always restore it.
    originalProductLists[gridId] = products.slice();
    // Remember which collection this grid is showing so getFilteredBase can find
    // its facet payload. loadCollection stamps the handle onto the element.
    gridHandle[gridId] = targetEl.dataset.collectionHandle || gridHandle[gridId];
    // A fresh grid load resets any prior selection, then (re)builds the filter
    // row. Opt-in via opts.colorFilter. Real Shopify facets are preferred; the
    // legacy keyword-guessed colour chips are the fallback while the facet fetch
    // is still in flight or if it failed. loadCollection re-runs this once the
    // facets land, which swaps the chips out for the real bar.
    wantsFilters[gridId] = !!opts.colorFilter;
    if (opts.colorFilter) {
      colorFilterState[gridId] = null;
      facetState[gridId] = {};
      priceState[gridId] = {};
      var usedFacets = buildFacetBar(targetEl, gridId);
      if (usedFacets) {
        hideLegacyColorChips(targetEl);
      } else if (gridHasFacetData(gridId)) {
        // Facet data has landed but yields no usable facet for this grid — the
        // legacy keyword-colour chips are the genuine fallback now.
        buildColorFilter(targetEl, gridId, products);
      } else {
        // Facets are still in flight. No legacy chips (rendering them only to
        // hide them a beat later was the "old colour menu flashes then
        // vanishes" bug) — but the filter pill itself is drawn right away in a
        // muted, inert state, so the row is in place from the first paint
        // instead of popping in seconds later ("the filter only appears after
        // you pick a product"). loadCollection's facet callback swaps in the
        // real bar, or hides it if this grid has nothing to filter on.
        hideLegacyColorChips(targetEl);
        renderFacetPlaceholder(targetEl);
      }
    } else {
      hideLegacyColorChips(targetEl);
      hideFacetBar(targetEl);
      colorFilterState[gridId] = null;
      facetState[gridId] = {};
      priceState[gridId] = {};
    }
    // Most popular first (see popularityOrder), pinned PDP case in front.
    var ordered = hoistPinned(sortProducts(products, S.gridSort).slice(), gridId);
    gridTouched[gridId] = false;
    fullProductLists[gridId] = ordered;
    visibleCounts[gridId] = Math.min(productsPerPage, ordered.length);
    var visible = ordered.slice(0, visibleCounts[gridId]);
    targetEl.innerHTML = visible.map(productCard).join('');
    syncLoadMoreButton(gridId);
    // Only surface the sort control once the grid has enough products to make
    // ordering meaningful — keeps small grids visually clean.
    //
    // EXCEPT step 1. Its two tabs are the same task ("pick your case") but are
    // fed differently: "zonder koord" shows design-GROUPED tiles (9-13 per
    // model) while "met koord" lists individual cord cases (30+). A shared
    // product-count threshold therefore showed Sort on the with-cord tab and
    // hid it on the cordless one — the same step offering different controls
    // depending on which tab you were on. Step 1 always shows it so the tabs
    // match; steps 2 and 3 keep the threshold, where grid sizes vary far more.
    var sortCtl = findSortControlForGrid(targetEl);
    if (sortCtl) {
      if (gridId === 'xbb-step-1-products' || products.length >= SORT_VISIBILITY_THRESHOLD) {
        sortCtl.classList.remove('xbb-hidden');
      } else {
        sortCtl.classList.add('xbb-hidden');
      }
    }
    syncSortButtons();
    maybeHighlightPending(gridId);
    maybeScrollToGrid(gridId);
  }

  // Deep-link: after the step-1 case grid renders, scroll to + pulse the
  // product the customer clicked on the collection page. Best-effort —
  // if the exact product isn't in this grid (e.g. it's a with-cord case
  // and the cordless tab is showing), we leave the pending handle set so
  // a later render (tab switch) can still match it. The model + grid are
  // always shown regardless, so a miss degrades gracefully.
  function maybeHighlightPending(gridId) {
    if (!_pendingHighlightHandle || gridId !== 'xbb-step-1-products') return;
    var handle = _pendingHighlightHandle;
    var grid = $(gridId);
    if (!grid) return;
    var sel = '.xbb-pcard[data-product-handle="' + cssEsc(handle) + '"]';
    var card = grid.querySelector(sel);
    // If the product exists in the list but is paginated out of view, reveal
    // up to its position so it can be highlighted.
    if (!card) {
      var list = fullProductLists[gridId] || [];
      var idx = -1;
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].handle === handle) { idx = i; break; }
      }
      if (idx >= 0 && idx >= (visibleCounts[gridId] || 0)) {
        visibleCounts[gridId] = idx + 1;
        grid.innerHTML = list.slice(0, visibleCounts[gridId]).map(productCard).join('');
        syncLoadMoreButton(gridId);
        card = grid.querySelector(sel);
      }
    }
    if (!card) return; // not in this grid — keep pending for a later render
    _pendingHighlightHandle = null; // consume on first successful match
    card.classList.add('xbb-pcard--deeplink');
    setTimeout(function() {
      try { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      catch (e) { card.scrollIntoView(); }
    }, 90);
    setTimeout(function() { card.classList.remove('xbb-pcard--deeplink'); }, 2800);
    // The pinned card is now on screen — this is the "everything's ready" moment.
    // Lift the preload mask, then pop the add-to-cart confirmation so it lands on
    // the finished view rather than over the loader.
    hidePreloadOverlay();
    if (_preselectedLine) {
      var ln = _preselectedLine; _preselectedLine = null;
      setTimeout(function() { showAddedConfirm(ln); }, 220);
    }
  }

  // Model-only deep-link: once the step-1 grid renders, bring the model title,
  // case-type toggle and first cases into view so the customer isn't stranded
  // at the page top. Consumed once. Deferred so the fresh grid has laid out and
  // any synchronous scrollTo(top:0) from showStep/showSubstep has run first.
  function maybeScrollToGrid(gridId) {
    if (!_pendingScrollToGrid || gridId !== 'xbb-step-1-products') return;
    _pendingScrollToGrid = false;
    var target = $('xbb-step-1b-title') || $('xbb-step-1b');
    if (!target) return;
    setTimeout(function() {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      catch (e) { target.scrollIntoView(); }
    }, 90);
  }

  function syncLoadMoreButton(gridId) {
    var btnId = {
      'xbb-step-1-products': 'xbb-load-more-1',
      'xbb-step-2-products': 'xbb-load-more-2',
      'xbb-step-3-products': 'xbb-load-more-3'
    }[gridId];
    if (!btnId) return;
    var btn = $(btnId);
    if (!btn) return;
    var full = fullProductLists[gridId] || [];
    if (visibleCounts[gridId] < full.length) {
      btn.classList.remove('xbb-hidden');
      btn.textContent = btn.textContent.replace(/\s*\(\d+\)/, '') + ' (' + (full.length - visibleCounts[gridId]) + ')';
    } else {
      btn.classList.add('xbb-hidden');
    }
  }

  // "Toon meer" loads itself as it scrolls into view. 48% of builder sessions
  // pressed it, three times each on average — a long grid stalling on a button
  // is friction, not a feature. The button stays as the fallback (and is what
  // the observer watches), and hides itself once everything is shown.
  function setupAutoLoadMore() {
    if (!('IntersectionObserver' in window)) return;
    var map = {
      'xbb-load-more-1': 'xbb-step-1-products',
      'xbb-load-more-2': 'xbb-step-2-products',
      'xbb-load-more-3': 'xbb-step-3-products'
    };
    var busy = {};
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (!en.isIntersecting) return;
        var btn = en.target;
        var gridId = map[btn.id];
        if (!gridId || btn.classList.contains('xbb-hidden') || busy[gridId]) return;
        busy[gridId] = true;
        showMore(gridId);
        // one page per settle: let layout catch up before the next trigger
        setTimeout(function() { busy[gridId] = false; }, 350);
      });
    }, { rootMargin: '360px 0px' });
    Object.keys(map).forEach(function(id) {
      var el = document.getElementById(id);
      if (el) io.observe(el);
    });
  }
  function showMore(gridId) {
    var target = $(gridId);
    if (!target) return;
    gridTouched[gridId] = true;
    var full = fullProductLists[gridId] || [];
    var prev = visibleCounts[gridId] || 0;
    visibleCounts[gridId] = Math.min(prev + productsPerPage, full.length);
    var next = full.slice(prev, visibleCounts[gridId]);
    target.insertAdjacentHTML('beforeend', next.map(productCard).join(''));
    syncLoadMoreButton(gridId);
  }

  // ─── Step navigation ────────────────────────────────
  // ─── Step scrolling ──────────────────────────────────
  // Advancing a step used to yank the page to y=0. On a long page that threw the
  // customer clear above the builder — it read as a reload, not as progress.
  // Scroll to the heading of the step they just landed on instead ("02 Kies jouw
  // koord"), so the numbered header is the thing that greets them.
  var _stepScrollArmed = false;   // off until init finishes: page load must not scroll
  var _stepScrollQueued = false;
  var _scrollMem = {};            // step key -> where they were when they left it
  var _backNav = false;           // set by handleBack: restore instead of re-heading

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function stepKey() { return S.step + '|' + (S.substep || ''); }

  // Remember where they were before a step change, so going back puts them
  // where they left off instead of at the top of the step. Only the FIRST call
  // in a frame records: goToStep(3) runs showStep() then showSubstep(), and the
  // second one would otherwise overwrite the real outgoing position with the
  // half-changed state. _stepScrollQueued is already set by the first call.
  function rememberScroll() {
    if (!_stepScrollArmed || _stepScrollQueued) return;
    _scrollMem[stepKey()] = window.pageYOffset;
  }

  // offsetTop chain rather than getBoundingClientRect: steps animate in with
  // translateY(14px), and a rect measured mid-animation is 14px off. offsetTop
  // ignores transforms, so the target is exact.
  function docTop(el) {
    var y = 0;
    while (el) { y += el.offsetTop; el = el.offsetParent; }
    return y;
  }

  // Height of whatever is pinned to the top of the viewport, so the heading
  // lands just below it instead of behind it.
  function topChromeHeight() {
    var h = 18; // breathing room above the heading
    // The builder's own stepper (mobile). It collapses to a slim bar the instant
    // it pins, so its height while still unpinned is meaningless — allow for the
    // collapsed bar instead of measuring the tall unpinned one.
    var prog = document.querySelector('.xbb-prog');
    if (prog && /^(sticky|fixed)$/.test(window.getComputedStyle(prog).position)) h += 44;
    // A sticky theme header, if this theme has one. Measured rather than assumed,
    // because the theme can change under us, and only counted while it is
    // actually pinned at the top.
    var wrap = document.querySelector('.xbb-wrap');
    var cands = document.querySelectorAll('header, [id*="__header"], [id*="section-header"]');
    for (var i = 0; i < cands.length && i < 12; i++) {
      var el = cands[i];
      // The builder's own step headings are <header> elements too — skip our
      // whole subtree so they can't crowd out the real site header.
      if (wrap && wrap.contains(el)) continue;
      if (!/^(sticky|fixed)$/.test(window.getComputedStyle(el).position)) continue;
      var r = el.getBoundingClientRect();
      if (r.top <= 4 && r.bottom > 0) h += r.bottom;
    }
    return h;
  }

  function stepScrollTarget() {
    var step = document.querySelector('.xbb-step.active');
    if (!step) return null;
    // A step with substeps has several heads — take the active substep's.
    var sub = step.querySelector('.xbb-substep.active');
    return (sub && sub.querySelector('.xbb-step__head')) ||
           step.querySelector('.xbb-step__head') || step;
  }

  // Coalesced through rAF: goToStep(3) calls showStep() AND showSubstep(), and
  // two smooth scrollTo()s fired in the same frame fight each other and land
  // somewhere arbitrary. One scroll per frame, measured after both have run.
  function scrollToActiveStep() {
    if (!_stepScrollArmed || _stepScrollQueued) return;
    _stepScrollQueued = true;
    requestAnimationFrame(function() {
      _stepScrollQueued = false;
      // Consume the back-nav flag up front: an early return below would
      // otherwise leak it into the next forward navigation.
      var back = _backNav;
      _backNav = false;
      var target = stepScrollTarget();
      if (!target) return;
      var y = Math.max(0, docTop(target) - topChromeHeight());
      // Going back: return them to where they were in that step (deep in a grid,
      // say) rather than to its heading. Never below the heading, so a stale
      // memory from a taller render can't strand them past the content.
      if (back) {
        var mem = _scrollMem[stepKey()];
        if (typeof mem === 'number' && mem > y) y = mem;
      }
      // Already sitting where we'd put it? Don't move. A 20px hop reads as a
      // glitch rather than as navigation, and this is the common case when the
      // customer taps Continue right after landing on a step.
      if (Math.abs(window.pageYOffset - y) < 24) return;
      if (reduceMotion()) { window.scrollTo(0, y); return; }
      try { window.scrollTo({ top: y, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
    });
  }

  // ─── Browser back/forward = builder back/forward ─────
  // Every step / sub-step the shopper reaches becomes a history entry, so the
  // phone's back button (or an edge swipe) walks back through the builder
  // instead of leaving the page. Modals, the drawer and the filter sheet are
  // deliberately NOT entries: a back press while one is open just closes it and
  // stays on the same step. Entries are written one frame after a navigation
  // (goToStep(3) runs showStep() and then showSubstep() — that must be ONE
  // entry, for the final view), and never while init/restore is still laying
  // the page out.
  var _histNav = false;        // applying a popstate: replace, never push
  var _histQueued = false;
  function histKey() { return S.step + '|' + (S.substep || ''); }
  function histState() { return { xbb: { step: S.step, substep: S.substep || null } }; }
  function histUrl() { return window.location.pathname + window.location.search + window.location.hash; }
  function syncHistory() {
    if (!_stepScrollArmed || _histQueued) return;
    _histQueued = true;
    requestAnimationFrame(function() {
      _histQueued = false;
      var cur = history.state && history.state.xbb;
      var same = !!cur && (cur.step + '|' + (cur.substep || '')) === histKey();
      try {
        if (_histNav || same) history.replaceState(histState(), '', histUrl());
        else history.pushState(histState(), '', histUrl());
      } catch (e) { /* history quota / sandboxed frame — navigation still works */ }
      _histNav = false;
    });
  }
  function anyOverlayOpen() {
    var qv = $('xbb-qv'), up = $('xbb-upsell'), dr = $('xbb-drawer-mobile');
    return !!((qv && qv.classList.contains('show')) ||
              (up && up.classList.contains('show')) ||
              (dr && dr.classList.contains('expanded')) ||
              _openFacetSheetEl);
  }
  function closeAnyOverlay() {
    var qv = $('xbb-qv'); if (qv && qv.classList.contains('show')) closeQuickView();
    var up = $('xbb-upsell'); if (up && up.classList.contains('show')) hideUpsell();
    var dr = $('xbb-drawer-mobile'); if (dr && dr.classList.contains('expanded')) closeMobileDrawer();
    if (_openFacetSheetEl) closeFacetSheet(_openFacetSheetEl);
  }
  window.addEventListener('popstate', function(ev) {
    var st = ev.state && ev.state.xbb;
    if (!st) return;   // not one of ours — let the browser do its thing
    if (anyOverlayOpen()) {
      // Consume the back press: close what's open and put the entry back.
      closeAnyOverlay();
      try { history.pushState(histState(), '', histUrl()); } catch (e) {}
      return;
    }
    _histNav = true;
    _backNav = true;   // land where they were in that step, not on its heading
    closeDrawerForNav();
    var step = Number(st.step) || 1;
    if (step === 2 && S.caseType === 'with') step = 1;   // no cord step on this path
    if (step === 2) {
      showStep(2);
      loadCordTab(S.cordLength || 'short');
    } else if (step === 3) {
      showStep(3);
      showSubstep('xbb-step-3', st.substep === 'xbb-step-3b' ? 'xbb-step-3b' : 'xbb-step-3a');
    } else {
      showStep(1);
      var wantGrid = (st.substep === 'xbb-step-1b' || Number(st.step) === 2) && S.model;
      showSubstep('xbb-step-1', wantGrid ? 'xbb-step-1b' : 'xbb-step-1a');
    }
    refreshTray();
  });

  function showStep(n) {
    rememberScroll();
    S.step = n;
    if (n > S.maxStep) S.maxStep = n;
    $$('.xbb-step').forEach(function(el) { el.classList.toggle('active', el.id === 'xbb-step-' + n); });
    $$('.xbb-prog-step').forEach(function(el) {
      var pn = parseInt(el.dataset.prog, 10);
      el.classList.toggle('active', pn === n);
      // "done" = any step we've already visited but aren't on right now
      el.classList.toggle('done', pn !== n && pn <= S.maxStep);
    });
    scrollToActiveStep();
    refreshTray();
    syncHistory();
  }

  // Sticky Skip/Continue bar on step 2 mobile. Standalone fixed element so
  // it's visible the INSTANT the customer lands on step 2 — they shouldn't
  // have to add a cord (or even know the drawer exists) to find the next
  // button. Stacked above the bundle drawer via a measured offset.
  function updateDrawerNav() {
    var drBack = $('xbb-drawer-back');
    if (drBack) {
      var isStep1a = S.step === 1 && (S.substep === 'xbb-step-1a' || !S.substep);
      drBack.style.display = isStep1a ? 'none' : 'flex';
    }
  }

  function handleDrawerBack() {
    if (S.step === 3) {
      if (S.substep === 'xbb-step-3a') handleBack('step2');
      else handleBack('3a');
    } else if (S.step === 2) {
      handleBack('step1');
    } else if (S.step === 1) {
      if (S.substep === 'xbb-step-1b') handleBack('1a');
    }
  }

  function showSubstep(parentId, substepId) {
    var parent = $(parentId);
    if (!parent) return;
    rememberScroll();
    // The step-3 subcategory grid's injected tiles depend on caseType (the
    // "Add a cord" tile is cordless-only). Rebuild it on every entry to 3a so
    // it always matches the current path — covers normal nav, back, "add
    // another category", progress-bar jumps, and deep-link cord-tab flips.
    if (substepId === 'xbb-step-3a') renderSubcats();
    $$('.xbb-substep', parent).forEach(function(el) {
      el.classList.toggle('active', el.id === substepId);
    });
    S.substep = substepId;
    persistState();

    scrollToActiveStep();
    syncHistory();
  }

  // Navigating while the mobile bundle drawer is expanded used to change the step
  // BEHIND it: the drawer stayed open, covering the page you'd just navigated to.
  // Every step navigation now dismisses it first.
  function closeDrawerForNav() {
    var dr = $('xbb-drawer-mobile');
    if (dr && dr.classList.contains('expanded')) closeMobileDrawer();
  }

  function goToStep(n) {
    closeDrawerForNav();
    if (n === 2) {
      showStep(2);
      loadCordTab(S.cordLength);
    } else if (n === 3) {
      showStep(3);
      showSubstep('xbb-step-3', 'xbb-step-3a');
    } else {
      showStep(n);
    }
  }

  // ─── Quick view modal ───────────────────────────────
  var qvActiveCard = null;
  var qvImages = [];
  var qvIndex = 0;

  // ─── Quick-view info panel ───────────────────────────
  // Facts come from two places: the card's own dataset (model, stock) and the
  // bundle-json facet payload merged into facetRowIndex (rating, case type) —
  // metafields can't come from products.json, so that view is the only source.
  function qvStars(rating) {
    var r = Math.max(0, Math.min(5, Number(rating) || 0));
    var full = Math.floor(r);
    var half = (r - full) >= 0.5;
    var out = '';
    for (var i = 0; i < 5; i++) {
      var on = i < full || (i === full && half);
      out += '<span class="xbb-qv__star' + (on ? ' is-on' : '') + '" aria-hidden="true">★</span>';
    }
    return out;
  }
  function renderQuickViewFacts(card) {
    var el = $('xbb-qv-facts');
    if (!el) return;
    if (card.dataset.qvKind === 'clip') {
      // Not a phone-model product: one chip, the gift label.
      el.innerHTML = '<div class="xbb-qv__chips"><span class="xbb-qv__chip">' + esc(t.giftLabel) + '</span></div>';
      el.hidden = false;
      return;
    }
    var handle = card.dataset.productHandle || '';
    var row = facetRowIndex[handle] || {};
    var bits = [];

    var rating = Number(row.r || 0);
    var count = Number(row.rc || 0);
    if (rating > 0) {
      var inner = qvStars(rating) +
        '<span class="xbb-qv__rating-num">' + rating.toFixed(1).replace('.', ',') + '</span>' +
        (count > 0 ? '<span class="xbb-qv__rating-count">(' + count + ')</span>' : '');
      // With reviews behind it, the rating is a button: it opens a compact
      // Loox reviews panel right here in the popup (see toggleQvReviews).
      if (looxKey && count > 0) {
        bits.push('<button type="button" class="xbb-qv__rating xbb-qv__rating--btn" data-qv-reviews aria-expanded="false" aria-controls="xbb-qv-reviews">' + inner +
          '<span class="xbb-qv__rating-link">' + esc(t.reviewsSee) + '</span>' +
          '<svg class="xbb-qv__rating-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
        '</button>');
      } else {
        bits.push('<div class="xbb-qv__rating">' + inner + '</div>');
      }
    }

    var chips = [];
    // Which phone this tile is for — the single most useful fact in a builder.
    if (S.model && S.model.title) chips.push(esc(S.model.title));
    (row.ct || []).forEach(function(c) { if (c) chips.push(esc(String(c))); });
    if (!(row.ct || []).length && row.pt) chips.push(esc(String(row.pt)));
    var avail = card.dataset.variantAvailable !== '0';
    chips.push(avail ? esc(t.inStock) : esc(t.soldOut));
    if (chips.length) {
      bits.push('<div class="xbb-qv__chips">' + chips.map(function(c) {
        return '<span class="xbb-qv__chip">' + c + '</span>';
      }).join('') + '</div>');
    }

    el.innerHTML = bits.join('');
    el.hidden = !bits.length;
  }
  // The description is merchant HTML from body_html. We keep only inline
  // formatting and paragraphs/lists — no scripts, styles, iframes or event
  // attributes — because it is injected into our own modal.
  var QV_ALLOWED = /^(P|BR|STRONG|B|EM|I|U|UL|OL|LI|SPAN|H2|H3|H4|SMALL)$/;
  function sanitizeDescription(html) {
    var box = document.createElement('div');
    box.innerHTML = String(html || '');
    var walk = box.querySelectorAll('*');
    for (var i = walk.length - 1; i >= 0; i--) {
      var node = walk[i];
      if (!QV_ALLOWED.test(node.tagName)) {
        // Unwrap unknown tags so their text survives; drop dangerous ones whole.
        if (/^(SCRIPT|STYLE|IFRAME|OBJECT|EMBED|LINK|META|FORM|INPUT|BUTTON)$/.test(node.tagName)) {
          node.parentNode.removeChild(node);
        } else {
          while (node.firstChild) node.parentNode.insertBefore(node.firstChild, node);
          node.parentNode.removeChild(node);
        }
        continue;
      }
      for (var a = node.attributes.length - 1; a >= 0; a--) {
        node.removeAttribute(node.attributes[a].name);   // strips on*, style, class…
      }
    }
    return box.innerHTML;
  }
  // ─── Quick-view reviews panel ─────────────────────────
  // Loox draws its reviews inside an iframe from loox.io (no cross-origin
  // access to the HTML), so the panel embeds the same widget page the PDP
  // uses, trimmed with its own parameters: a few reviews, no "write a review"
  // button, the shopper's language. Lazy: nothing loads until the rating is
  // tapped; the frame is dropped again when the popup changes product.
  var productIdCache = {};        // handle -> Shopify product id (from the facet row or /products/<handle>.js)
  function qvResetReviews() {
    var panel = document.getElementById('xbb-qv-reviews');
    if (panel) panel.parentNode.removeChild(panel);
    var btn = document.querySelector('#xbb-qv [data-qv-reviews]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  function qvProductId(handle, cb) {
    if (productIdCache[handle]) { cb(productIdCache[handle]); return; }
    var row = facetRowIndex[handle];
    if (row && row.id) { productIdCache[handle] = String(row.id); cb(productIdCache[handle]); return; }
    fetchT(lp + '/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } }, 12000)
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(p) { if (p && p.id) { productIdCache[handle] = String(p.id); cb(productIdCache[handle]); } else cb(null); })
      .catch(function() { cb(null); });
  }
  function looxReviewsUrl(productId) {
    // header=false drops Loox's own summary block + "write a review" button: the
    // panel has its own header, and the popup already shows the stars.
    var q = ['limit=4', 'header=false', 'write_btn=false', 'language=' + encodeURIComponent(lang === 'de' ? 'de' : lang === 'fr' ? 'fr' : lang === 'en' ? 'en' : 'nl')];
    return 'https://loox.io/widget/' + encodeURIComponent(looxKey) + '/reviews/' + encodeURIComponent(productId) + '?' + q.join('&');
  }
  function toggleQvReviews(btn) {
    var facts = $('xbb-qv-facts');
    if (!facts || !qvActiveCard || !looxKey) return;
    var panel = document.getElementById('xbb-qv-reviews');
    if (panel) {
      var hide = !panel.hidden;
      panel.hidden = hide;
      btn.setAttribute('aria-expanded', hide ? 'false' : 'true');
      if (!hide) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    var handle = qvActiveCard.dataset.productHandle || '';
    var row = facetRowIndex[handle] || {};
    var count = Number(row.rc || 0);
    panel = document.createElement('div');
    panel.id = 'xbb-qv-reviews';
    panel.className = 'xbb-qv__reviews';
    panel.innerHTML =
      '<div class="xbb-qv__reviews-head"><span>' + esc(t.reviewsTitle) + (count ? '<span class="xbb-qv__reviews-count">(' + count + ')</span>' : '') + '</span>' +
        '<button type="button" class="xbb-qv__reviews-close" data-qv-reviews-close aria-label="' + esc(t.reviewsTitle) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button></div>' +
      '<div class="xbb-qv__reviews-body"><div class="xbb-qv__reviews-loading">' + esc(t.reviewsLoading) + '</div></div>';
    facts.insertAdjacentElement('afterend', panel);
    btn.setAttribute('aria-expanded', 'true');
    var card = qvActiveCard;
    var body = panel.querySelector('.xbb-qv__reviews-body');
    body.innerHTML = '<div class="xbb-qv__revrow" aria-hidden="true"><span class="xbb-qv__revskel"></span><span class="xbb-qv__revskel"></span></div>';
    panel.classList.add('is-loaded');
    qvProductId(handle, function(pid) {
      if (qvActiveCard !== card || !panel.parentNode) return;
      if (!pid) { body.innerHTML = '<div class="xbb-qv__reviews-loading">' + esc(t.reviewsNone) + '</div>'; return; }
      var frame = function() {
        // Loox's own frame — the fallback when the proxy is off or returns nothing.
        body.innerHTML = '<div class="xbb-qv__reviews-loading">' + esc(t.reviewsLoading) + '</div>';
        panel.classList.remove('is-loaded');
        var fr = document.createElement('iframe');
        fr.setAttribute('title', t.reviewsTitle);
        fr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        fr.addEventListener('load', function() { panel.classList.add('is-loaded'); });
        fr.src = looxReviewsUrl(pid);
        body.appendChild(fr);
      };
      if (!reviewsApi) { frame(); return; }
      var url = reviewsApi + '/api/loox-reviews?key=' + encodeURIComponent(looxKey) + '&product=' + encodeURIComponent(pid) +
        '&lang=' + encodeURIComponent(lang === 'de' ? 'de' : lang === 'fr' ? 'fr' : lang === 'en' ? 'en' : 'nl') + '&limit=20';
      fetchT(url, { headers: { 'Accept': 'application/json' } }, 9000)
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(d) {
          if (qvActiveCard !== card || !panel.parentNode) return;
          var list = (d && d.reviews) || [];
          if (!list.length) { frame(); return; }
          renderReviewCards(body, list, count, handle);
          panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        })
        .catch(function() { if (qvActiveCard === card && panel.parentNode) frame(); });
    });
  }
  function fmtReviewDate(ts) {
    if (!ts) return '';
    try {
      var loc = lang === 'de' ? 'de-DE' : lang === 'fr' ? 'fr-FR' : lang === 'en' ? 'en-GB' : 'nl-NL';
      return new Date(ts).toLocaleDateString(loc, { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) { return ''; }
  }
  // Native cards, the builder's own type and colours: name + verified tick,
  // date, stars, text clamped to five lines with a "more" toggle, photo if any.
  // A swipeable row, so the shopper thumbs through them; the popup keeps its
  // normal vertical scroll. Ends with a link to the full list on the product page.
  // How far one arrow press moves the row: exactly one card plus the gap, so a
  // press always lands a whole card rather than a sliver of two.
  function revStep(row) {
    var card = row.querySelector('.xbb-qv__revcard');
    return card ? Math.round(card.getBoundingClientRect().width) + 10
                : Math.round(row.clientWidth * 0.8);
  }

  // The arrows only earn their place when there is something to reach AND there is
  // no finger to swipe with. On a touch screen they would sit on top of the cards
  // for no reason; on a desktop they are the only way to move the row at all.
  function syncRevNav(scope) {
    var row = scope.querySelector('.xbb-qv__revrow');
    if (!row) return;
    var navs = scope.querySelectorAll('[data-rev-nav]');
    var max = row.scrollWidth - row.clientWidth;
    var coarse = false;
    try { coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) {}
    var show = max > 8 && !coarse;
    for (var i = 0; i < navs.length; i++) {
      navs[i].hidden = !show;
      navs[i].disabled = Number(navs[i].getAttribute('data-rev-nav')) < 0
        ? row.scrollLeft <= 2
        : row.scrollLeft >= max - 2;
    }
  }

  function renderReviewCards(body, list, total, handle) {
    var tick = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    function revChev(dir) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="' +
        (dir < 0 ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"/></svg>';
    }
    var html = '<div class="xbb-qv__revwrap">' +
      '<button type="button" class="xbb-qv__revnav xbb-qv__revnav--prev" data-rev-nav="-1" aria-label="' +
        esc(t.reviewsPrev) + '" hidden>' + revChev(-1) + '</button>' +
      '<div class="xbb-qv__revrow" tabindex="0">' + list.map(function(rv, i) {
      var long = String(rv.text || '').length > 190;
      return '<article class="xbb-qv__revcard" data-rev-index="' + i + '">' +
        '<div class="xbb-qv__revcard-top">' +
          '<span class="xbb-qv__revcard-name">' + esc(rv.name || '') + (rv.verified ? tick : '') + '</span>' +
          '<span class="xbb-qv__revcard-date">' + esc(fmtReviewDate(rv.ts)) + '</span>' +
        '</div>' +
        '<div class="xbb-qv__revcard-stars" aria-label="' + esc(String(rv.rating)) + ' / 5">' + qvStars(rv.rating) + '</div>' +
        (rv.text ? '<p class="xbb-qv__revcard-text">' + esc(rv.text) + '</p>' : '') +
        (long ? '<button type="button" class="xbb-qv__revcard-more" data-rev-more>' + esc(t.reviewsMore) + '</button>' : '') +
      '</article>';
    }).join('') + '</div>' +
      '<button type="button" class="xbb-qv__revnav xbb-qv__revnav--next" data-rev-nav="1" aria-label="' +
        esc(t.reviewsNext) + '" hidden>' + revChev(1) + '</button>' +
    '</div>';
    // No way out of the builder from here: the old "see all reviews" link opened
    // the product page, which is the one thing this popup exists to avoid. The
    // row simply carries more of them (20), and says how many there are.
    if (total > list.length) {
      html += '<p class="xbb-qv__revall">' + esc(t.reviewsShown(list.length, total)) + '</p>';
    }
    body.innerHTML = html;
    // Arm the arrows. The row is measured after it is in the DOM, and again a beat
    // later because a late image can change its width after the first paint.
    var revRow = body.querySelector('.xbb-qv__revrow');
    if (revRow) {
      revRow.addEventListener('scroll', function() {
        if (revRow._revTick) return;
        revRow._revTick = true;
        requestAnimationFrame(function() { revRow._revTick = false; syncRevNav(body); });
      }, { passive: true });
      syncRevNav(body);
      setTimeout(function() { syncRevNav(body); }, 300);
    }
  }

  function renderQuickViewDesc(card) {
    var el = $('xbb-qv-desc');
    if (!el) return;
    var handle = card.dataset.productHandle || '';
    var html = descByHandle[handle] || '';
    if (!html) { el.innerHTML = ''; el.hidden = true; return; }
    el.innerHTML = sanitizeDescription(html);
    el.hidden = !el.textContent.trim();
  }

  function openQuickView(card) {
    qvResetReviews();
    qvActiveCard = card;
    var title = card.dataset.productTitle || '';
    var price = Math.round(parseFloat(card.dataset.productPrice) || 0);
    var photos = [];
    try { photos = JSON.parse(card.dataset.images || '[]'); } catch (e) { photos = []; }
    if (!photos.length && card.dataset.productImg) photos = [card.dataset.productImg];
    if (card.dataset.qvMedia) {
      // prebuilt entries (clip popup: straight from /products/<handle>.js media)
      try { qvImages = JSON.parse(card.dataset.qvMedia); } catch (e) { qvImages = []; }
      if (!qvImages.length) qvImages = qvBuildGallery(photos, null);
    } else {
      // grid card: photos from products.json + this product's videos / translated
      // images from the collection's bundle-json payload (if it has landed)
      var qvHandle = card.dataset.productHandle || '';
      qvImages = qvBuildGallery(photos, qvRowFor(qvHandle));
      // No media info for it anywhere yet? Ask the product (one small request).
      var rowNow = facetRowIndex[qvHandle];
      if (!rowNow || typeof rowNow.md === 'undefined') qvFetchMediaFor(card);
    }
    qvIndex = 0;

    $('xbb-qv-title').textContent = title;
    $('xbb-qv-price').textContent = money(price);
    renderQuickViewFacts(card);
    renderQuickViewDesc(card);

    updateQuickViewImage(true);
    renderQuickViewThumbs();

    var counterEl = $('xbb-qv-counter');
    if (qvImages.length > 1) {
      counterEl.hidden = false;
      updateQuickViewCounter();
    } else {
      counterEl.hidden = true;
    }

    // Hide prev/next when only one image
    var multi = qvImages.length > 1;
    $('xbb-qv-prev').style.display = multi ? '' : 'none';
    $('xbb-qv-next').style.display = multi ? '' : 'none';

    // Adapt the CTA — disable + relabel when product is already in bundle
    var addBtn = $('xbb-qv-add');
    var addLabel = $('xbb-qv-add-label');
    var alreadyIn = card.classList.contains('selected');
    addBtn.disabled = alreadyIn;
    addLabel.textContent = alreadyIn
      ? (lang === 'de' ? 'Bereits hinzugefügt' : lang === 'fr' ? 'Déjà ajouté' : lang === 'en' ? 'Already in bundle' : 'Al toegevoegd')
      : (lang === 'de' ? 'Hinzufügen' : lang === 'fr' ? 'Ajouter au pack' : lang === 'en' ? 'Add to bundle' : 'Voeg toe aan bundel');
    // Gift-clip popup (opened from the cord-step notification): no Add button —
    // the clip is added automatically once a cord is in — and the price line
    // reads "free · worth €5,99" so the gift has a visible value.
    var isClipQv = card.dataset.qvKind === 'clip';
    addBtn.style.display = isClipQv ? 'none' : '';
    if (isClipQv) {
      var worth = parseInt(card.dataset.clipWorth || '0', 10);
      $('xbb-qv-price').textContent = t.free + (worth > 0 ? ' · ' + t.clipWorth(money(worth)) : '');
    }

    var modal = $('xbb-qv');
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    // Bulletproof: force visibility + escape any ancestor with overflow:hidden
    // or a transform that traps position:fixed children inside a stacking
    // context. Max-int z-index so no theme element can sit above us.
    // align-items:flex-start + overflow-y:auto (matching the stylesheet) — the
    // card carries `margin:auto` so it still centres when it fits. Centring here
    // instead would put the top of a too-tall card out of reach on Android.
    modal.style.cssText = 'display:flex !important;position:fixed !important;inset:0 !important;z-index:2147483647 !important;opacity:1 !important;align-items:flex-start;justify-content:center;padding:1rem;overflow-y:auto;-webkit-overflow-scrolling:touch;';
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    document.body.style.overflow = 'hidden';

    // Reset the details scroll to the top — but only NOW, once the modal is
    // actually visible. Doing it while the panel is still display:none is a
    // no-op, which is why opening a second product used to land you halfway
    // down its description instead of on its title. The deferred second pass
    // covers browsers that only lay the panel out on the next frame.
    var qvScroll = $('xbb-qv-scroll');
    if (qvScroll) {
      qvScroll.scrollTop = 0;
      setTimeout(function() { qvScroll.scrollTop = 0; }, 0);
    }

    // Safety net: never leave body locked indefinitely if anything glitches.
    clearTimeout(openQuickView._safety);
    openQuickView._safety = setTimeout(function() {
      if (modal.classList.contains('show')) closeQuickView();
    }, 60000);
  }

  // ─── Quick-view gallery entries ──────────────────────
  // qvImages used to be a list of photo urls straight out of products.json. It
  // is now a list of ENTRIES so the gallery can carry what the PDP carries:
  //   { t: 'image', src }                       a photo
  //   { t: 'video', src, img }                  a Shopify-hosted video (mp4) + poster
  //   { t: 'ext',   host, id, img }             a YouTube / Vimeo video + poster
  // products.json lists photos only, so videos and the per-language "images with
  // text" arrive through the collection's bundle-json view (facetRowIndex[handle]
  // .md / .li) and are slotted in here, at the same positions the PDP uses:
  // videos at their media position, the first translated image second, the rest
  // at the end. Strong product videos were simply never shown before.
  function qvEntryImg(e) { return e ? (e.t === 'image' ? e.src : (e.img || '')) : ''; }
  function qvNormUrl(u) { return String(u || '').replace(/^\/\//, 'https://'); }
  function qvKey(u) { return qvNormUrl(u).split('?')[0]; }
  function qvBuildGallery(photos, row) {
    var out = [], seen = {};
    (photos || []).forEach(function(src) {
      var k = qvKey(src); if (!src || seen[k]) return; seen[k] = 1;
      out.push({ t: 'image', src: qvNormUrl(src) });
    });
    row = row || {};
    // videos: media positions are 1-based and count the videos themselves, so
    // inserting in ascending order at (p - 1) reproduces the PDP order exactly.
    (row.md || []).slice().sort(function(a, b) { return (a.p || 0) - (b.p || 0); }).forEach(function(v) {
      if (!v || (v.t === 'video' && !v.src) || (v.t === 'ext' && !v.id)) return;
      var e = v.t === 'ext'
        ? { t: 'ext', host: v.host || '', id: String(v.id), img: qvNormUrl(v.img) }
        : { t: 'video', src: qvNormUrl(v.src), img: qvNormUrl(v.img) };
      var at = Math.max(0, Math.min(out.length, (parseInt(v.p, 10) || out.length + 1) - 1));
      out.splice(at, 0, e);
    });
    // translated images with text: first one second in the gallery, rest at the end
    (row.li || []).forEach(function(src, i) {
      var k = qvKey(src); if (!src || seen[k]) return; seen[k] = 1;
      var e = { t: 'image', src: qvNormUrl(src) };
      if (i === 0 && out.length) out.splice(1, 0, e); else out.push(e);
    });
    return out;
  }
  // The row the gallery builder reads for a grid card: the facet row, plus — when
  // that row has no media info at all (no payload yet, or one rendered before
  // the view carried it) — videos asked from the product itself. Kept OUT of
  // facetRowIndex on purpose: other code treats a row's presence as "facet data
  // landed for this grid", and a media-only stub must not flip that.
  var qvJsMediaCache = {};          // handle -> md[] (possibly empty), from /products/<handle>.js
  function qvRowFor(handle) {
    var row = facetRowIndex[handle] || null;
    if (row && typeof row.md !== 'undefined') return row;
    var md = qvJsMediaCache[handle];
    if (!md) return row;
    var merged = {}; if (row) { for (var k in row) merged[k] = row[k]; }
    merged.md = md;
    return merged;
  }
  function qvFetchMediaFor(card) {
    var handle = card.dataset.productHandle || '';
    if (!handle || handle.charAt(0) === '_' || qvJsMediaCache[handle]) return;
    fetchT(lp + '/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } }, 12000)
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(p) {
        var md = [];
        ((p && p.media) || []).forEach(function(m) {
          if (m.media_type === 'video') {
            var best = null;
            (m.sources || []).forEach(function(s) {
              if (s.format !== 'mp4') return;
              if (!best || (s.height <= 720 && (best.height > 720 || s.height > best.height))) best = s;
            });
            if (best) md.push({ p: m.position, t: 'video', src: best.url, img: m.preview_image && m.preview_image.src });
          } else if (m.media_type === 'external_video' && m.external_id) {
            md.push({ p: m.position, t: 'ext', host: m.host, id: m.external_id, img: m.preview_image && m.preview_image.src });
          }
        });
        qvJsMediaCache[handle] = md;
        // Still looking at this product? Slot the videos in now.
        if (qvActiveCard === card && md.length) refreshQuickViewGallery();
      })
      .catch(function() { qvJsMediaCache[handle] = []; });
  }
  // /products/<handle>.js media (used by the clip popup): same entry shape
  function qvEntriesFromJsMedia(media, fallbackImages) {
    var out = [];
    (media || []).forEach(function(m) {
      if (!m) return;
      if (m.media_type === 'image' && m.src) out.push({ t: 'image', src: qvNormUrl(m.src) });
      else if (m.media_type === 'video') {
        var best = null;
        (m.sources || []).forEach(function(s) {
          if (s.format !== 'mp4') return;
          if (!best || (s.height <= 720 && (best.height > 720 || s.height > best.height))) best = s;
        });
        if (best) out.push({ t: 'video', src: qvNormUrl(best.url), img: qvNormUrl(m.preview_image && m.preview_image.src) });
      } else if (m.media_type === 'external_video' && m.external_id) {
        out.push({ t: 'ext', host: m.host || '', id: String(m.external_id), img: qvNormUrl(m.preview_image && m.preview_image.src) });
      }
    });
    if (!out.length) (fallbackImages || []).forEach(function(s) { out.push({ t: 'image', src: qvNormUrl(s) }); });
    return out;
  }
  function qvExtEmbedUrl(e) {
    if (/vimeo/i.test(e.host)) return 'https://player.vimeo.com/video/' + encodeURIComponent(e.id) + '?autoplay=1&muted=1&playsinline=1';
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(e.id) + '?autoplay=1&mute=1&playsinline=1&rel=0';
  }
  // Stop whatever is playing (gallery step away, close): no background download.
  function qvStopVideo() {
    var v = $('xbb-qv-main-video');
    if (v) { try { v.pause(); } catch (e) {} v.removeAttribute('src'); v.removeAttribute('poster'); try { v.load(); } catch (e) {} v.hidden = true; }
    var x = $('xbb-qv-main-ext');
    if (x) { x.innerHTML = ''; x.hidden = true; }
  }

  // ─── Quick-view image performance ────────────────────
  // qvImages holds the ORIGINAL CDN urls straight out of products.json — often
  // 2000-3000px and hundreds of KB each. Every left/right press was therefore
  // downloading a full-resolution original, which is what made stepping through
  // the gallery feel slow. Two fixes:
  //   1. request a modal-sized render (Shopify resizes + caches server-side),
  //   2. pre-warm the neighbours so the next press is already in cache.
  var QV_IMG_W = 1200;
  var qvPreloadCache = {};   // url -> Image, kept referenced so it isn't evicted
  function qvSrc(src) { return cdnImg(src, QV_IMG_W); }
  function qvPreload(entry) {
    var src = typeof entry === 'string' ? entry : qvEntryImg(entry);
    if (!src) return;
    var url = qvSrc(src);
    if (qvPreloadCache[url]) return;
    var im = new Image();
    try { im.decoding = 'async'; } catch (e) {}
    im.src = url;              // same URL the <img> will use → guaranteed cache hit
    qvPreloadCache[url] = im;
  }
  // Warm the next few FORWARD first (people step 1→2→3→4, so a single-neighbour
  // window gets out-run by fast clicking on a 13-photo gallery), plus one back;
  // the rest of the gallery follows once the browser is idle so it never competes
  // with them.
  function qvWarmAround(idx) {
    var n = qvImages.length;
    if (!n) return;
    for (var step = 1; step <= 3 && step < n; step++) {
      qvPreload(qvImages[(idx + step) % n]);
    }
    qvPreload(qvImages[(idx - 1 + n) % n]);
    var rest = function() { qvImages.forEach(qvPreload); };
    if (window.requestIdleCallback) { requestIdleCallback(rest, { timeout: 1500 }); }
    else { setTimeout(rest, 400); }
  }

  // `fresh` = we just opened a DIFFERENT product (not a gallery step).
  function updateQuickViewImage(fresh) {
    var entry = qvImages[qvIndex] || null;
    var img = $('xbb-qv-main-img');
    // Video entries take over the stage: the <img> is hidden, the <video> (or the
    // YouTube/Vimeo iframe) gets the source and starts muted; stepping away stops
    // it again so nothing keeps downloading behind a photo.
    if (entry && entry.t !== 'image') {
      if (img) { img.hidden = true; img.classList.remove('is-swapping'); }
      qvStopVideo();
      if (entry.t === 'video') {
        var vid = $('xbb-qv-main-video');
        if (vid) {
          if (entry.img) vid.poster = cdnImg(entry.img, 800);
          vid.src = entry.src;
          vid.hidden = false;
          var pl = vid.play(); if (pl && pl.catch) pl.catch(function() {});
        }
      } else {
        var ext = $('xbb-qv-main-ext');
        if (ext) {
          ext.innerHTML = '<iframe src="' + esc(qvExtEmbedUrl(entry)) + '" title="video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
          ext.hidden = false;
        }
      }
      qvWarmAround(qvIndex);
      var thumbsV = document.querySelectorAll('.xbb-qv__thumb');
      for (var tv = 0; tv < thumbsV.length; tv++) {
        thumbsV[tv].classList.toggle('is-active', parseInt(thumbsV[tv].dataset.thumbIndex, 10) === qvIndex);
      }
      updateQuickViewCounter();
      return;
    }
    qvStopVideo();
    if (img) img.hidden = false;
    var src = entry ? entry.src : '';
    if (img) {
      if (src) {
        var url = qvSrc(src);
        // Setting .src leaves the OLD image painted until the new one decodes —
        // which is why the previous product flashed for a moment. Blank it across
        // the swap, but only when the new URL isn't already warm: a pre-warmed
        // neighbour paints instantly, so blanking there would ADD a flicker.
        // onerror clears it too, otherwise a failed image would stay invisible.
        if (url !== img.getAttribute('src')) {
          img.onload = img.onerror = function() { img.classList.remove('is-swapping'); };
          if (fresh || !qvPreloadCache[url]) img.classList.add('is-swapping');
          try { img.fetchPriority = 'high'; } catch (e) {}
          img.src = url;
        }
      }
      else {
        img.removeAttribute('src'); // avoid implicit reload of current URL
        img.classList.remove('is-swapping');
      }
    }
    qvWarmAround(qvIndex);
    // Update active state on thumbs
    var thumbs = document.querySelectorAll('.xbb-qv__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', parseInt(thumbs[i].dataset.thumbIndex, 10) === qvIndex);
    }
    updateQuickViewCounter();
  }

  function updateQuickViewCounter() {
    var counterEl = $('xbb-qv-counter');
    if (counterEl && qvImages.length > 1) {
      counterEl.textContent = (qvIndex + 1) + ' / ' + qvImages.length;
    }
  }

  function renderQuickViewThumbs() {
    var thumbsEl = $('xbb-qv-thumbs');
    if (!thumbsEl) return;
    if (qvImages.length <= 1) {
      thumbsEl.innerHTML = '';
      thumbsEl.style.display = 'none';
      return;
    }
    thumbsEl.style.display = '';
    thumbsEl.innerHTML = qvImages.map(function(e, i) {
      var isVid = e.t !== 'image';
      var src = qvEntryImg(e);
      return '<button type="button" class="xbb-qv__thumb' + (isVid ? ' xbb-qv__thumb--video' : '') + (i === qvIndex ? ' is-active' : '') + '" data-thumb-index="' + i + '" aria-label="' + (isVid ? 'Video' : 'Image') + ' ' + (i + 1) + '">' +
        (src ? '<img src="' + esc(cdnImg(src, 160)) + '" alt="" loading="lazy" decoding="async">' : '') +
        (isVid ? '<span class="xbb-qv__thumb-play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' : '') +
      '</button>';
    }).join('');
  }

  // Re-derive the open quick view's gallery (a facet payload landed after it
  // opened). Keeps the shopper on the slide they were looking at.
  function refreshQuickViewGallery() {
    var modal = $('xbb-qv');
    if (!modal || !modal.classList.contains('show') || !qvActiveCard) return;
    var cur = qvImages[qvIndex] || null;
    var photos = [];
    try { photos = JSON.parse(qvActiveCard.dataset.images || '[]'); } catch (e) { photos = []; }
    if (!photos.length && qvActiveCard.dataset.productImg) photos = [qvActiveCard.dataset.productImg];
    qvImages = qvBuildGallery(photos, qvRowFor(qvActiveCard.dataset.productHandle || ''));
    var keep = -1;
    if (cur) {
      for (var k = 0; k < qvImages.length; k++) {
        var e = qvImages[k];
        if (e.t === cur.t && e.src === cur.src && e.id === cur.id) { keep = k; break; }
      }
    }
    qvIndex = keep >= 0 ? keep : 0;
    renderQuickViewThumbs();
    var multi = qvImages.length > 1;
    var counterEl = $('xbb-qv-counter');
    if (counterEl) counterEl.hidden = !multi;
    $('xbb-qv-prev').style.display = multi ? '' : 'none';
    $('xbb-qv-next').style.display = multi ? '' : 'none';
    updateQuickViewImage(false);
  }

  function nextQuickViewImage() {
    if (!qvImages.length) return;
    qvIndex = (qvIndex + 1) % qvImages.length;
    updateQuickViewImage();
  }

  function prevQuickViewImage() {
    if (!qvImages.length) return;
    qvIndex = (qvIndex - 1 + qvImages.length) % qvImages.length;
    updateQuickViewImage();
  }

  function closeQuickView() {
    var modal = $('xbb-qv');
    qvStopVideo();
    qvResetReviews();
    modal.classList.remove('show');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.style.cssText = '';
    document.body.style.overflow = '';
    clearTimeout(openQuickView._safety);
    qvActiveCard = null;
  }

  // ─── Upsell prompt (1 item away from a discount tier) ──
  // Stores the user's intended action (continue to cart) so the popup can
  // either bounce them to the extras step or proceed with their original plan.
  var _upsellOnContinue = null;

  function maybeShowUpsell(onContinue) {
    var n = itemCount();
    var state = computeDiscountState(n);
    // Skip when discount disabled, no tiers, no next tier (max reached),
    // or more than 1 item from next tier (too aggressive to nag).
    if (!state.active || !state.next || (state.next.min - n) !== 1) {
      onContinue();
      return;
    }
    // What does one more item actually gain on the set AS IT STANDS? The same
    // per-line rounding as checkout, so the promised number is the real one.
    // (The new item's own discount comes on top; promising only the certain
    // part keeps the line honest whatever they pick.)
    var curPct = state.current ? state.current.pct : 0;
    var extraCents = 0;
    try { extraCents = Math.max(0, discountCentsTotal(state.next.pct) - discountCentsTotal(curPct)); } catch (e) {}
    showUpsell(state.next.pct, onContinue, extraCents);
  }

  function showUpsell(pct, onContinue, extraCents) {
    _upsellOnContinue = onContinue;
    var modal = $('xbb-upsell');
    if (!modal) { onContinue(); return; }
    var titleEl = $('xbb-upsell-title');
    var subEl = $('xbb-upsell-sub');
    if (titleEl && t.upsellTitle) {
      // The percentage is the whole argument; let it stand out in the title.
      var tt = esc(t.upsellTitle(pct));
      var pctTxt = esc(pct + '%');
      titleEl.innerHTML = tt.indexOf(pctTxt) !== -1
        ? tt.replace(pctTxt, '<span class="xbb-upsell__pct">' + pctTxt + '</span>')
        : tt;
    }
    if (subEl) {
      if (extraCents > 0 && t.upsellSaving) {
        var amt = money(extraCents);
        var line = esc(t.upsellSaving(amt));
        subEl.innerHTML = line.indexOf(esc(amt)) !== -1
          ? line.replace(esc(amt), '<strong class="xbb-upsell__amt">' + esc(amt) + '</strong>')
          : line;
      } else if (t.upsellSub) {
        subEl.textContent = t.upsellSub;
      }
    }
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    // Bulletproof: force visibility via inline styles so theme CSS can't hide it.
    // Also reparent to <body> in case a section ancestor has overflow:hidden or
    // a transform that traps position:fixed children inside a stacking context.
    modal.style.cssText = 'display:flex !important;position:fixed !important;inset:0 !important;z-index:2147483647 !important;opacity:1 !important;align-items:center;justify-content:center;padding:1rem;';
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    document.body.style.overflow = 'hidden';
    // Safety net: if something prevents close, restore overflow after 60s.
    clearTimeout(showUpsell._safety);
    showUpsell._safety = setTimeout(function() {
      if (modal.classList.contains('show')) hideUpsell();
    }, 60000);
  }

  function hideUpsell() {
    var modal = $('xbb-upsell');
    if (!modal) return;
    modal.classList.remove('show');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.style.cssText = '';
    document.body.style.overflow = '';
    clearTimeout(showUpsell._safety);
  }

  (function setupQuickViewSwipe() {
    var area = document.querySelector('#xbb-qv .xbb-qv__main');
    if (!area) return;
    var startX = 0, startY = 0, tracking = false;
    area.addEventListener('touchstart', function(e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    area.addEventListener('touchend', function(e) {
      if (!tracking) return;
      tracking = false;
      if (qvImages.length < 2) return;
      var tch = e.changedTouches && e.changedTouches[0];
      if (!tch) return;
      var dx = tch.clientX - startX;
      var dy = tch.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      if (dx < 0) nextQuickViewImage(); else prevQuickViewImage();
    }, { passive: true });
  })();

  // Close on Escape + arrow nav inside quick view modal
  document.addEventListener('keydown', function(ev) {
    var upsellOpen = $('xbb-upsell') && $('xbb-upsell').classList.contains('show');
    if (ev.key === 'Escape' && upsellOpen) {
      hideUpsell();
      _upsellOnContinue = null;
      return;
    }
    var qvOpen = $('xbb-qv') && $('xbb-qv').classList.contains('show');
    if (ev.key === 'Escape' && qvOpen) {
      closeQuickView();
      return;
    }
    if (qvOpen && qvImages.length > 1) {
      if (ev.key === 'ArrowRight') { ev.preventDefault(); nextQuickViewImage(); return; }
      if (ev.key === 'ArrowLeft')  { ev.preventDefault(); prevQuickViewImage(); return; }
    }
    // Activate product card (div with role="button") on Enter or Space
    if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
      var pcard = ev.target.closest && ev.target.closest('.xbb-pcard[role="button"]');
      if (pcard && ev.target === pcard) {
        ev.preventDefault();
        pcard.click();
      }
    }
  });

  // ─── Click delegation ───────────────────────────────
  document.addEventListener('click', function(ev) {

    // quick view: rating -> compact reviews panel; its X closes the panel
    var qvRev = ev.target.closest('[data-qv-reviews]');
    if (qvRev) { ev.preventDefault(); toggleQvReviews(qvRev); return; }
    var revNav = ev.target.closest('[data-rev-nav]');
    if (revNav) {
      ev.preventDefault();
      var revWrap = revNav.closest('.xbb-qv__revwrap');
      var navRow = revWrap && revWrap.querySelector('.xbb-qv__revrow');
      if (navRow) {
        navRow.scrollBy({ left: Number(revNav.getAttribute('data-rev-nav')) * revStep(navRow), behavior: 'smooth' });
      }
      return;
    }
    var revMore = ev.target.closest('[data-rev-more]');
    if (revMore) {
      ev.preventDefault();
      var rc0 = revMore.closest('.xbb-qv__revcard');
      if (rc0) { rc0.classList.toggle('is-open'); revMore.textContent = rc0.classList.contains('is-open') ? t.reviewsLess : t.reviewsMore; }
      return;
    }
    if (ev.target.closest('[data-qv-reviews-close]')) {
      ev.preventDefault();
      var rb = document.querySelector('#xbb-qv [data-qv-reviews]');
      var rp = document.getElementById('xbb-qv-reviews');
      if (rp) rp.hidden = true;
      if (rb) rb.setAttribute('aria-expanded', 'false');
      return;
    }

    // clip tile / "see the clip" link in the cord-step notification -> clip popup
    if (ev.target.closest('[data-cordgift-open]')) {
      ev.preventDefault();
      openClipQuickView();
      return;
    }

    // returning-shopper banner — continue dismisses, reset clears + reloads
    if (ev.target.closest('#xbb-resume-continue')) {
      ev.preventDefault();
      // Restore the items / step / totals right here on the page (they were
      // deliberately NOT shown on first load, so the page looked fresh until the
      // shopper chose to resume). No reload — see resumeSavedBundle().
      resumeSavedBundle();
      return;
    }
    if (ev.target.closest('#xbb-resume-reset')) {
      ev.preventDefault();
      clearPersistedState();
      try { sessionStorage.removeItem('xbb_resume_confirmed'); } catch (e) {}
      // Hard reload — simplest way to fully reset every JS state + visible UI
      window.location.reload();
      return;
    }

    // grid density toggle — flips every grid into 1- or 2-per-row layout
    var densityBtn = ev.target.closest('[data-density]');
    if (densityBtn) {
      ev.preventDefault();
      var d = densityBtn.dataset.density;
      if (d && d !== S.gridDensity) {
        S.gridDensity = d;
        applyGridDensity();
      }
      return;
    }

    // grid sort toggle — re-orders all known product grids
    var sortBtn = ev.target.closest('[data-sort]');
    if (sortBtn) {
      ev.preventDefault();
      var sortMode = sortBtn.dataset.sort;
      if (sortMode && sortMode !== S.gridSort) {
        S.gridSort = sortMode;
        syncSortButtons();
        ['xbb-step-1-products', 'xbb-step-2-products', 'xbb-step-3-products'].forEach(applyGridSort);
        persistState();
      }
      return;
    }

    // quick view: backdrop tap or close button (any element with data-qv-close)
    if (ev.target.closest('[data-qv-close]')) {
      ev.preventDefault();
      closeQuickView();
      return;
    }

    // quick view: previous image
    if (ev.target.closest('#xbb-qv-prev')) {
      ev.preventDefault();
      prevQuickViewImage();
      return;
    }
    // quick view: next image
    if (ev.target.closest('#xbb-qv-next')) {
      ev.preventDefault();
      nextQuickViewImage();
      return;
    }
    // quick view: thumbnail click
    var thumbBtn = ev.target.closest('.xbb-qv__thumb');
    if (thumbBtn) {
      ev.preventDefault();
      qvIndex = parseInt(thumbBtn.dataset.thumbIndex, 10) || 0;
      updateQuickViewImage();
      return;
    }

    // quick view: add to bundle from inside the modal
    if (ev.target.closest('#xbb-qv-add')) {
      ev.preventDefault();
      if (qvActiveCard) {
        handleProductClick(qvActiveCard);
        closeQuickView();
      }
      return;
    }

    // Drawer mobile back button
    if (ev.target.closest('#xbb-drawer-back')) {
      ev.preventDefault();
      ev.stopPropagation();
      handleDrawerBack();
      return;
    }

    // "Still to unlock" rows. Each reward sends the customer somewhere different:
    // the free clip needs a cord (step 2), the discount needs another product
    // (the extras step). On mobile these live in the expanded drawer, so collapse
    // it first — mirrors the upsell-add handler — or the destination is hidden
    // behind the drawer.
    var unlockRow = ev.target.closest('[data-unlock]');
    if (unlockRow) {
      ev.preventDefault();
      var unlockDrawer = $('xbb-drawer-mobile');
      if (unlockDrawer && unlockDrawer.classList.contains('expanded')) closeMobileDrawer();
      if (unlockRow.dataset.unlock === 'clip') {
        goToStep(2);
      } else if (S.maxStep >= 3) {
        // Only jump to the extras step if they've already been there; forcing a
        // step change from step 1 would skip the flow's own guards.
        goToStep(3);
      } else {
        var extras = $('xbb-step-3a');
        if (extras && extras.offsetParent !== null) {
          // Same top offset as the step navigation, so it can't land behind the
          // sticky stepper on mobile.
          var ey = Math.max(0, docTop(extras) - topChromeHeight());
          try { window.scrollTo({ top: ey, behavior: 'smooth' }); }
          catch (e) { window.scrollTo(0, ey); }
        }
      }
      return;
    }

    // Upsell modal: close (X / backdrop)
    if (ev.target.closest('[data-upsell-close]')) {
      ev.preventDefault();
      hideUpsell();
      _upsellOnContinue = null;
      return;
    }
    // Upsell modal: Add 1 more → close + jump to extras step
    if (ev.target.closest('[data-upsell-add]')) {
      ev.preventDefault();
      hideUpsell();
      _upsellOnContinue = null;
      showSubstep('xbb-step-3', 'xbb-step-3a');
      // On mobile the upsell can be triggered from the EXPANDED drawer's CTA —
      // collapse it so the category grid is actually visible (mirrors the
      // discount-hint tap handler).
      var upDrawer = $('xbb-drawer-mobile');
      if (upDrawer && upDrawer.classList.contains('expanded')) closeMobileDrawer();
      return;
    }
    // Upsell modal: Continue anyway → run the stored continuation
    if (ev.target.closest('[data-upsell-continue]')) {
      ev.preventDefault();
      hideUpsell();
      var cont = _upsellOnContinue;
      _upsellOnContinue = null;
      if (typeof cont === 'function') cont();
      return;
    }

    // quick view: open trigger on a product card (eye icon)
    var qvBtn = ev.target.closest('[data-quickview]');
    if (qvBtn) {
      ev.preventDefault();
      ev.stopPropagation();
      var card = qvBtn.closest('.xbb-pcard');
      if (card) openQuickView(card);
      return;
    }

    // generation chip
    var genBtn = ev.target.closest('[data-gen]');
    if (genBtn) {
      ev.preventDefault();
      S.activeGen = genBtn.dataset.gen;
      clearModelSearch(true);           // a gen pick supersedes any active search
      $$('.xbb-gen-chip', $('xbb-gen-chips')).forEach(function(c) {
        c.classList.toggle('active', c.dataset.gen === S.activeGen);
      });
      renderModels();
      persistState();
      return;
    }

    // brand toggle (iPhone / Samsung) — filters gens + models
    var brandBtn = ev.target.closest('.xbb-brand-toggle__btn');
    if (brandBtn) {
      ev.preventDefault();
      var newBrand = brandBtn.dataset.brand;
      if (newBrand && newBrand !== S.activeBrand) {
        S.activeBrand = newBrand;
        S.activeGen = null; // let renderGenChips pick the first gen of this brand
        clearModelSearch(true); // reset the device search when the platform changes
        syncBrandButtons();
        renderGenChips();
        renderModels();
        syncGenChipActive();
        updateProgressForCaseType();
        updateStep1NextLabel();
        updateCtaState();
        persistState();
      }
      return;
    }

    // case-type toggle (with cord / without cord)
    var ctBtn = ev.target.closest('[data-case-type]');
    if (ctBtn) {
      ev.preventDefault();
      var newType = ctBtn.dataset.caseType;
      if (newType === S.caseType) return;
      $$('.xbb-case-type__btn').forEach(function(b) {
        var match = b.dataset.caseType === newType;
        b.classList.toggle('active', match);
        b.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      S.caseType = newType;

      // NOTE: switching the cord filter must NOT wipe the customer's set.
      // It only changes which product source the grid shows; cases already
      // chosen (incl. one pre-selected via a deep-link) stay in the tray.
      // Cards that don't belong to the newly shown grid simply won't render
      // a "selected" badge — refreshProductCardsSelectedState reconciles that
      // after the reload. The Continue button tracks the real case count.
      $('xbb-next-1').disabled = !S.cases.length;

      // Re-load step 1b products from the right source
      if (S.model) loadStep1Products();

      updateProgressForCaseType();
      updateStep1NextLabel();
      refreshTray();
      refreshProductCardsSelectedState();
      return;
    }

    // model tile
    var modelBtn = ev.target.closest('[data-model]');
    if (modelBtn) {
      ev.preventDefault();
      var handle = modelBtn.dataset.model;
      var title = modelBtn.dataset.title;
      var img = modelBtn.dataset.img;
      S.model = { handle: handle, title: title, image_url: img };
      clearModelSearch(true); // leave step-1a with a clean search box for next time
      // Default to "Zonder koord" on every new model click. If the model only
      // carries with-cord products, the loader will auto-switch in the load
      // callback. Ensures the first thing customers see is the cordless set.
      S.caseType = 'without';
      syncCaseTypeButtons();
      updateStep1NextLabel();
      updateProgressForCaseType();
      $('xbb-step-1b-title').textContent = title;
      // The customer has now chosen a phone by hand, so the "we auto-selected
      // this for you" notice is both redundant and (if they corrected a wrong
      // guess) wrong — retire it for the rest of the session.
      var apNotice = $('xbb-autopick');
      if (apNotice) apNotice.hidden = true;
      var apEyebrow = $('xbb-autopick-eyebrow');
      if (apEyebrow && apEyebrow.dataset.defaultLabel) apEyebrow.textContent = apEyebrow.dataset.defaultLabel;
      showSubstep('xbb-step-1', 'xbb-step-1b');
      loadStep1Products();
      refreshTray();
      return;
    }

    // subcategory tile
    var subBtn = ev.target.closest('[data-subcat]');
    if (subBtn) {
      ev.preventDefault();
      handleSubcatClick(subBtn);
      return;
    }

    // Extra-cases cord-type toggle (With cord / No cord)
    var cordBtn = ev.target.closest('[data-extra-cord]');
    if (cordBtn) {
      ev.preventDefault();
      var pick = cordBtn.dataset.extraCord;
      if (pick !== S.extraCasesCord) {
        S.extraCasesCord = pick;
        syncExtraCasesCordButtons();
        loadExtraCasesGrid();
      }
      return;
    }


    // airpods nested model
    var apBtn = ev.target.closest('[data-airpods-model]');
    if (apBtn) {
      ev.preventDefault();
      var apHandle = apBtn.dataset.airpodsModel;
      S.accessoryAirpodsModel = apHandle;
      var apModel = (stepConfig[3].nested.airpods_by_model || []).find(function(m) { return m.handle === apHandle; });
      $('xbb-step-3b-title').textContent = apModel ? apModel.title : '';
      // Model switcher + cord toggle are cases-only — keep them hidden here
      var apModelSwitch = $('xbb-extra-cases-model-switch');
      if (apModelSwitch) apModelSwitch.classList.add('xbb-hidden');
      setExtraCasesCordToggle(false);
      showSubstep('xbb-step-3', 'xbb-step-3b');
      var grid3 = $('xbb-step-3-products');
      loadCollection(apHandle, grid3, function(products) {
        renderGrid(withColorMatching(products || []), grid3, 'xbb-step-3-products', { colorFilter: true });
      });
      return;
    }

    // product card
    var pcard = ev.target.closest('.xbb-pcard');
    if (pcard) {
      ev.preventDefault();
      handleProductClick(pcard);
      return;
    }

    // progress step navigation — click any visited step to jump there
    var progStep = ev.target.closest('.xbb-prog-step');
    if (progStep && progStep.classList.contains('done')) {
      ev.preventDefault();
      var targetStep = parseInt(progStep.dataset.prog, 10);
      if (targetStep && targetStep !== S.step) {
        if (targetStep === 1) {
          goToStep(1);
          // Restore the case grid if a case was picked, otherwise the model picker
          showSubstep('xbb-step-1', S.case ? 'xbb-step-1b' : 'xbb-step-1a');
        } else if (targetStep === 2) {
          // Step 2 doesn't exist in the with-cord path
          if (S.caseType !== 'with') goToStep(2);
        } else if (targetStep === 3) {
          goToStep(3);
        }
      }
      return;
    }

    // back
    var back = ev.target.closest('[data-back]');
    if (back) { ev.preventDefault(); handleBack(back.dataset.back); return; }

    // cord-length tab
    var cordTab = ev.target.closest('[data-cord-len]');
    if (cordTab) {
      ev.preventDefault();
      $$('.xbb-tab', cordTab.parentElement).forEach(function(t) { t.classList.remove('active'); });
      cordTab.classList.add('active');
      S.cordLength = cordTab.dataset.cordLen;
      loadCordTab(S.cordLength);
      return;
    }

    // load-more buttons
    var loadMore = ev.target.closest('.xbb-load-more');
    if (loadMore) {
      ev.preventDefault();
      var map = {
        'xbb-load-more-1': 'xbb-step-1-products',
        'xbb-load-more-2': 'xbb-step-2-products',
        'xbb-load-more-3': 'xbb-step-3-products'
      };
      var gridId = map[loadMore.id];
      if (gridId) showMore(gridId);
      return;
    }

    // tray / drawer line item buttons
    var qtyBtn = ev.target.closest('[data-line-qty]');
    if (qtyBtn) {
      ev.preventDefault();
      handleQtyClick(qtyBtn);
      return;
    }
    var removeBtn = ev.target.closest('[data-line-remove]');
    if (removeBtn) {
      ev.preventDefault();
      handleRemoveLine(removeBtn.dataset.lineRemove);
      return;
    }

    // (Note: Extra-cases model switcher is handled by a separate `change`
    // listener bound below — selects don't fire `click` reliably.)

    // Colour filter "scroll next" button — explicit tap target replaces
    // the decorative chevron so customers can advance through colours by
    // clicking instead of having to swipe.
    var colorNext = ev.target.closest('.xbb-color-filter__next');
    if (colorNext) {
      ev.preventDefault();
      ev.stopPropagation();
      var trackEl = colorNext.parentNode && colorNext.parentNode.querySelector('.xbb-color-filter__track');
      if (trackEl) {
        // Scroll one viewport's worth of chips so several new colours come
        // into view per tap. clientWidth × 0.7 keeps a couple visible from
        // the prior view so the customer doesn't lose their place.
        trackEl.scrollBy({ left: Math.max(80, Math.round(trackEl.clientWidth * 0.7)), behavior: 'smooth' });
      }
      return;
    }

    // Discount hint as a CTA — when the customer is one (or more) products
    // away from a higher tier, tapping the hint takes them to step 3's
    // category picker so they can add another product instead of bouncing
    // straight to cart.
    var discHintTap = ev.target.closest('.xbb-disc--has-next .xbb-disc__hint, .xbb-disc-strip--has-next .xbb-disc-strip__hint');
    if (discHintTap) {
      ev.preventDefault();
      ev.stopPropagation();
      if (S.step !== 3) goToStep(3);
      showSubstep('xbb-step-3', 'xbb-step-3a');
      // On mobile, also collapse the drawer so the categories are visible.
      var drExp = $('xbb-drawer-mobile');
      if (drExp && drExp.classList.contains('expanded')) closeMobileDrawer();
      return;
    }

    // Drawer toggle button — explicit open/close, no swipe gestures
    if (ev.target.closest('#xbb-drawer-toggle')) {
      ev.preventDefault();
      var drawerEl = $('xbb-drawer-mobile');
      if (drawerEl && drawerEl.classList.contains('expanded')) {
        closeMobileDrawer();
      } else {
        var anyT = S.cases.length > 0 || S.cords.length > 0 || S.accessories.length > 0;
        if (anyT) openMobileDrawer();
      }
      return;
    }
    // mobile drawer bar tap (open) — still works as a secondary affordance
    var drawerBar = ev.target.closest('#xbb-drawer-bar, #xbb-disc-strip');
    if (drawerBar && !$('xbb-drawer-mobile').classList.contains('expanded')) {
      var any = S.cases.length > 0 || S.cords.length > 0 || S.accessories.length > 0;
      if (any && !ev.target.closest('#xbb-drawer-cta')) {
        ev.preventDefault();
        openMobileDrawer();
        return;
      }
    }
    // mobile drawer close (× button inside the expanded view)
    if (ev.target.closest('#xbb-drawer-close')) {
      ev.preventDefault();
      closeMobileDrawer();
      return;
    }
    // backdrop click
    if (ev.target.id === 'xbb-drawer-backdrop') {
      ev.preventDefault();
      closeMobileDrawer();
      return;
    }
  });

  // ─── Change-event delegation (selects, etc) ─────────
  document.addEventListener('change', function(ev) {
    // Product-card variant select: keep the card's stock state in sync so a
    // partially-sold-out product un-dims the moment an in-stock variant is
    // chosen. (Sold-out options are disabled, so the reverse transition can
    // only happen programmatically — the add guard covers that regardless.)
    var vSel = ev.target.closest && ev.target.closest('select[data-product]');
    if (vSel) {
      var vCard = vSel.closest('.xbb-pcard');
      var vOpt = vSel.options[vSel.selectedIndex];
      if (vCard && vOpt) {
        var vOk = vOpt.dataset.available !== '0';
        vCard.dataset.variantAvailable = vOk ? '1' : '0';
        vCard.classList.toggle('xbb-pcard--oos', !vOk);
        if (vOk) vCard.removeAttribute('aria-disabled');
        else vCard.setAttribute('aria-disabled', 'true');
        var ribbon = vCard.querySelector('.xbb-pcard__oos');
        if (ribbon) ribbon.style.display = vOk ? 'none' : '';
      }
      return;
    }
    // Extra-cases model switcher → reload that grid for the new model
    var modelSel = ev.target.closest && ev.target.closest('[data-extra-cases-model]');
    if (modelSel) {
      setExtraCasesModel(modelSel.value);
      return;
    }
    // Smart device model selector → re-filter the current extras grid by the
    // chosen model (empty value = "Mijn model" / bundle-case driven).
    var smartSel = ev.target.closest && ev.target.closest('[data-smart-device-model]');
    if (smartSel) {
      S.smartDeviceOverride = smartSel.value || '';
      reloadCurrentExtrasGrid();
      return;
    }
  });

  function shouldShowColorFilter(subcat) {
    if (subcat === 'screenprotectors') return false; // Already hidden globally

    // Hide colour filter on mobile for utility/tech categories where it adds noise
    var utilitySubcats = ['magsafe-accessoires', 'cables-and-adapters'];
    if (utilitySubcats.indexOf(subcat) !== -1) {
      if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) return false;
    }
    return true;
  }

  function reloadCurrentExtrasGrid() {
    var grid = $('xbb-step-3-products');
    if (!grid || !S.activeSubcat) return;
    if (S.activeSubcat === 'screenprotectors') {
      loadMergedScreenProtectors(grid);
      return;
    }
    loadCollection(S.activeSubcat, grid, function(products) {
      _currentExtrasAllProducts = products || [];
      buildSmartDeviceModelOptions();
      var filtered = applySmartDeviceFilter(products);
      renderGrid(withColorMatching(filtered || []), grid, 'xbb-step-3-products', { colorFilter: shouldShowColorFilter(S.activeSubcat) });
    });
  }

  // Products currently loaded for the active extras subcategory. Drives the
  // dropdown so the customer never sees a model that the current category
  // has zero products for (e.g. Galaxy S24+ shouldn't appear under Screen
  // protectors if no protector products mention it).
  var _currentExtrasAllProducts = [];

  // Build dropdown options for the smart device model selector.
  //
  // First entry adapts to the bundle's state:
  //   • With a case (or a phone model selected) → "Mijn model" — narrows to
  //     whatever's already in the bundle.
  //   • No bundle context (skipped case + skipped model picker) → "Alle
  //     modellen" — the "Mijn model" anchor would be meaningless here.
  // Followed by every model from stepConfig[1].models that actually has at
  // least one matching product in the currently-loaded set.
  function buildSmartDeviceModelOptions() {
    var sel = $('xbb-smart-device-model');
    if (!sel) return;
    var allModels = (stepConfig[1].models || []).slice();
    // Restrict to models that have at least one matching product in the
    // currently-loaded category. Each product is mapped to its single best
    // model (longest match wins) so iPhone 17 only appears when an actual
    // iPhone-17 product exists — iPhone 17 Pro products don't qualify it.
    var availableModels = allModels;
    // Safe to remove anytime — while products are still loading, show only
    // the default option instead of flashing the full phone-model list.
    if (!_currentExtrasAllProducts || _currentExtrasAllProducts.length === 0) {
      availableModels = [];
    }
    if (_currentExtrasAllProducts && _currentExtrasAllProducts.length > 0) {
      var presentHandles = {};
      _currentExtrasAllProducts.forEach(function(p) {
        var pm = findBestMatchModel(p && p.title, allModels);
        if (pm) presentHandles[pm.handle] = true;
      });
      availableModels = allModels.filter(function(m) { return presentHandles[m.handle]; });
    }
    // If the override is set to a model that no longer has products in the
    // current category, reset it so the grid doesn't render empty.
    if (S.smartDeviceOverride) {
      var stillAvailable = availableModels.some(function(m) { return m.handle === S.smartDeviceOverride; });
      if (!stillAvailable) S.smartDeviceOverride = '';
    }
    var hasBundleContext = !!(S.case || (S.model && S.model.title));
    var defaultLabel = hasBundleContext
      ? ((lang === 'de') ? 'Mein Modell'
         : (lang === 'en') ? 'My model'
         : (lang === 'fr') ? 'Mon modèle'
         : 'Mijn model')
      : ((lang === 'de') ? 'Alle Modelle'
         : (lang === 'en') ? 'All models'
         : (lang === 'fr') ? 'Tous les modèles'
         : 'Alle modellen');
    // Safe to remove anytime — append the resolved model name(s) so
    // "Mijn model" is self-explanatory, e.g. "Mijn model (Galaxy S24
    // Ultra)". Mirrors the resolution in applySmartDeviceFilter so the
    // label always names exactly what the filter targets.
    try {
      if (hasBundleContext) {
        var lblTitles = [];
        if (S.case) {
          if (S.case.variantTitle) lblTitles.push(S.case.variantTitle);
          if (S.case.title) lblTitles.push(S.case.title);
        }
        if (S.cases && S.cases.length > 0) {
          S.cases.forEach(function(c) {
            if (c.variantTitle) lblTitles.push(c.variantTitle);
            if (c.title) lblTitles.push(c.title);
          });
        }
        if (S.model && S.model.title) lblTitles.push(S.model.title);
        var lblNames = [];
        lblTitles.forEach(function(t) {
          var lm = findBestMatchModel(t, allModels);
          if (lm && lblNames.indexOf(lm.title) === -1) lblNames.push(lm.title);
        });
        if (lblNames.length > 0) {
          defaultLabel += ' (' + lblNames.slice(0, 2).join(' / ') +
            (lblNames.length > 2 ? ' +' + (lblNames.length - 2) : '') + ')';
        }
      }
    } catch (e) {}
    var current = S.smartDeviceOverride || '';
    var html = '<option value=""' + (current === '' ? ' selected' : '') + '>' + esc(defaultLabel) + '</option>';
    availableModels.forEach(function(m) {
      var isSel = (current === m.handle) ? ' selected' : '';
      html += '<option value="' + esc(m.handle) + '"' + isSel + '>' + esc(m.title) + '</option>';
    });
    sel.innerHTML = html;

    try {
      var switchWrap = $('xbb-smart-device-switch');
      if (switchWrap && !switchWrap.classList.contains('xbb-hidden')) {
        var xbbLoaded = _currentExtrasAllProducts && _currentExtrasAllProducts.length > 0;
        switchWrap.style.display = (xbbLoaded && availableModels.length === 0) ? 'none' : '';
      }
    } catch (e) {}
  }

  function xbbPulseDrawerBar() {
    try {
      var drawer = $('xbb-drawer-mobile');
      if (!drawer || !drawer.classList.contains('visible') || drawer.classList.contains('expanded')) return;
      var bar = $('xbb-drawer-bar');
      var badge = $('xbb-drawer-hero-badge');
      [bar, badge].forEach(function(el) {
        if (!el) return;
        el.classList.remove('xbb-pulse');
        void el.offsetWidth; // restart animation on rapid adds
        el.classList.add('xbb-pulse');
      });
      setTimeout(function() {
        if (bar) bar.classList.remove('xbb-pulse');
        if (badge) badge.classList.remove('xbb-pulse');
      }, 700);
      if (navigator.vibrate) navigator.vibrate(10);
    } catch (e) {}
  }

  // Freshest availability for the variant a card click would ADD. Prefers the
  // live product data behind the grid the card sits in; falls back to the
  // card's own select/dataset for stale or detached cards. Absent data fails
  // OPEN — a block only ever happens on an explicit available:false.
  function clickedVariantAvailable(card, handle, variantId) {
    var gridEl = card.closest('.xbb-pgrid');
    var list = (gridEl && fullProductLists[gridEl.id]) || [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (p && p.handle === handle) {
        var vs = p.variants || [];
        for (var j = 0; j < vs.length; j++) {
          if (String(vs[j].id) === String(variantId)) return variantAvailable(vs[j]);
        }
        break; // product found but variant unknown — fall back to the card
      }
    }
    var sel = card.querySelector('select[data-product]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset.available === '0') return false;
    }
    return card.dataset.variantAvailable !== '0';
  }

  // ─── Product click handler ──────────────────────────
  function handleProductClick(card) {
    try { var tg = card && card.closest && card.closest('.xbb-pgrid'); if (tg && tg.id) gridTouched[tg.id] = true; } catch (e) {}
    // Safe to remove anytime — snapshot the count so the end of this
    // function can tell an ADD apart from a removal/toggle-off.
    var xbbPrevCount = itemCount();
    var handle = card.dataset.productHandle;
    var variantId = card.dataset.variantId;
    var title = card.dataset.productTitle;
    var variantTitle = card.dataset.variantTitle || '';
    var img = card.dataset.productImg;
    var price = Math.round(parseFloat(card.dataset.productPrice) || 0);

    // honor variant select
    var sel = card.querySelector('select[data-product]');
    if (sel) {
      variantId = sel.value;
      var opt = sel.options[sel.selectedIndex];
      if (opt) {
        price = Math.round(parseFloat(opt.dataset.price) * 100);
        variantTitle = opt.dataset.variantTitle || opt.textContent.split(' · ')[0] || variantTitle;
      }
    }

    // ── Stock guard ──
    // Never ADD an unavailable variant, no matter what the card claimed —
    // cards can be stale. Toggling an already-selected line OFF stays
    // allowed: removal must always work, even for a line that sold out
    // after it was added.
    var alreadySelected =
      (S.step === 1 && S.cases.some(function(c) { return c.handle === handle && c.variantId === variantId; })) ||
      (S.step === 2 && S.cords.some(function(c) { return c.handle === handle && c.variantId === variantId; })) ||
      (S.step === 3 && S.accessories.some(function(a) { return a.handle === handle && a.variantId === variantId; }));
    if (!alreadySelected && !clickedVariantAvailable(card, handle, variantId)) {
      console.warn('[xoxo-bundle] blocked add of unavailable variant', handle, variantId);
      showToast(t.soldOut, true);
      return;
    }

    var product = { handle: handle, variantId: variantId, title: title, variantTitle: variantTitle, image: img, price: price };
    // Cordless case that needs a free Easy Cord Clip (captured here so later
    // stages don't need the product's tags). Persisted with the line.
    if (card.dataset.needsClip === '1') product.needsClip = true;

    // Hard validation: refuse to add malformed products to the bundle.
    // Without this, a stale/empty card or a 0-priced variant can slip into
    // S.cords/S.accessories, count toward the discount tier, and even reach
    // checkout — exactly the "phantom €0 koord" bug we hit at launch.
    if (!product.handle || !product.variantId || !product.title || !(product.price > 0)) {
      console.warn('[xoxo-bundle] rejected invalid product from click', product);
      return;
    }

    if (S.step === 1) {
      // multi-select cases (parity with cords/accessories steps).
      var caseIdx = S.cases.findIndex(function(c) { return c.handle === handle && c.variantId === variantId; });
      if (caseIdx >= 0) {
        S.cases.splice(caseIdx, 1);
        card.classList.remove('selected'); card.removeAttribute('data-qty');
      } else {
        product.qty = 1;
        S.cases.push(product);
        card.classList.add('selected'); card.setAttribute('data-qty', '1');
      }
      // Keep S.case mirrored to the first selected case for any code path
      // that still reads the singular form (model context, etc.).
      S.case = S.cases[0] || null;
      $('xbb-next-1').disabled = !S.cases.length;
    } else if (S.step === 2) {
      // multi-select cords, toggle
      var idx = S.cords.findIndex(function(c) { return c.handle === handle && c.variantId === variantId; });
      if (idx >= 0) {
        S.cords.splice(idx, 1);
        card.classList.remove('selected'); card.removeAttribute('data-qty');
      } else {
        product.qty = 1;
        S.cords.push(product);
        card.classList.add('selected'); card.setAttribute('data-qty', '1');
      }
    } else if (S.step === 3) {
      // multi-select accessories, toggle
      var idx2 = S.accessories.findIndex(function(a) { return a.handle === handle && a.variantId === variantId; });
      if (idx2 >= 0) {
        S.accessories.splice(idx2, 1);
        card.classList.remove('selected'); card.removeAttribute('data-qty');
      } else {
        product.qty = 1;
        product.subcat = S.activeSubcat;
        S.accessories.push(product);
        card.classList.add('selected'); card.setAttribute('data-qty', '1');
      }
    }
    refreshTray();
    try { if (itemCount() > xbbPrevCount) xbbPulseDrawerBar(); } catch (e) {}
  }

  function getActiveExtraCasesModel() {
    var models = (stepConfig[1].models || []);
    var hnd = S.extraCasesModel || (S.model && S.model.handle);
    return models.find(function(m) { return m.handle === hnd; }) || S.model || models[0] || null;
  }
  function setExtraCasesModel(handle) {
    var models = (stepConfig[1].models || []);
    var found = models.find(function(m) { return m.handle === handle; });
    if (!found) return;
    S.extraCasesModel = found.handle;
    persistState();
    loadExtraCasesGrid();
  }
  function buildExtraCasesModelOptions() {
    var sel = $('xbb-extra-cases-model');
    if (!sel) return;
    var models = (stepConfig[1].models || []).slice();
    var active = getActiveExtraCasesModel();
    sel.innerHTML = models.map(function(m) {
      var selected = (active && m.handle === active.handle) ? ' selected' : '';
      return '<option value="' + esc(m.handle) + '"' + selected + '>' + esc(m.title) + '</option>';
    }).join('');
  }
  function loadExtraCasesGrid() {
    var grid = $('xbb-step-3-products');
    if (!grid) return;
    var activeModel = getActiveExtraCasesModel();
    if (!activeModel) {
      setExtraCasesCordToggle(false);
      renderGrid([], grid, 'xbb-step-3-products');
      return;
    }
    // For Samsung models, surface every bundle-eligible product (cord
    // cases + cord-ready cordless). Each is tagged with its cord status at
    // source so the No cord / With cord toggle can filter reliably.
    if (modelBrand(activeModel.handle) === 'samsung') {
      loadCollection(activeModel.handle, grid, function(products) {
        loadPhoneCordsHandles().then(function() {
          var all = [];
          (products || []).forEach(function(p) {
            var k = classifySamsungProduct(p);
            if (k === 'withcord') { p._caseCord = 'cord'; all.push(p); }
            else if (k === 'cordless') { p._caseCord = 'nocord'; all.push(p); }
          });
          renderExtraCases(all);
        });
      }, { limit: 250 });
      return;
    }
    // iPhone path — load BOTH cordless cases (curated intern collection,
    // resolved to this model) AND the per-model with-cord case collection.
    // Provenance is authoritative for cord status: intern designs = no cord,
    // per-model collection = with cord. Tag at source, then merge.
    loadCollection(INTERN_BB_HANDLE, grid, function(cordlessProducts) {
      var cordless = resolveDesignsForModel(cordlessProducts || [], activeModel.title);
      loadCollection(activeModel.handle, grid, function(withCordProducts) {
        var seen = {};
        var merged = [];
        (cordless || []).forEach(function(p) {
          if (p && p.handle && !seen[p.handle]) { seen[p.handle] = true; p._caseCord = 'nocord'; merged.push(p); }
        });
        (withCordProducts || []).forEach(function(p) {
          if (p && p.handle && !seen[p.handle]) { seen[p.handle] = true; p._caseCord = 'cord'; merged.push(p); }
        });
        renderExtraCases(merged);
      }, { limit: 250 });
    }, { limit: 50 });
  }

  // Split the cases by cord status, reconcile the toggle (hide it if only one
  // side exists), then render the selected side. Colour filter runs on top of
  // whatever cord type is showing.
  function renderExtraCases(allCases) {
    var grid = $('xbb-step-3-products');
    if (!grid) return;
    var withCord = (allCases || []).filter(function(p) { return p._caseCord === 'cord'; });
    var noCord   = (allCases || []).filter(function(p) { return p._caseCord === 'nocord'; });
    var hasBoth = withCord.length > 0 && noCord.length > 0;

    // Default the selection from the customer's step-1 choice the first time.
    if (S.extraCasesCord !== 'cord' && S.extraCasesCord !== 'nocord') {
      S.extraCasesCord = (S.caseType === 'without') ? 'nocord' : 'cord';
    }
    // Force the selection to a side that actually has products.
    if (!hasBoth) {
      if (withCord.length) S.extraCasesCord = 'cord';
      else if (noCord.length) S.extraCasesCord = 'nocord';
    }
    setExtraCasesCordToggle(hasBoth);
    syncExtraCasesCordButtons();

    var list = (S.extraCasesCord === 'nocord') ? noCord : withCord;
    renderGrid(list, grid, 'xbb-step-3-products', { colorFilter: true });
    persistState();
  }

  function setExtraCasesCordToggle(show) {
    var el = $('xbb-extra-cases-cord-switch');
    if (el) el.classList.toggle('xbb-hidden', !show);
  }
  function syncExtraCasesCordButtons() {
    $$('#xbb-extra-cases-cord-switch .xbb-cordfilter__btn').forEach(function(b) {
      var on = b.dataset.extraCord === S.extraCasesCord;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function handleSubcatClick(btn) {
    var handle = btn.dataset.subcat;
    var nested = btn.dataset.nested;
    S.activeSubcat = handle;

    // Scroll is owned by the showSubstep() call further down, which lands on
    // this step's heading — scrolling here too would double-fire.

    // The model switcher is exclusive to the "Extra hoesjes" (cases) view.
    // Hide it for every other subcategory up front so it can never linger
    // from a previous cases visit (e.g. when jumping to AirPods).
    var modelSwitchEl = $('xbb-extra-cases-model-switch');
    if (modelSwitchEl) modelSwitchEl.classList.toggle('xbb-hidden', handle !== 'cases');
    // Safe to remove anytime — clear any lingering model-filter fallback
    // notice left over from a previously viewed category.
    try { if (typeof xbbShowFilterFallbackNote === 'function') xbbShowFilterFallbackNote(false); } catch (e) {}
    // The cord-type toggle is likewise cases-only — hide it for other views.
    if (handle !== 'cases') setExtraCasesCordToggle(false);

    // Show smart device filter ONLY for categories where the phone model
    // genuinely changes the product (screen protectors are model-cut; Apple
    // Watch products are sized to the watch model). Everything else is
    // universal — wallets, charms, stickers, cables, MagSafe pucks, lipgloss
    // holders, silicone bags — and a model dropdown there just confuses.
    var smartSwitchEl = $('xbb-smart-device-switch');
    if (smartSwitchEl) {
      // Apple Watch removed: the dropdown is built from stepConfig[1].models
      // (PHONE models), which is meaningless for watch products — it rendered
      // as a lone "Mijn model" no-op under Apple Watch accessoires.
      // Re-add only once a dedicated watch-model list exists.
      var MODEL_RELEVANT_CATS = ['screenprotectors'];
      var showSmart = MODEL_RELEVANT_CATS.indexOf(handle) !== -1 && nested !== 'airpods_by_model';
      smartSwitchEl.classList.toggle('xbb-hidden', !showSmart);
      if (showSmart) {
        // Reset stale product cache + override so the dropdown doesn't list
        // models from the previously-viewed category or carry over a "specific
        // model" pick that may not exist in the new one. Load callback below
        // repopulates with the right set.
        _currentExtrasAllProducts = [];
        S.smartDeviceOverride = '';
        buildSmartDeviceModelOptions();
      }
    }

    if (nested === 'airpods_by_model') {
      showSubstep('xbb-step-3', 'xbb-step-3-airpods');
      return;
    }
    var sub = (stepConfig[3].subcollections || []).find(function(s) { return s.handle === handle; });
    if (!sub && handle === 'cords') sub = EXTRA_CORDS_SUBCAT;
    if (!sub && handle === 'cases') sub = EXTRA_CASES_SUBCAT;
    $('xbb-step-3b-title').textContent = sub ? subcatTitle(sub) : handle;
    showSubstep('xbb-step-3', 'xbb-step-3b');
    var grid = $('xbb-step-3-products');

    // Special path: "Extra cases" reuses a per-model case collection.
    // Customer can pick any iPhone model — not locked to their step-1 choice.
    if (handle === 'cases') {
      // Customers can reach step 3 without ever picking a phone model
      // (e.g. they hit "Skip case" right from the model picker). Fall back
      // to the first model in the catalog so the grid still shows products;
      // the model dropdown is right above the grid for them to switch.
      if (!S.extraCasesModel) {
        if (S.model && S.model.handle) S.extraCasesModel = S.model.handle;
        else {
          var fallback = (stepConfig[1].models || [])[0];
          if (fallback) S.extraCasesModel = fallback.handle;
        }
      }
      buildExtraCasesModelOptions();
      loadExtraCasesGrid();
      return;
    }

    // Special path: "Screen protectors" is a virtual category. Merchant
    // splits screen + camera-lens protectors across multiple collections so
    // each one stays manageable. Behind one tile we load + merge them.
    if (handle === 'screenprotectors') {
      loadMergedScreenProtectors(grid);
      return;
    }

    loadCollection(handle, grid, function(products) {
      _currentExtrasAllProducts = products || [];
      buildSmartDeviceModelOptions();
      var filtered = applySmartDeviceFilter(products);
      renderGrid(withColorMatching(filtered || []), grid, 'xbb-step-3-products', { colorFilter: shouldShowColorFilter(handle) });
    });
  }

  // Handles that make up the "Screen protectors" master tile. Order is the
  // order items appear in the merged grid (after smart-model sorting).
  var SCREENPROTECTOR_HANDLES = [
    'tempered-glass-screenprotector-with-frame-2-pack',
    'tempered-glass-privacy-screenprotector-with-frame-2-pack',
    'tempered-glass-camera-lens-protection',
    'diamond-tempered-glass-camera-lens-protection',
    'mirror-camera-lens-protection'
  ];
  function loadMergedScreenProtectors(grid) {
    if (!grid) return;
    grid.innerHTML = skeletonHtml(6);
    var collected = {};
    var doneCount = 0;
    function finish() {
      // Dedupe by handle in case a product is in more than one sub-collection
      var merged = Object.keys(collected).map(function(h) { return collected[h]; });
      _currentExtrasAllProducts = merged;
      buildSmartDeviceModelOptions();
      var filtered = applySmartDeviceFilter(merged);
      // Color filter is intentionally OFF for screen protectors — these
      // are split by product TYPE (regular tempered glass, privacy, camera
      // lens, mirror lens, diamond lens), not by colour, so a colour-chip
      // row would be confusing rather than helpful.
      renderGrid(withColorMatching(filtered || []), grid, 'xbb-step-3-products', { colorFilter: false });
    }
    SCREENPROTECTOR_HANDLES.forEach(function(handle) {
      loadCollection(handle, grid, function(products) {
        (products || []).forEach(function(p) {
          if (p && p.handle && !collected[p.handle]) collected[p.handle] = p;
        });
        doneCount++;
        if (doneCount === SCREENPROTECTOR_HANDLES.length) finish();
      }, { limit: 250 });
    });
  }

  function applySmartDeviceFilter(products) {
    var allModels = (stepConfig[1] && stepConfig[1].models) || [];

    // Resolve the customer's "target" model handles — the ones we want to
    // keep products for. Either the explicit dropdown override OR the
    // most-specific model match for everything in the bundle.
    var targetHandles = [];
    if (S.smartDeviceOverride) {
      targetHandles.push(S.smartDeviceOverride);
    } else if (S.filterExtrasByModel) {
      var titles = [];
      if (S.case) {
        if (S.case.variantTitle) titles.push(S.case.variantTitle);
        if (S.case.title) titles.push(S.case.title);
      }
      if (S.cases && S.cases.length > 0) {
        S.cases.forEach(function(c) {
          if (c.variantTitle) titles.push(c.variantTitle);
          if (c.title) titles.push(c.title);
        });
      }
      if (S.model && S.model.title) titles.push(S.model.title);
      titles.forEach(function(title) {
        var m = findBestMatchModel(title, allModels);
        if (m && targetHandles.indexOf(m.handle) === -1) targetHandles.push(m.handle);
      });
    } else {
      return products;
    }

    if (targetHandles.length === 0) return products;

    var xbbKept = (products || []).filter(function(p) {
      // Map this product to its most-specific model. If iPhone 17 Pro Max is
      // in the model list, an "iPhone 17 Pro Max" product maps there and
      // NOT to iPhone 17 — fixing the substring-overlap bug.
      var productModel = findBestMatchModel(p.title, allModels);
      if (productModel) return targetHandles.indexOf(productModel.handle) !== -1;
      // No model match → treat as universal and keep. Previously the regex
      // here was hiding legitimate universal accessories whose titles
      // happened to mention a brand (e.g. "iPhone-compatible…", or models
      // missing from stepConfig like iPhone 8/XS) — leaving them invisible
      // to the customer for no good reason.
      return true;
    });

    // Safe to remove anytime — empty-state fallback. If the model filter
    // hides EVERYTHING (e.g. a category that only stocks other models),
    // an empty grid reads as "out of stock" and kills the sale. Fall back
    // to the full unfiltered list and show a one-line notice instead.
    try {
      if (xbbKept.length === 0 && (products || []).length > 0) {
        xbbShowFilterFallbackNote(true);
        return products;
      }
      xbbShowFilterFallbackNote(false);
    } catch (e) {}
    return xbbKept;
  }

  // Safe to remove anytime — injects/toggles a small notice above the
  // step-3 product grid explaining the model-filter fallback.
  function xbbShowFilterFallbackNote(show) {
    var grid = $('xbb-step-3-products');
    if (!grid || !grid.parentNode) return;
    var note = document.getElementById('xbb-filter-fallback-note');
    if (!show) { if (note) note.style.display = 'none'; return; }
    var msg = (lang === 'de') ? 'Keine exakte Übereinstimmung für dein Modell — wir zeigen alle Modelle.'
            : (lang === 'en') ? 'No exact match for your model — showing all models instead.'
            : (lang === 'fr') ? 'Aucune correspondance exacte pour votre modèle — tous les modèles sont affichés.'
            : 'Geen exacte match voor jouw model — we tonen alle modellen.';
    if (!note) {
      note = document.createElement('p');
      note.id = 'xbb-filter-fallback-note';
      note.style.cssText = 'margin:0 0 12px;padding:10px 14px;font-size:.82rem;line-height:1.45;border:1px solid var(--x-rule);border-radius:var(--x-r);background:rgba(255,255,255,.6);';
      grid.parentNode.insertBefore(note, grid);
    }
    note.textContent = msg;
    note.style.display = '';
  }

  function handleBack(target) {
    closeDrawerForNav();
    // Scroll is owned by the goToStep()/showSubstep() calls below, which land on
    // the heading of the step we're going back to — or, because this is a back
    // navigation, on wherever the customer had scrolled to in that step.
    _backNav = true;
    if (target === '1a') {
      showSubstep('xbb-step-1', 'xbb-step-1a');
    } else if (target === 'step1') {
      goToStep(1);
      showSubstep('xbb-step-1', S.case ? 'xbb-step-1b' : 'xbb-step-1a');
    } else if (target === 'step2') {
      // Path B (with cord): skip Step 2 going back, jump to Step 1's case grid
      if (S.caseType === 'with') {
        goToStep(1);
        showSubstep('xbb-step-1', 'xbb-step-1b');
      } else {
        goToStep(2);
      }
    } else if (target === '3a') {
      showSubstep('xbb-step-3', 'xbb-step-3a');
    }
    refreshTray();
  }

  // ─── Step 1: load case products based on caseType ───
  // ─── Normal (non-cord) cases for the "Zonder koord" grid ─────────────
  // Data-only products.json fetch (no rendering), with the same retry +
  // non-empty-cache guard as loadCollection.
  // fetch() with a deadline. A request the OS parks while the tab sits in the
  // background (screen off, app switch, browser closed and reopened) can
  // otherwise hang forever: no error, so no retry, so a skeleton grid for good —
  // and with the in-flight dedupe below, every later call for that collection
  // would just join the dead queue. Aborting turns it into a normal failure that
  // the existing retry path handles.
  // Run fn once every promise has settled, or after ms, whichever comes first.
  // Used to hold a grid's FIRST draw until its popularity scores are in, so it
  // appears in its final order instead of re-sorting in front of the shopper,
  // without ever letting a slow score request hold the products back for long.
  var RANK_WAIT_MS = 1500;
  function whenReadyOrAfter(promises, ms, fn) {
    var done = false;
    var go = function() { if (done) return; done = true; fn(); };
    Promise.all(promises.map(function(x) { return Promise.resolve(x).catch(function() {}); })).then(go);
    setTimeout(go, ms);
  }
  function fetchT(url, opts, ms) {
    if (typeof AbortController === 'undefined') return fetch(url, opts);
    var ac = new AbortController();
    var o = Object.assign({}, opts || {}, { signal: ac.signal });
    var timer = setTimeout(function() { ac.abort(); }, ms || 20000);
    return fetch(url, o).then(
      function(r) { clearTimeout(timer); return r; },
      function(e) { clearTimeout(timer); throw e; });
  }
  function fetchProductsJson(handle, limit, cb) {
    if (!handle) { cb([]); return; }
    if (productCache[handle]) { cb(productCache[handle]); return; }
    // In-flight dedupe: a second caller for the same collection JOINS the request
    // already running instead of firing its own. This is what makes pre-warming
    // safe — without it, a warm-up plus the real call would double-fetch these
    // 250-product pages and make the slow start worse, not better.
    if (productInflight[handle]) { productInflight[handle].push(cb); return; }
    productInflight[handle] = [cb];
    function done(list) {
      var queue = productInflight[handle] || [cb];
      delete productInflight[handle];
      for (var qi = 0; qi < queue.length; qi++) {
        try { queue[qi](list); }
        catch (e) { console.warn('[xoxo-bundle] products callback failed', handle, e); }
      }
    }
    // /products.json caps out at 250 per page, so we MUST walk the pages: the
    // easy-cord-case collection passed 250 in the Aug-2026 case expansion
    // (294 live products), and a single-page fetch silently dropped the tail —
    // whole colours went missing from "Zonder koord". Keep paging until a page
    // comes back short; MAX_PAGES stops a misbehaving response looping forever.
    var per = limit || 250;
    var MAX_PAGES = 8;
    var all = [];
    function finish() {
      var products = all.filter(function(p) { return !isBundleExcluded(p); });
      if (products.length > 0) productCache[handle] = products;
      done(products);
    }
    function attempt(page, tries) {
      var url = lp + '/collections/' + encodeURIComponent(handle) +
                '/products.json?limit=' + per + '&page=' + page;
      fetchT(url, { headers: { 'Accept': 'application/json' }, cache: 'no-cache' }, 20000)
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(data) {
          var batch = (data && data.products) || [];
          all = all.concat(batch);
          // A full page means there may be more; a short page means we're done.
          if (batch.length >= per && page < MAX_PAGES) { attempt(page + 1, 1); return; }
          finish();
        })
        .catch(function(err) {
          if (tries < 3) { setTimeout(function() { attempt(page, tries + 1); }, 400 * tries); }
          else if (all.length) {
            // Partial data beats none — keep what earlier pages returned.
            console.warn('[xoxo-bundle] normal-case load partial', handle, 'page', page, err);
            finish();
          } else {
            console.warn('[xoxo-bundle] normal-case load failed', handle, err);
            done([]);
          }
        });
    }
    attempt(1, 1);
  }
  function modelFromTitle(t) {
    var parts = String(t || '').split(' - ');
    return parts.length > 1 ? parts[parts.length - 1].trim() : '';
  }
  function normalizeModel(s) {
    return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  // Keep only the normal cases whose title model EXACTLY matches the selected
  // model (exact compare avoids the "iPhone 15" ⊂ "iPhone 15 Pro" trap), and
  // mark them cordless so they sit in the "Zonder koord" grid.
  function normalCasesForModel(products) {
    if (!S.model || !S.model.title) return [];
    var want = normalizeModel(S.model.title);
    var out = [];
    (products || []).forEach(function(p) {
      if (normalizeModel(modelFromTitle(p.title)) === want) {
        p._caseCord = 'nocord';
        out.push(p);
      }
    });
    return out;
  }
  function mergeCases(base, extra) {
    var seen = {};
    (base || []).forEach(function(p) { if (p && p.handle) seen[p.handle] = true; });
    var out = (base || []).slice();
    (extra || []).forEach(function(p) { if (p && p.handle && !seen[p.handle]) { seen[p.handle] = true; out.push(p); } });
    return out;
  }
  // Render a cordless step-1 grid, merging in the normal (clip) cases for the
  // model. Falls back to just the base list when the feature is off.
  function renderCordlessWithNormals(baseList, grid, isStale) {
    if (!normalCasesEnabled) {
      renderGrid(baseList, grid, 'xbb-step-1-products', { colorFilter: true });
      return;
    }
    // The clip cases land in this grid under their REAL handles, so their
    // quick-view facts / videos / translated images live in THIS collection's
    // facet payload — which nothing fetched before (only the design source's).
    // Memoised, fire-and-forget: the grid never waits for it.
    // The merged grid holds the clip cases too, whose scores live in THIS
    // collection's payload: hold the first draw for them as well (capped). A
    // payload that lands after the draw still re-sorts, as before.
    var drawn = false;
    var normalFacets = loadFacets(normalCaseHandle);
    normalFacets.then(function() { if (drawn) resortIfUntouched('xbb-step-1-products'); patchCardRatings(); });
    fetchProductsJson(normalCaseHandle, 250, function(prods) {
      if (isStale && isStale()) return;
      whenReadyOrAfter([normalFacets], RANK_WAIT_MS, function() {
        if (isStale && isStale()) return;
        var merged = mergeCases(baseList, normalCasesForModel(prods));
        renderGrid(merged, grid, 'xbb-step-1-products', { colorFilter: true });
        drawn = true;
      });
    });
  }

  // Cordless step-1 grid. Primary path derives the designs straight from the real
  // per-model products, so the curated "dropdown" products aren't involved at all.
  // Falls back to the old curated path whenever the source collection can't
  // produce a grid — an empty main tab is far worse than an older-looking one.
  function loadCordlessDesigns(grid, isStale) {
    if (!caseSourceHandle) { loadCordlessDesignsLegacy(grid, isStale); return; }
    // Warm the clip-case collection IN PARALLEL with the design source below.
    // renderCordlessWithNormals needs it, but it only asked for it AFTER the
    // first collection had resolved — so the two big paginated loads (~700
    // products between them) ran back-to-back, which is the main reason the
    // first step-1 render felt slow on mobile. The dedupe in fetchProductsJson
    // means this shares a single request with that later call.
    if (normalCasesEnabled) fetchProductsJson(normalCaseHandle, 250, function() {});
    loadCollection(caseSourceHandle, grid, function(products) {
      if (isStale()) return;
      var groups = buildDesignGroups(products);
      var tiles = designTilesForModel(groups);
      console.log('[xoxo-bundle] designs from real products:', tiles.length,
                  'of', Object.keys(groups).length, 'for', S.model.title);
      if (!tiles.length) { loadCordlessDesignsLegacy(grid, isStale); return; }
      renderCordlessWithNormals(tiles, grid, isStale);
    }, { limit: 250, paginate: true });
  }
  // Legacy: curated dropdown products, model resolved to a variant, then swapped
  // to the real product by SKU. Kept as the safety net until the derived path has
  // proven itself, and as the answer for any design that only exists as a
  // curated product.
  function loadCordlessDesignsLegacy(grid, isStale) {
    loadCollection(INTERN_BB_HANDLE, grid, function(products) {
      if (isStale()) return;
      var resolved = resolveDesignsForModel(products, S.model.title);
      console.log('[xoxo-bundle] FALLBACK curated designs:', resolved.length, '/', products.length, 'for', S.model.title);
      swapTilesToSourceProducts(resolved, function(tiles) {
        if (isStale()) return;
        renderCordlessWithNormals(tiles, grid, isStale);
      });
    }, { limit: 50 });
  }

  function loadStep1Products() {
    if (!S.model) return;
    var grid = $('xbb-step-1-products');
    var myToken = ++_step1LoadToken;   // newest load wins; stale callbacks bail
    var isStale = function() { return myToken !== _step1LoadToken; };
    // Samsung uses the same with/without-cord branching as iPhone, but
    // the per-model collection mixes 3 product types:
    //   1. Cord cases (with built-in cord) — isWithCordProduct()
    //   2. Cord-ready cordless cases — isCordReadyCordlessProduct()
    //      (tagged "Bundle Builder" OR title indicates no-cord variant)
    //   3. Normal cases — NOT bundle eligible, excluded entirely
    //
    // Load the model collection once, classify each product, decide which
    // type(s) actually have items, hide the case-type toggle if only one,
    // and render the appropriate set.
    if (modelBrand(S.model.handle) === 'samsung') {
      loadCollection(S.model.handle, grid, function(products) {
        loadPhoneCordsHandles().then(function() {
          if (isStale()) return;   // a newer load (e.g. deep-link tab flip) superseded us
          var all = products || [];
          var withCord = [];
          var cordless = [];
          all.forEach(function(p) {
            var k = classifySamsungProduct(p);
            if (k === 'withcord') withCord.push(p);
            else if (k === 'cordless') cordless.push(p);
          });
          var canWith = withCord.length > 0;
          var canWithout = cordless.length > 0;

          // Auto-switch caseType to whatever's available
          if (S.caseType === 'with' && !canWith && canWithout) {
            S.caseType = 'without';
            syncCaseTypeButtons();
            updateStep1NextLabel();
            updateProgressForCaseType();
          } else if (S.caseType === 'without' && !canWithout && canWith) {
            S.caseType = 'with';
            syncCaseTypeButtons();
            updateStep1NextLabel();
            updateProgressForCaseType();
          }
          updateCaseTypeAvailability(canWith, canWithout);

          if (S.caseType === 'with') {
            renderGrid(withCord, grid, 'xbb-step-1-products', { colorFilter: true });
          } else {
            // Cordless: fold in the normal (non-cord) cases for this model too.
            renderCordlessWithNormals(cordless, grid, isStale);
          }
        });
      }, { limit: 250 });
      return;
    }
    // iPhone path always has both types available across most gens, so
    // restore the toggle to its full visibility just in case the user
    // switched FROM Samsung (which may have hidden it).
    updateCaseTypeAvailability(true, true);
    if (S.caseType === 'without') {
      // Path A: load the curated intern-bundle-builder, resolve variants for this model
      loadCordlessDesigns(grid, isStale);
    } else {
      // Path B: per-model cord-cases collection, filtered to with-cord products only
      loadCollection(S.model.handle, grid, function(products) {
        if (isStale()) return;   // superseded by a newer load
        renderGrid(products, grid, 'xbb-step-1-products', { colorFilter: true });
      }, { limit: 250, withCordOnly: true });
    }
  }

  function loadCordTab(key) {
    var opt = (stepConfig[2].options || []).find(function(o) { return o.key === key; });
    if (!opt) return;
    var grid = $('xbb-step-2-products');
    loadCollection(opt.handle, grid, function(products) {
      renderGrid(withColorMatching(products || []), grid, 'xbb-step-2-products', { colorFilter: true });
    });
  }

  // ─── Qty stepper / remove from tray ─────────────────
  // Line keys are "<kind>:<handle>@<variantId>" — variant-aware, because the
  // same product can sit in the tray twice with different variants (e.g. a
  // screen protector added for two phone models via the card's variant
  // select). Handle-only keys made the qty stepper edit the FIRST variant
  // line and remove delete BOTH. "@" can never appear in a Shopify handle.
  // A key without "@" (none are emitted today) still matches by handle alone.
  function lineMatchesKey(line, ref) {
    if (!line) return false;
    if (ref.variantId == null) return line.handle === ref.handle;
    return line.handle === ref.handle && String(line.variantId) === ref.variantId;
  }
  function parseLineKey(key) {
    var m = String(key || '').match(/^(case|cord|acc):(.+)$/);
    if (!m) return null;
    var at = m[2].indexOf('@');
    return {
      kind: m[1],
      handle: at === -1 ? m[2] : m[2].slice(0, at),
      variantId: at === -1 ? null : m[2].slice(at + 1)
    };
  }
  function findLineByKey(key) {
    if (key === 'case') return S.cases[0] || S.case;
    var ref = parseLineKey(key);
    if (!ref) return null;
    var list = ref.kind === 'case' ? S.cases : ref.kind === 'cord' ? S.cords : S.accessories;
    return list.find(function(l) { return lineMatchesKey(l, ref); });
  }
  function handleQtyClick(btn) {
    var key = btn.dataset.lineQty.split('|')[0];
    var dir = btn.dataset.lineQty.split('|')[1]; // 'plus' or 'minus'
    var line = findLineByKey(key);
    if (!line) return;
    var newQty = (line.qty || 1) + (dir === 'plus' ? 1 : -1);
    if (newQty <= 0) {
      handleRemoveLine(key);
      return;
    }
    if (newQty > 10) newQty = 10;
    line.qty = newQty;
    refreshTray();
    refreshProductCardsSelectedState();
  }
  function handleRemoveLine(key) {
    if (key === 'case') {
      // Legacy single-case removal: clear all cases.
      S.cases = [];
      S.case = null;
      $('xbb-next-1').disabled = true;
    } else {
      var ref = parseLineKey(key);
      if (ref) {
        var keep = function(l) { return !lineMatchesKey(l, ref); };
        if (ref.kind === 'case') {
          S.cases = S.cases.filter(keep);
          S.case = S.cases[0] || null;
          $('xbb-next-1').disabled = !S.cases.length;
        } else if (ref.kind === 'cord') {
          S.cords = S.cords.filter(keep);
        } else {
          S.accessories = S.accessories.filter(keep);
        }
      }
    }
    refreshTray();
    refreshProductCardsSelectedState();
  }

  // Sync all density toggle buttons + apply / remove the single-col class on every grid
  function applyGridDensity() {
    $$('.xbb-grid-density__btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.density === S.gridDensity);
    });
    $$('.xbb-pgrid').forEach(function(grid) {
      grid.classList.toggle('xbb-pgrid--single', S.gridDensity === '1');
    });
  }

  // After tray edits, re-sync selected/qty on visible product cards
  function refreshProductCardsSelectedState() {
    $$('.xbb-pcard').forEach(function(card) {
      var h = card.dataset.productHandle;
      var qty = 0;
      S.cases.forEach(function(c) { if (c.handle === h) qty += c.qty || 1; });
      S.cords.forEach(function(c) { if (c.handle === h) qty += c.qty; });
      S.accessories.forEach(function(a) { if (a.handle === h) qty += a.qty; });
      card.classList.toggle('selected', qty > 0);
      if (qty > 0) card.setAttribute('data-qty', qty);
      else card.removeAttribute('data-qty');
      var badge = card.querySelector('.xbb-pcard__qty-badge');
      if (badge) badge.textContent = qty > 1 ? qty : '';
    });
    syncPinnedCase();
  }

  // ─── Tray rendering ─────────────────────────────────
  // Subtitle next to the kind label — gives customers an at-a-glance
  // confirmation of what model/variant they actually picked.
  //   • Case lines  → "Hoesje · iPhone 17 Pro"
  //   • Other lines → "Koord · Burgundy" (only when product has variants)
  function lineSubtitle(line, kind) {
    if (kind === 'case' && S.model && S.model.title) return S.model.title;
    var vt = line && line.variantTitle ? String(line.variantTitle).trim() : '';
    if (vt && vt.toLowerCase() !== 'default title') return vt;
    return '';
  }
  function lineHtml(line, kind, key, kindLabel) {
    var qty = line.qty || 1;
    var sub = lineSubtitle(line, kind);
    var kindMarkup = sub
      ? '<span class="xbb-line__kind">' + esc(kindLabel) + ' <span class="xbb-line__kind-sep">·</span> <span class="xbb-line__kind-sub">' + esc(sub) + '</span></span>'
      : '<span class="xbb-line__kind">' + esc(kindLabel) + '</span>';
    return '<div class="xbb-line">' +
      '<div class="xbb-line__img">' + (line.image ? '<img src="' + esc(cdnImg(line.image, 160)) + '" alt="" decoding="async">' : '') + '</div>' +
      '<div class="xbb-line__info">' +
        kindMarkup +
        '<span class="xbb-line__title">' + esc(line.title) + '</span>' +
        '<span class="xbb-line__price">' + money(line.price * qty) + '</span>' +
      '</div>' +
      '<div class="xbb-line__actions">' +
        '<button type="button" class="xbb-line__remove" data-line-remove="' + esc(key) + '" aria-label="' + esc(t.remove) + '">×</button>' +
        '<div class="xbb-step-qty">' +
          '<button type="button" data-line-qty="' + esc(key) + '|minus" aria-label="−">−</button>' +
          '<span class="xbb-step-qty__val">' + qty + '</span>' +
          '<button type="button" data-line-qty="' + esc(key) + '|plus" aria-label="+">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function lineKey(kind, line) {
    return kind + ':' + line.handle + '@' + (line.variantId == null ? '' : line.variantId);
  }
  // Free Easy Cord Clip gift line — read-only (no qty stepper, no remove; it's
  // derived from the bundle and disappears on its own when the case or cord is
  // removed). Shown as a gift so the customer understands the extra €0 line.
  function giftLineHtml(qty) {
    var qtyLabel = qty > 1 ? ' <span class="xbb-line__kind-sub">×' + qty + '</span>' : '';
    return '<div class="xbb-line xbb-line--gift">' +
      '<div class="xbb-line__img xbb-line__img--gift">' +
        (clipImage
          ? '<img src="' + esc(cdnImg(clipImage, 160)) + '" alt="" decoding="async">'
          : '<span class="xbb-line__gift-icon" aria-hidden="true">🎁</span>') +
      '</div>' +
      '<div class="xbb-line__info">' +
        '<span class="xbb-line__kind xbb-line__kind--gift">' + esc(t.giftLabel) + qtyLabel + '</span>' +
        '<span class="xbb-line__title">' + esc(clipTitle) + '</span>' +
        '<span class="xbb-line__gift-note">' + esc(t.giftNote) + '</span>' +
      '</div>' +
      '<div class="xbb-line__actions">' +
        '<span class="xbb-line__free">' + esc(t.free) + '</span>' +
      '</div>' +
    '</div>';
  }
  function buildLinesHtml() {
    var html = '';
    S.cases.forEach(function(c) {
      html += lineHtml(c, 'case', lineKey('case', c), t.kindCase);
    });
    S.cords.forEach(function(c) {
      html += lineHtml(c, 'cord', lineKey('cord', c), t.kindCord);
    });
    S.accessories.forEach(function(a) {
      // Cases/cords picked from Step 3's "Add a case"/"Add a cord" tiles stay
      // in accessories but should read as a Case/Cord (not "Extra") in the
      // tray — matching how they're sent to cart (kind 'case' / 'cord').
      var kindLabel = a.subcat === 'cords' ? t.kindCord
                    : a.subcat === 'cases' ? t.kindCase
                    : t.kindAcc;
      html += lineHtml(a, 'acc', lineKey('acc', a), kindLabel);
    });
    var clipQty = computeClipQty();
    // Once the gift is actually unlocked it earns its own module in the list.
    // Until then it's just one of the pending rewards, and lives in the combined
    // "still to unlock" module that refreshTray appends (see unlockModuleHtml) —
    // two separate nudges stacked on top of each other read as clutter.
    if (clipQty > 0) html += giftLineHtml(clipQty);
    return html;
  }
  // One module listing every reward still within reach, instead of a separate
  // card per reward. Each row carries its own action, because "add one more
  // product" and "add a cord" send the customer to different steps.
  //   includeDiscount — the desktop tray already has a discount progress bar, so
  //                     only the drawer wants the discount row.
  function unlockModuleHtml(includeDiscount, discState, n, hasItems) {
    var rows = '';
    if (includeDiscount && hasItems && discState.active && discState.next && !discState.isMax) {
      rows += '<button type="button" class="xbb-unlock__row" data-unlock="discount">' +
        '<span class="xbb-unlock__icon xbb-unlock__icon--plus" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
        '</span>' +
        '<span class="xbb-unlock__text">' + esc(t.discNextTier(discState.next.min - n, discState.next.pct)) + '</span>' +
        '<svg class="xbb-unlock__chev" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>' +
      '</button>';
    }
    if (shouldShowClipNudge()) {
      var icon = clipImage
        ? '<img src="' + esc(cdnImg(clipImage, 120)) + '" alt="" decoding="async">'
        : '<span aria-hidden="true">🎁</span>';
      rows += '<button type="button" class="xbb-unlock__row" data-unlock="clip">' +
        '<span class="xbb-unlock__icon xbb-unlock__icon--gift">' + icon + '</span>' +
        '<span class="xbb-unlock__text">' +
          '<strong>' + esc(t.nudgeTitle) + '</strong>' +
          '<span class="xbb-unlock__hint">' + esc(t.nudgeCta) + '</span>' +
        '</span>' +
        '<svg class="xbb-unlock__chev" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>' +
      '</button>';
    }
    if (!rows) return '';
    // The id is kept for styling hooks (the old flash animation is gone).
    return '<div id="xbb-ghost-line" class="xbb-unlock">' +
      '<span class="xbb-unlock__head">' + esc(t.unlockTitle) + '</span>' + rows +
    '</div>';
  }
  // Show the "add a cord → free clip" nudge only when there's a clip-eligible
  // case in the bundle but no cord yet (the exact gap where adding a cord flips
  // clipQty from 0 to >0). Mutually exclusive with the gift line above.
  function shouldShowClipNudge() {
    return clipEnabled && !bundleHasCord() && clipNeedingCaseUnits() > 0;
  }
  // Cord-step notification. The free Easy Cord Clip is earned only by a case
  // that needs a clip (no hinge) TOGETHER with a cord, so the promise is made
  // exactly where the cord gets chosen, and only while such a case is in the
  // bundle. A badge on the case cards and a note above the case grid were both
  // tried first — each read as "this case comes with a free clip", which is
  // not the deal. Flips to "included" the moment a cord is in; hidden otherwise.
  function syncCordGift() {
    var el = document.getElementById('xbb-cordgift');
    if (!el) return;
    var eligible = clipEnabled && clipNeedingCaseUnits() > 0;
    el.hidden = !eligible;
    if (!eligible) return;
    var earned = computeClipQty() > 0;
    el.classList.toggle('is-earned', earned);
    var set = function(id, txt) { var n = document.getElementById(id); if (n) n.textContent = txt; };
    set('xbb-cordgift-eyebrow', earned ? t.clipEarnedEyebrow : t.giftLabel);
    set('xbb-cordgift-title', t.nudgeTitle);
    set('xbb-cordgift-text', earned ? t.clipEarned : t.nudgeText);
    var img = document.getElementById('xbb-cordgift-img');
    if (img && clipImage && !img.getAttribute('src')) { img.src = cdnImg(clipImage, 120); img.hidden = false; }
  }
  // The clip tile in that notification is pressable: it opens the same quick
  // view the product cards use, fed from the clip product itself
  // (/products/<handle>.js — photos, description, price), so the shopper can see
  // exactly what the free gift is. Fetched once, on first tap.
  var _clipProduct = null;
  function fetchClipProduct(cb) {
    if (_clipProduct) { cb(_clipProduct); return; }
    if (!clipInfoHandle) { cb(null); return; }
    fetchT(lp + '/products/' + encodeURIComponent(clipInfoHandle) + '.js', { headers: { 'Accept': 'application/json' } }, 12000)
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(p) { _clipProduct = p; cb(p); })
      .catch(function(e) { console.warn('[xoxo-bundle] clip product load failed', clipInfoHandle, e); cb(null); });
  }
  function openClipQuickView() {
    fetchClipProduct(function(p) {
      var images = (p && p.images && p.images.length)
        ? p.images.map(function(u) { return String(u).replace(/^\/\//, 'https://'); })
        : (clipImage ? [clipImage] : []);
      // photos AND the clip's video, in the product's own media order
      var entries = qvEntriesFromJsMedia(p && p.media, images);
      // Lead with the deal in one line, then the merchant's own description.
      descByHandle['__clip'] = '<p><strong>' + esc(t.nudgeText) + '</strong></p>' + ((p && p.description) || '');
      // openQuickView reads a product CARD; hand it a detached stand-in.
      var stub = document.createElement('div');
      stub.dataset.qvKind = 'clip';
      stub.dataset.productHandle = '__clip';
      // The merchant's clip title from the section settings reads cleaner than the
      // catalogue title ("... - Gold (No Cord)"); the product title is the fallback.
      stub.dataset.productTitle = clipTitle || (p && p.title) || t.nudgeTitle;
      stub.dataset.productPrice = '0';
      stub.dataset.clipWorth = String((p && p.price) || 0);
      stub.dataset.productImg = images[0] || '';
      stub.dataset.images = JSON.stringify(images);
      stub.dataset.qvMedia = JSON.stringify(entries);
      stub.dataset.variantAvailable = '1';
      openQuickView(stub);
    });
  }
  function totalCents() {
    var sum = 0;
    S.cases.forEach(function(c) { sum += (c.price || 0) * (c.qty || 1); });
    S.cords.forEach(function(c) { sum += (c.price || 0) * (c.qty || 1); });
    S.accessories.forEach(function(a) { sum += (a.price || 0) * (a.qty || 1); });
    return sum;
  }

  // Apply the discount the SAME way Shopify applies it at checkout: per-line,
  // and Shopify TRUNCATES (Math.floor) the fractional cent rather than
  // rounding. For prices ending in .99 at 10/15/20% this matters — a
  // discount of €1.699 displays as €1.69 in the cart, not €1.70. Using
  // Math.floor here keeps the bundle-builder preview cent-perfect.
  function discountCentsForLine(line, pct) {
    if (!line || !pct) return 0;
    var lineTotal = (line.price || 0) * (line.qty || 1);
    return Math.floor(lineTotal * pct / 100);
  }
  function discountCentsTotal(pct) {
    if (!pct) return 0;
    var sum = 0;
    S.cases.forEach(function(c) { sum += discountCentsForLine(c, pct); });
    S.cords.forEach(function(c) { sum += discountCentsForLine(c, pct); });
    S.accessories.forEach(function(a) { sum += discountCentsForLine(a, pct); });
    return sum;
  }

  function itemCount() {
    var n = 0;
    S.cases.forEach(function(c) { n += c.qty || 1; });
    S.cords.forEach(function(c) { n += c.qty || 1; });
    S.accessories.forEach(function(a) { n += a.qty || 1; });
    return n;
  }

  // ─── Easy Cord Clip free gift — derived from bundle state ─────────
  // A cord is present if the customer picked one in step 2 OR added a cord
  // from step 3's "Add a cord" tiles.
  function bundleHasCord() {
    if (S.cords && S.cords.length) return true;
    return !!(S.accessories && S.accessories.some(function(a) { return a.subcat === 'cords'; }));
  }
  // Total clip-needing case UNITS in the bundle (respects qty; cases can live
  // in S.cases from step 1 or in S.accessories with subcat 'cases' from step 3).
  function clipNeedingCaseUnits() {
    var n = 0;
    S.cases.forEach(function(c) { if (c.needsClip) n += c.qty || 1; });
    S.accessories.forEach(function(a) { if (a.needsClip && a.subcat === 'cases') n += a.qty || 1; });
    return n;
  }
  // How many free clips to add: one per clip-needing case, but only once the
  // bundle actually contains a cord for them to clip onto.
  // Cord UNITS in the bundle (step-2 cords + step-3 "Add a cord" tiles),
  // respecting qty. A clip pairs ONE cord to ONE case, so this caps the clips.
  function cordUnits() {
    var n = 0;
    S.cords.forEach(function(c) { n += c.qty || 1; });
    S.accessories.forEach(function(a) { if (a.subcat === 'cords') n += a.qty || 1; });
    return n;
  }
  // How many free clips to add: one per clip-needing case, but NEVER more than
  // the number of cords (a clip attaches ONE cord to ONE case).
  function computeClipQty() {
    if (!clipEnabled) return 0;
    var cords = cordUnits();
    if (cords <= 0) return 0;
    return Math.min(clipNeedingCaseUnits(), cords);
  }

  // ─── Discount state ─────────────────────────────────
  function computeDiscountState(n) {
    if (!discEnabled || !discTiers.length) {
      return { active: false };
    }
    var current = null;
    var next = null;
    for (var i = 0; i < discTiers.length; i++) {
      if (n >= discTiers[i].min) current = discTiers[i];
      else if (!next) next = discTiers[i];
    }
    var maxTier = discTiers[discTiers.length - 1];
    return {
      active: true,
      n: n,
      current: current,
      next: next,
      max: maxTier,
      isMax: current && current.min === maxTier.min
    };
  }

  // Track tier transitions so we only celebrate on UPward moves
  var _lastAppliedPct = 0;
  var _discNotesArmed = false; // no celebration/nudge on the first (restore) render

  // The rich discount toast that used to live here was removed on 2026-09-16:
  // it fired on every add and covered the grid. The strip pulse below is the
  // remaining, in-place celebration.

  function triggerDiscountUnlock(pct, state, n) {
    var widget = $('xbb-disc');
    if (widget) {
      widget.classList.remove('xbb-disc--just-unlocked');
      // Trigger reflow to restart animation
      void widget.offsetWidth;
      widget.classList.add('xbb-disc--just-unlocked');
      setTimeout(function() {
        widget.classList.remove('xbb-disc--just-unlocked');
      }, 1200);
    }
    var strip = $('xbb-disc-strip');
    if (strip) {
      strip.classList.remove('xbb-disc-strip--just-unlocked');
      void strip.offsetWidth;
      strip.classList.add('xbb-disc-strip--just-unlocked');
      setTimeout(function() {
        strip.classList.remove('xbb-disc-strip--just-unlocked');
      }, 1200);
    }
  }

  // Heart-burst removed per design feedback (no 🎁 hearts; the unlock still
  // pulses the widget/strip via the --just-unlocked class).

  // Build the discount timeline as a row of "stations" — one per tier — so
  // customers can see the milestones (2 items → 10%, 3 → 15%, 4+ → 25%) and
  // their current position at a glance. Replaces the older invisible-marker
  // bar that only rendered a smooth fill with no labels.
  // Station X-position on the track (% of total width). Stations are evenly
  // distributed across the timeline — N tiers → station i at (i+1)/N * 100%.
  // This leaves "ramp up" room before tier 1 so the fill shows progress
  // even at 1 item, and the fill arrives precisely at each station when the
  // tier unlocks.
  function stationPosPct(i) { return ((i + 1) / discTiers.length) * 100; }
  function prevStationPosPct(i) { return i === 0 ? 0 : (i / discTiers.length) * 100; }
  // Map current item count → fill width. Linear between stations.
  function computeTimelineFillPct(n) {
    if (n <= 0) return 0;
    for (var i = 0; i < discTiers.length; i++) {
      if (n < discTiers[i].min) {
        var prevMin = i === 0 ? 0 : discTiers[i - 1].min;
        var spanItems = discTiers[i].min - prevMin;
        var t = spanItems > 0 ? (n - prevMin) / spanItems : 1;
        return prevStationPosPct(i) + (stationPosPct(i) - prevStationPosPct(i)) * t;
      }
    }
    return 100;
  }

  var _discTimelineBuilt = false;
  function buildDiscountTimeline() {
    if (_discTimelineBuilt) return;
    var stations = '';
    for (var i = 0; i < discTiers.length; i++) {
      var isLast = (i === discTiers.length - 1);
      var minLabel = discTiers[i].min + (isLast ? '+' : '');
      var pos = stationPosPct(i);
      stations +=
        '<div class="xbb-disc__station" data-tier="' + i + '" style="left:' + pos.toFixed(2) + '%">' +
          '<span class="xbb-disc__station-pct">' + discTiers[i].pct + '%</span>' +
          '<span class="xbb-disc__station-dot" aria-hidden="true">' +
            '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px;display:block;pointer-events:none"><polyline points="2.5 6.5 5 9 9.5 3.5"/></svg>' +
          '</span>' +
          '<span class="xbb-disc__station-count">' + esc(minLabel) + '</span>' +
        '</div>';
    }
    var inner =
      '<div class="xbb-disc__track" aria-hidden="true">' +
        '<div class="xbb-disc__track-fill" id="xbb-disc-fill"></div>' +
      '</div>' +
      '<div class="xbb-disc__stations">' + stations + '</div>';
    var desktop = $('xbb-disc-timeline');
    if (desktop) desktop.innerHTML = inner;
    var mobile = $('xbb-disc-strip-timeline');
    if (mobile) {
      mobile.innerHTML = inner.replace('id="xbb-disc-fill"', 'id="xbb-disc-strip-fill"');
    }
    _discTimelineBuilt = true;
  }
  function buildDiscountMarkers() { buildDiscountTimeline(); }

  function renderDiscount(n, hasItems) {
    var widget = $('xbb-disc');
    var strip = $('xbb-disc-strip');
    var state = computeDiscountState(n);
    if (!state.active) {
      if (widget) widget.hidden = true;
      if (strip) strip.hidden = true;
      return state;
    }
    if (!hasItems) {
      if (widget) widget.hidden = true;
      if (strip) strip.hidden = true;
      return state;
    }
    buildDiscountTimeline();

    var fillPct = computeTimelineFillPct(n);
    // Compact pct pill (e.g. "−10%") — only shown when a tier is active.
    // Universal across languages, the pill style communicates "discount".
    var pctLabel = state.current ? ('−' + state.current.pct + '%') : '';
    var hint;
    if (state.isMax) hint = t.discMax;
    else if (state.current && state.next) hint = t.discNextTier(state.next.min - n, state.next.pct);
    else if (state.next) hint = t.discAddMore(state.next.min - n, state.next.pct);
    else hint = '';

    // Detect "almost there" — exactly one item from the next tier
    var almost = !!(state.next && (state.next.min - n) === 1);

    // Detect tier UNLOCK (current pct went up since last render)
    var currentPct = state.current ? state.current.pct : 0;
    var unlocked = currentPct > _lastAppliedPct;
    _lastAppliedPct = currentPct;
    // Crossing a tier still pulses the strip, in place. The toast that used to
    // slide over the grid here (unlock + "1 away" nudge) is gone on purpose:
    // it repeated on every add, and the pre-checkout upsell moment now carries
    // the "one more product" message once, with a concrete number.
    var _discMasked = document.documentElement.classList.contains('xbb-case-loading');
    if (_discNotesArmed && !_discMasked && unlocked) {
      triggerDiscountUnlock(currentPct, state, n);
    }

    // Desktop widget
    // Flag "next-tier available" so CSS can dress the hint as a CTA — the
    // customer should see it as a clickable nudge to add one more product
    // rather than as static fine print.
    var hasNextTier = !!state.next && !state.isMax;

    if (widget) {
      widget.hidden = false;
      widget.classList.toggle('xbb-disc--active', !!state.current);
      widget.classList.toggle('xbb-disc--maxed', !!state.isMax);
      widget.classList.toggle('xbb-disc--almost', almost);
      widget.classList.toggle('xbb-disc--has-next', hasNextTier);
      var fill = $('xbb-disc-fill');
      if (fill) fill.style.width = fillPct.toFixed(2) + '%';
      var pctEl = $('xbb-disc-pct');
      if (pctEl) {
        if (state.current) {
          pctEl.textContent = pctLabel;
          pctEl.hidden = false;
        } else {
          pctEl.hidden = true;
        }
      }
      var hintEl = $('xbb-disc-hint');
      if (hintEl) hintEl.textContent = hint;
      syncTimelineStations(widget, n);
    }

    // Mobile strip
    if (strip) {
      strip.hidden = false;
      strip.classList.toggle('xbb-disc-strip--maxed', !!state.isMax);
      strip.classList.toggle('xbb-disc-strip--almost', almost);
      strip.classList.toggle('xbb-disc-strip--has-next', hasNextTier);
      var stripFill = $('xbb-disc-strip-fill');
      if (stripFill) stripFill.style.width = fillPct.toFixed(2) + '%';
      var stripHint = $('xbb-disc-strip-hint');
      if (stripHint) {
        if (state.current && state.next) {
          stripHint.innerHTML = '<span style="opacity: 0.85; font-weight: 500;">' + esc(t.discApplied(state.current.pct)) + '</span>' +
            '<span style="display: inline-block; margin: 0 6px; opacity: 0.3;">|</span>' +
            '<span style="color: var(--x-primary, #53181F); font-weight: 700; white-space: nowrap;">' + esc(hint) + ' <span aria-hidden="true" style="display: inline-block; margin-left: 2px;">→</span></span>';
        } else if (state.isMax) {
          stripHint.innerHTML = '<span style="opacity: 0.85; font-weight: 500;">' + esc(t.discApplied(state.current.pct)) + '</span>' +
            '<span style="display: inline-block; margin: 0 6px; opacity: 0.3;">|</span>' +
            '<span style="color: var(--x-primary, #53181F); font-weight: 700;">' + esc(hint) + '</span>';
        } else {
          stripHint.innerHTML = '<span style="color: var(--x-primary, #53181F); font-weight: 600;">' + esc(hint) + '</span>';
        }
      }
      syncTimelineStations(strip, n);
    }

    return state;
  }

  // Apply active/current state to each station inside a timeline. A station
  // is "active" when item count has reached its threshold; "current" is the
  // highest unlocked tier (used to highlight what they've actually earned).
  function syncTimelineStations(rootEl, n) {
    var stations = rootEl.querySelectorAll('.xbb-disc__station');
    var currentIdx = -1;
    for (var i = 0; i < discTiers.length; i++) {
      if (n >= discTiers[i].min) currentIdx = i;
    }
    for (var j = 0; j < stations.length; j++) {
      var tierIdx = parseInt(stations[j].getAttribute('data-tier'), 10);
      var unlocked = n >= discTiers[tierIdx].min;
      stations[j].classList.toggle('xbb-disc__station--active', unlocked);
      stations[j].classList.toggle('xbb-disc__station--current', tierIdx === currentIdx);
    }
  }

  function refreshTray() {
    // If the pinned case was removed anywhere (grid tap, drawer, tray), stop
    // pinning it. No-op until a PDP preselect is live.
    syncPinnedCase();
    syncCordGift();
    var n = itemCount();
    var total = totalCents();
    var hasItems = n > 0;

    // Discount math — per-line to match Shopify checkout rounding
    var discState = computeDiscountState(n);
    var discPct = (discState.active && discState.current) ? discState.current.pct : 0;
    var discountAmt = discountCentsTotal(discPct);
    var grandTotal = total - discountAmt;

    // "We found the best deal" note — only surface once a real bundle
    // discount tier is actually unlocked (≥ 2 items today). Below that,
    // claiming we found a deal isn't truthful yet.
    var dealFound = !!(discState.active && discState.current && n >= 2);
    var discNote = document.getElementById('xbb-disc-note');
    if (discNote) discNote.hidden = !dealFound;
    var discNoteDrawer = document.getElementById('xbb-disc-note-drawer');
    if (discNoteDrawer) discNoteDrawer.hidden = !dealFound;

    // Sidebar
    $('xbb-tray-count').textContent = hasItems ? t.itemsLabel(n) : '';
    var trayEmpty = $('xbb-tray-empty');
    var lines = $('xbb-tray-lines');
    var totals = $('xbb-tray-totals');
    var trayCta = $('xbb-tray-cta');
    if (hasItems) {
      trayEmpty.style.display = 'none';
      lines.innerHTML = buildLinesHtml() + unlockModuleHtml(false, discState, n, hasItems);
      totals.style.display = 'flex';
      $('xbb-tray-item-count').textContent = n;
      var subRow = $('xbb-tray-subtotal-row');
      var discRow = $('xbb-tray-discount-row');
      if (discountAmt > 0) {
        if (subRow) { subRow.hidden = false; $('xbb-tray-subtotal').textContent = money(total); }
        if (discRow) {
          discRow.hidden = false;
          $('xbb-tray-discount-pct').textContent = '· ' + discPct + '%';
          $('xbb-tray-discount-amt').textContent = '−' + money(discountAmt);
        }
      } else {
        if (subRow) subRow.hidden = true;
        if (discRow) discRow.hidden = true;
      }
      $('xbb-tray-total').textContent = money(grandTotal);
    } else {
      trayEmpty.style.display = 'block';
      lines.innerHTML = '';
      totals.style.display = 'none';
    }
    trayCta.disabled = !S.cases.length;

    // Mobile drawer
    var drawer = $('xbb-drawer-mobile');
    var showDrawer = hasItems || S.step > 1;
    if (showDrawer) {
      drawer.classList.add('visible');
      } else {
      // Going from visible→hidden — fully unwind any expanded state,
      // backdrop, scroll lock, and ARIA so the page isn't left in a
      // half-locked state when the customer removed the last item from
      // inside the expanded drawer.
      drawer.classList.remove('visible');
        if (drawer.classList.contains('expanded')) {
        drawer.classList.remove('expanded');
        var backdropEl = $('xbb-drawer-backdrop');
        if (backdropEl) backdropEl.classList.remove('show');
        document.body.style.overflow = '';
        var toggleEl = $('xbb-drawer-toggle');
        if (toggleEl) toggleEl.setAttribute('aria-expanded', 'false');
      }
    }

    // Hero thumb — prefers the case, but falls back to the first cord /
    // accessory the customer has added so the drawer never sits "empty"
    // when there's actually something in the bundle (e.g. skipped case).
    var heroImg = $('xbb-drawer-hero-img');
    var heroEmpty = $('xbb-drawer-hero-empty');
    var heroBadge = $('xbb-drawer-hero-badge');
    var heroSource = null;
    if (S.case && S.case.image) heroSource = S.case;
    else if (S.cords[0] && S.cords[0].image) heroSource = S.cords[0];
    else if (S.accessories[0] && S.accessories[0].image) heroSource = S.accessories[0];
    if (heroSource) {
      heroImg.src = heroSource.image;
      heroImg.style.display = '';
      heroEmpty.style.display = 'none';
    } else {
      heroImg.style.display = 'none';
      heroEmpty.style.display = '';
    }
    // Total extras = additional cases (beyond the one in the hero) + cords + accessories.
    var extras = Math.max(0, (S.cases.length || 0) - (S.case ? 1 : 0))
               + (S.cords.length || 0)
               + (S.accessories.length || 0);
    // Don't double-count: if the hero is now showing a cord/accessory (no
    // case fallback), it's already visible — only show "+N" for the rest.
    if (!S.case && heroSource) extras = Math.max(0, extras - 1);
    if (extras > 0) {
      heroBadge.textContent = '+' + extras;
      heroBadge.classList.add('show');
    } else {
      heroBadge.classList.remove('show');
    }

    // Count + total
    if (hasItems) {
      $('xbb-drawer-count').textContent = t.itemsLabel(n);
    } else {
      $('xbb-drawer-count').textContent = t.emptyShort;
    }
    // Same count in the expanded drawer's head — the compact list shows ~7
    // rows, so the head tells the customer how much sits below the fold.
    var expCount = $('xbb-drawer-count-expanded');
    if (expCount) expCount.textContent = hasItems ? t.itemsLabel(n) : '';
    $('xbb-drawer-total').textContent = money(grandTotal);
    $('xbb-drawer-total-big').textContent = money(grandTotal);
    
    // Drawer gets the full module (discount + gift); the desktop tray gets it
    // without the discount row, since the tray already shows a progress bar.
    var drawerLinesHtml = buildLinesHtml() +
      unlockModuleHtml(true, discState, n, hasItems);
    $('xbb-drawer-lines').innerHTML = drawerLinesHtml;

    // Drawer subtotal/discount rows
    var drawerSubRow = $('xbb-drawer-subtotal-row');
    var drawerDiscRow = $('xbb-drawer-discount-row');
    if (hasItems && discountAmt > 0) {
      if (drawerSubRow) { drawerSubRow.hidden = false; $('xbb-drawer-subtotal').textContent = money(total); }
      if (drawerDiscRow) {
        drawerDiscRow.hidden = false;
        $('xbb-drawer-discount-pct').textContent = '· ' + discPct + '%';
        $('xbb-drawer-discount-amt').textContent = '−' + money(discountAmt);
      }
    } else {
      if (drawerSubRow) drawerSubRow.hidden = true;
      if (drawerDiscRow) drawerDiscRow.hidden = true;
    }

    // Discount progress widgets
    renderDiscount(n, hasItems);

    // Update the contextual CTA label/action on every state change
    updateCtaState();

    // Persist after every state change so refresh restores cart progress
    persistState();
  }

  function collectItems() {
    var out = [];
    S.cases.forEach(function(c) { out.push(c); });
    S.cords.forEach(function(c) { out.push(c); });
    S.accessories.forEach(function(a) { out.push(a); });
    return out;
  }

  // ─── Mobile drawer open/close ───────────────────────
  function openMobileDrawer() {
    $('xbb-drawer-mobile').classList.add('expanded');
    $('xbb-drawer-backdrop').classList.add('show');
    document.body.style.overflow = 'hidden';
    // Hide the sticky step header so it doesn't float over the open set view
    // (the header sits at z-95, above the drawer/backdrop).
    var pr = document.querySelector('.xbb-prog');
    if (pr) pr.classList.add('xbb-prog--set-open');
    var t = $('xbb-drawer-toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeMobileDrawer() {
    $('xbb-drawer-mobile').classList.remove('expanded');
    $('xbb-drawer-backdrop').classList.remove('show');
    document.body.style.overflow = '';
    var pr = document.querySelector('.xbb-prog');
    if (pr) pr.classList.remove('xbb-prog--set-open');
    var t = $('xbb-drawer-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  // Swipe-to-open/close was hijacking product-list scrolls inside the drawer
  // and accidentally closing it. The drawer is now driven entirely by explicit
  // taps on the bar (to open) and the close button / chevron (to close).

  // ─── Step buttons ───────────────────────────────────
  $('xbb-next-1').addEventListener('click', function() {
    if (!S.cases.length) return;
    // Path B: with-cord case → skip cord step, go straight to extras
    if (S.caseType === 'with') goToStep(3);
    else goToStep(2);
  });
  // "Koord overslaan" advances WITHOUT wiping any cords already picked —
  // matching "Afronden zonder extra's", which also keeps selections. Wiping
  // here silently deleted paid picks when a customer tapped skip out of
  // habit; anyone who truly wants a cord gone can remove it in the tray.
  $('xbb-skip-2').addEventListener('click', function() { goToStep(3); });
  // Skip-case: build a bundle with no phone case (just cords / extras).
  function skipCaseAndContinue() {
    S.cases = [];
    S.case = null;
    goToStep(2);
  }
  $('xbb-skip-case').addEventListener('click', skipCaseAndContinue);
  var skipCase1a = $('xbb-skip-case-1a');
  if (skipCase1a) skipCase1a.addEventListener('click', skipCaseAndContinue);

  // ── Device-search combobox wiring ──
  var modelSearch = $('xbb-model-search');
  if (modelSearch) {
    modelSearch.addEventListener('input', function() {
      S.modelQuery = modelSearch.value || '';
      syncModelSearchClear();
      renderModels();       // re-render the (now filtered) list
      syncGenChipActive();  // desktop chip row must not contradict a live search
    });
    modelSearch.addEventListener('keydown', function(e) {
      var key = e.key;
      if (key === 'ArrowDown' || key === 'Down') {
        e.preventDefault();
        setModelActiveOption(_modelActiveIdx + 1);
      } else if (key === 'ArrowUp' || key === 'Up') {
        e.preventDefault();
        setModelActiveOption(_modelActiveIdx - 1);
      } else if (key === 'Enter') {
        var opts = visibleModelOptions();
        if (_modelActiveIdx >= 0 && opts[_modelActiveIdx]) {
          e.preventDefault();
          opts[_modelActiveIdx].click();
        } else if (opts.length === 1) {
          // A single remaining match is an unambiguous choice — Enter picks it.
          e.preventDefault();
          opts[0].click();
        }
      } else if (key === 'Escape' || key === 'Esc') {
        if (modelSearch.value) {
          e.preventDefault();
          clearModelSearch();
          modelSearch.focus();
        }
      }
    });
  }
  var modelSearchClear = $('xbb-model-search-clear');
  if (modelSearchClear) {
    modelSearchClear.addEventListener('click', function() {
      clearModelSearch();
      if (modelSearch) modelSearch.focus();
    });
  }
  // Re-render the model list when the viewport crosses the mobile/desktop
  // picker breakpoint (grouped sub-headers vs the flat single-generation grid),
  // but only while the model picker sub-step is actually on screen.
  var _lastPickerMobile = isMobilePicker();
  window.addEventListener('resize', function() {
    var nowMobile = isMobilePicker();
    if (nowMobile === _lastPickerMobile) return;
    _lastPickerMobile = nowMobile;
    var sub = $('xbb-step-1a');
    if (sub && sub.classList.contains('active')) {
      renderModels();
      syncGenChipActive();
    }
  }, { passive: true });
  $('xbb-next-2').addEventListener('click', function() { goToStep(3); });
  // Reviewing the bundle (finish buttons, drawer CTA on step 3) used to scroll
  // the bundle list to its very bottom and flash the "still to unlock" module,
  // to push "one more product = more discount". Removed on request: the
  // discount is already explained in enough places (progress bar, tier notes,
  // the module itself), and the forced scroll read as pushy. The drawer still
  // opens / the tray still scrolls into view — the list just stays where it is.
  $('xbb-finish-no-acc').addEventListener('click', function() {
    var any = S.cases.length > 0 || S.cords.length > 0 || S.accessories.length > 0;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    if (isMobile) {
      if (any) {
        openMobileDrawer();
      }
      return;
    }
    var tray = $('xbb-tray');
    if (tray) {
      tray.scrollIntoView({ behavior: 'smooth', block: 'center' });
      tray.classList.remove('xbb-tray--flash');
      void tray.offsetWidth;
      tray.classList.add('xbb-tray--flash');
      setTimeout(function() { tray.classList.remove('xbb-tray--flash'); }, 1200);
    }
  });
  $('xbb-add-more-cats').addEventListener('click', function() { showSubstep('xbb-step-3', 'xbb-step-3a'); });
  $('xbb-finish-3').addEventListener('click', function() {
    // "Bekijk mijn bundel" should always REVIEW, never directly add to cart.
    // Mobile: open the drawer so the customer can see what's in the bundle.
    // Desktop: scroll the always-visible tray into view and flash it briefly
    // so the customer notices it. They confirm via the tray's primary CTA.
    var any = S.cases.length > 0 || S.cords.length > 0 || S.accessories.length > 0;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    if (isMobile) {
      if (any) {
        openMobileDrawer();
      }
      return;
    }
    var tray = $('xbb-tray');
    if (tray) {
      tray.scrollIntoView({ behavior: 'smooth', block: 'center' });
      tray.classList.remove('xbb-tray--flash');
      // force reflow so the animation restarts on repeated taps
      void tray.offsetWidth;
      tray.classList.add('xbb-tray--flash');
      setTimeout(function() { tray.classList.remove('xbb-tray--flash'); }, 1200);
    }
  });
  // The tray + drawer CTAs are context-aware (Continue vs Add to cart) — see updateCtaState()
  $('xbb-tray-cta').addEventListener('click', function() { runCtaAction(); });
  $('xbb-drawer-cta').addEventListener('click', function(ev) {
    ev.stopPropagation();
    if (S.step === 3 && !$('xbb-drawer-mobile').classList.contains('expanded')) {
      openMobileDrawer();
    } else {
      runCtaAction();
    }
  });
  $('xbb-drawer-cta-big').addEventListener('click', function() { runCtaAction(); });

  // ─── Add to cart ────────────────────────────────────
  // ─── Reveal overlay (final review moment before redirect) ──
  function showReveal() {
    var reveal = $('xbb-reveal');
    var items = collectItems();
    // Include the free clip in the cutscene (display only — it's never counted;
    // itemCount()/totals below still exclude it). Marked _gift for a subtle ring.
    var revealClipQty = computeClipQty();
    if (revealClipQty > 0) {
      items = items.concat([{ image: clipImage, title: clipTitle, _gift: true }]);
    }
    var maxShown = 8;
    var shown = items.slice(0, maxShown);
    // Preload images via Image() so the reveal animation has them ready —
    // otherwise on slow connections the 1.4s window closes before the <img>
    // elements finish fetching, and the user only sees empty circles.
    shown.forEach(function(it) {
      if (it && it.image) { try { (new Image()).src = it.image; } catch (e) {} }
    });
    var html = shown.map(function(it, i) {
      var src;
      if (it && it.image) {
        // onerror falls back to the heart placeholder so a broken/expired URL
        // never leaves the circle blank.
        src = '<img src="' + esc(it.image) + '" alt="" loading="eager" decoding="async" ' +
              'onerror="this.style.display=\'none\';var s=document.createElement(\'span\');s.className=\'xbb-reveal__item-empty\';s.textContent=\'🎁\';this.parentNode.appendChild(s);">';
      } else {
        src = '<span class="xbb-reveal__item-empty">🎁</span>';
      }
      var giftCls = (it && it._gift) ? ' xbb-reveal__item--gift' : '';
      return '<span class="xbb-reveal__item' + giftCls + '" style="animation-delay:' + (0.25 + i * 0.07).toFixed(2) + 's">' + src + '</span>';
    }).join('');
    if (items.length > maxShown) {
      html += '<span class="xbb-reveal__item xbb-reveal__item--more" style="animation-delay:' + (0.25 + maxShown * 0.07).toFixed(2) + 's">+' + (items.length - maxShown) + '</span>';
    }
    $('xbb-reveal-items').innerHTML = html;
    var revealTotal = totalCents();
    var revealState = computeDiscountState(itemCount());
    if (revealState.active && revealState.current) {
      // Per-line rounding so the reveal price matches Shopify's checkout total
      revealTotal = revealTotal - discountCentsTotal(revealState.current.pct);
    }
    $('xbb-reveal-total').textContent = money(revealTotal);
    reveal.hidden = false;
    reveal.removeAttribute('hidden');
    reveal.classList.add('show');
    reveal.setAttribute('aria-hidden', 'false');
    // Bulletproof: inline-force visibility + reparent to <body> so the
    // celebratory cutscene plays on desktop too (was being trapped behind
    // an ancestor stacking context). Max-int z-index so no theme element
    // can sit above us. Mirrors the upsell/quickview fix.
    reveal.style.cssText = 'display:flex !important;position:fixed !important;inset:0 !important;z-index:2147483647 !important;opacity:1 !important;align-items:center;justify-content:center;padding:1.5rem;';
    if (reveal.parentNode !== document.body) {
      document.body.appendChild(reveal);
    }
    document.body.style.overflow = 'hidden';
  }
  function hideReveal() {
    var reveal = $('xbb-reveal');
    reveal.classList.remove('show');
    reveal.hidden = true;
    reveal.setAttribute('aria-hidden', 'true');
    reveal.style.cssText = '';
    document.body.style.overflow = '';
  }

  // Render the actual discount applications Shopify chose into the reveal.
  // Pulls from /cart.js so we tell the customer the truthful story —
  // bundle tier, sitewide deal, or anything else the merchant has running.
  function renderAppliedDeals(cart) {
    var el = $('xbb-reveal-deals');
    if (!el) return;
    var apps = (cart && cart.discount_applications) || [];
    // Sum savings per discount title (Shopify can split allocations across lines)
    var byTitle = {};
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function(item) {
        (item.line_level_discount_allocations || []).forEach(function(alloc) {
          var key = (alloc.discount_application && alloc.discount_application.title)
            || (alloc.title) || 'Discount';
          byTitle[key] = (byTitle[key] || 0) + (alloc.amount || 0);
        });
      });
    }
    // Fallback: read flat total_discount if no per-line allocations were emitted
    if (Object.keys(byTitle).length === 0 && cart && cart.total_discount > 0 && apps.length > 0) {
      var title = (apps[0] && apps[0].title) || 'Discount';
      byTitle[title] = cart.total_discount;
    }
    var titles = Object.keys(byTitle);
    if (titles.length === 0) { el.hidden = true; el.innerHTML = ''; return; }
    var headerLabel = (lang === 'de') ? 'Beste Aktion automatisch angewendet'
      : (lang === 'en') ? 'Best deal automatically applied'
      : (lang === 'fr') ? 'Meilleure offre appliquée automatiquement'
      : 'Beste actie automatisch toegepast';
    var html = '<p class="xbb-reveal__deals-head">' + esc(headerLabel) + '</p>';
    html += '<ul class="xbb-reveal__deals-list">';
    titles.forEach(function(title) {
      html += '<li class="xbb-reveal__deals-item">' +
        '<span class="xbb-reveal__deals-title">' + esc(title) + '</span>' +
        '<span class="xbb-reveal__deals-amt">−' + money(byTitle[title]) + '</span>' +
      '</li>';
    });
    html += '</ul>';
    el.innerHTML = html;
    el.hidden = false;
  }

  function addBundleToCart() {
    // Bundle can skip cases entirely — but must contain at least one item
    var hasAnyCase = !!(S.cases && S.cases.length > 0);
    var hasItems = hasAnyCase || (S.cords && S.cords.length > 0) || (S.accessories && S.accessories.length > 0);
    if (!hasItems) {
      showToast(t.pickCase, true);
      return;
    }
    // Tag every cart item from the bundle builder with hidden line-item
    // properties so a Shopify automatic discount (or Shopify Function) can
    // target ONLY bundle-built carts. Underscore-prefixed keys are invisible
    // to the customer but visible to discount rules and order detail.
    var bundleId = 'xbb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    function bundleProps(kind) {
      return { '_bundle': 'true', '_bundle_kind': kind, '_bundle_id': bundleId,
               '_bundle_entry': entrySource() };
    }
    // Defense in depth: same line validity check used on click + restore, so a
    // phantom (empty title / €0 price) can never reach the Shopify cart even
    // if some earlier guard missed it.
    function isCartable(x) {
      var id = parseInt(x && x.variantId, 10);
      return !!(x && id && typeof x.title === 'string' && x.title.trim() && Number(x.price) > 0);
    }
    var items = [];
    S.cases.forEach(function(c) {
      if (!isCartable(c)) return;
      items.push({
        id: parseInt(c.variantId, 10),
        quantity: c.qty || 1,
        properties: bundleProps('case')
      });
    });
    S.cords.forEach(function(c) {
      if (!isCartable(c)) return;
      items.push({
        id: parseInt(c.variantId, 10),
        quantity: c.qty || 1,
        properties: bundleProps('cord')
      });
    });
    S.accessories.forEach(function(a) {
      if (!isCartable(a)) return;
      var kind = 'accessory';
      if (a.subcat === 'cords') kind = 'cord';
      else if (a.subcat === 'cases') kind = 'case';
      items.push({
        id: parseInt(a.variantId, 10),
        quantity: a.qty || 1,
        properties: bundleProps(kind)
      });
    });

    // Free Easy Cord Clip gift. Added LAST and deliberately WITHOUT the
    // _bundle="true" property, so the discount Shopify Function skips it for the
    // tier — it never counts toward the tier and never gets the tier % applied.
    // The clip is a normally-priced product; the Function gives it a separate
    // free discount, CAPPED to `_bundle_gift_qty` (the intended count). That cap
    // is what stops a customer bumping the clip qty in the cart to get extra
    // free clips. _bundle_id is kept for order visibility / reporting.
    var clipQty = computeClipQty();
    if (clipEnabled && clipQty > 0) {
      var clipId = parseInt(clipVariantId, 10);
      if (clipId) {
        items.push({
          id: clipId,
          quantity: clipQty,
          properties: {
            '_bundle_gift': 'true',
            '_bundle_gift_qty': String(clipQty),
            '_bundle_id': bundleId,
            '_bundle_entry': entrySource()
          }
        });
      }
    }

    setCtasBusy(true);
    closeMobileDrawer();
    showReveal();

    // Race the network call with a minimum-display delay so the reveal
    // always plays for at least ~1.4s before we navigate.
    var minDelay = new Promise(function(resolve) { setTimeout(resolve, 1400); });
    // Retry cart-add on transient errors. Shopify can briefly 5xx during
    // CDN refreshes, or hand back a 422 if the customer's cart session
    // expired — re-fetching often succeeds the second time.
    function tryCartAdd(triesLeft) {
      return fetch(lp + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r) {
        if (r.ok) return r.json();
        // 422 = validation (bad variant id, sold-out etc) — don't retry
        if (r.status === 422 || triesLeft <= 1) {
          return r.json().then(function(body) {
            console.error('[xoxo-bundle] cart/add failed', r.status, body);
            return Promise.reject(r);
          }, function() { return Promise.reject(r); });
        }
        // Transient: wait a beat and retry
        return new Promise(function(res, rej) {
          setTimeout(function() { tryCartAdd(triesLeft - 1).then(res, rej); }, 500);
        });
      });
    }
    var addCart = tryCartAdd(3);

    // Stamp the entry source as a CART ATTRIBUTE too, not just a line property.
    // The line property is what shows on the order in admin; the attribute is what
    // the BWJ pixel can actually read (it already reads `_lp_attr` from
    // checkout.attributes the same way), so this is what makes entry source
    // queryable in the dashboard's analytics alongside revenue.
    // keepalive so it still completes across the redirect to /cart.
    try {
      fetch(lp + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ attributes: { '_bundle_entry': entrySource() } })
      }).catch(function() {});
    } catch (e) {}
    // After the bundle is in the cart, read /cart.js to see which discount(s)
    // Shopify actually applied. Lets us tell the customer the truthful "best
    // deal applied" story when a sitewide promo beats the bundle tier.
    var fetchAppliedDeals = addCart
      .then(function() {
        // Race /cart.js against a 6s timeout so a stalled response can never
        // freeze the reveal forever. Resolves to null on timeout.
        var cartFetch = fetch(lp + '/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.ok ? r.json() : null; });
        var timeout = new Promise(function(resolve) { setTimeout(function() { resolve(null); }, 6000); });
        return Promise.race([cartFetch, timeout]);
      })
      .catch(function() { return null; })
      .then(function(cart) {
        renderAppliedDeals(cart);
        return cart;
      });
    // Reading delay — when a discount actually applied, give the customer
    // ~2.4s AFTER the deals block has rendered so they can read it. With
    // no discount applied the reveal closes more briskly.
    var readingDelay = fetchAppliedDeals.then(function(cart) {
      var hasDeal = !!(cart && Number(cart.total_discount) > 0);
      return new Promise(function(resolve) { setTimeout(resolve, hasDeal ? 2400 : 600); });
    });

    // Watchdog — if the whole flow hasn't completed in 20s, force the
    // reveal closed and surface an error toast. Without this, a stalled
    // /cart/add.js can lock the customer inside the reveal indefinitely.
    var _revealSettled = false;
    var watchdog = setTimeout(function() {
      if (_revealSettled) return;
      _revealSettled = true;
      console.error('[xoxo-bundle] reveal watchdog fired — flow exceeded 20s');
      hideReveal();
      document.body.style.overflow = '';
      showToast(t.addError, true);
      setCtasBusy(false);
    }, 20000);

    Promise.all([addCart, fetchAppliedDeals, minDelay, readingDelay])
      .then(function() {
        if (_revealSettled) return;
        _revealSettled = true;
        clearTimeout(watchdog);
        // Bundle is now in the cart — wipe the in-progress state so a refresh
        // doesn't restore a bundle the customer already paid for / is editing.
        clearPersistedState();
        var drawer = document.querySelector('cart-drawer, cart-notification, #cart-drawer, .drawer--cart');
        if (drawer && typeof drawer.open === 'function') {
          hideReveal();
          try { drawer.open(); } catch (e) {}
        } else {
          // Clean up modal/overflow state BEFORE navigating, so the back-
          // button restore (bfcache) doesn't return to a stuck overlay.
          // Otherwise Safari/Chrome restore the page mid-reveal and the
          // customer has to press back multiple times to escape.
          hideReveal();
          document.body.style.overflow = '';
          window.location.href = lp + '/cart';
        }
      })
      .catch(function(err) {
        if (_revealSettled) return;
        _revealSettled = true;
        clearTimeout(watchdog);
        console.error('[xoxo-bundle] cart/add failed', err);
        hideReveal();
        showToast(t.addError, true);
      })
      .finally(function() {
        setCtasBusy(false);
      });
  }

  function setCtasBusy(busy) {
    ['xbb-tray-cta','xbb-drawer-cta','xbb-drawer-cta-big','xbb-finish-3','xbb-finish-no-acc'].forEach(function(id) {
      var el = $(id); if (!el) return;
      if (busy) { el.dataset._wasDisabled = el.disabled ? '1' : '0'; el.disabled = true; }
      else { el.disabled = el.dataset._wasDisabled === '1'; }
    });
  }

  // ─── Toast ──────────────────────────────────────────
  function showToast(msg, isError) {
    var el = $('xbb-toast');
    el.className = 'xbb-toast' + (isError ? ' xbb-toast--error' : '') + ' show';
    el.textContent = msg;
    clearTimeout(el._timer);
    el._timer = setTimeout(function() { el.className = 'xbb-toast' + (isError ? ' xbb-toast--error' : ''); }, 2400);
  }

  // ─── Helpers for case-type branching ────────────────
  function syncCaseTypeButtons() {
    // Reflect S.caseType on the visual toggle. Called from the click handler
    // AND from init() so a restored "with-cord" state doesn't show "zonder
    // koord" highlighted by default.
    $$('.xbb-case-type__btn').forEach(function(b) {
      var match = b.dataset.caseType === S.caseType;
      b.classList.toggle('active', match);
      b.setAttribute('aria-selected', match ? 'true' : 'false');
    });
  }
  function updateProgressForCaseType() {
    // Skip cord step only when the customer picked a with-cord case.
    // Samsung now follows the same with/without-cord branching as iPhone.
    var skipCord = (S.caseType === 'with');
    var step2 = document.querySelector('.xbb-prog-step[data-prog="2"]');
    if (step2) step2.style.display = skipCord ? 'none' : '';

    var progStep3Num = document.querySelector('.xbb-prog-step[data-prog="3"] .xbb-prog-step__num');
    if (progStep3Num) progStep3Num.textContent = skipCord ? '02' : '03';

    document.querySelectorAll('#xbb-step-3 .xbb-step__num').forEach(function(el) {
      el.textContent = skipCord ? '02' : '03';
    });
  }
  function updateStep1NextLabel() {
    var btn = $('xbb-next-1');
    if (!btn) return;
    var span = btn.querySelector('[data-next-label]');
    if (!span) return;
    var skipCord = (S.caseType === 'with');
    span.textContent = skipCord
      ? (btn.dataset.labelExtras || span.textContent)
      : (btn.dataset.labelCord || span.textContent);
  }

  // ─── Contextual CTA (drawer + tray) ─────────────────
  // Lets the user advance without scrolling — the always-visible CTA
  // changes its label and action based on current step + selection.
  function getCtaState() {
    if (S.step === 1) {
      if (!S.cases.length) return { label: t.pickCase, action: null, disabled: true, isCart: false };
      if (S.caseType === 'with') {
        return { label: t.ctaContinueExtras, action: function() { goToStep(3); }, disabled: false, isCart: false };
      }
      return { label: t.ctaContinueCord, action: function() { goToStep(2); }, disabled: false, isCart: false };
    }
    if (S.step === 2) {
      return { label: t.ctaContinueExtras, action: function() { goToStep(3); }, disabled: false, isCart: false };
    }
    // Step 3 — gate via maybeShowUpsell so the prompt fires from tray/drawer CTAs too
    return { label: t.ctaAddToCart, action: function() { maybeShowUpsell(function() { addBundleToCart(); }); }, disabled: false, isCart: true };
  }
  var _ctaAction = null;
  function runCtaAction() { if (_ctaAction) _ctaAction(); }
  function updateCtaState() {
    var state = getCtaState();
    _ctaAction = state.action;
    // Tray (desktop) — render as a span to preserve the icon if any
    var trayCta = $('xbb-tray-cta');
    if (trayCta) {
      var sp = trayCta.querySelector('span');
      (sp || trayCta).textContent = state.label;
      trayCta.disabled = state.disabled;
      trayCta.classList.toggle('xbb-btn--cart', !!state.isCart);
    }
    // Drawer collapsed CTA
    var drCta = $('xbb-drawer-cta');
    if (drCta) {
      drCta.textContent = state.label;
      drCta.disabled = state.disabled;
      drCta.classList.toggle('xbb-btn--cart', !!state.isCart);
    }
    // Drawer expanded big CTA
    var drBig = $('xbb-drawer-cta-big');
    if (drBig) {
      var sp2 = drBig.querySelector('span');
      (sp2 || drBig).textContent = state.label;
      drBig.disabled = state.disabled;
      drBig.classList.toggle('xbb-btn--cart', !!state.isCart);
    }

    if (typeof updateDrawerNav === 'function') updateDrawerNav();
  }

  // ─── iPhone generation auto-detect ──────────────────
  // Best-effort: matches the device's CSS pixel screen against known iPhone
  // models. Returns null for non-iPhone or ambiguous cases (older devices
  // overlap heavily). We pick the *newest* plausible gen for overlaps so
  // a recent buyer lands on the right generation immediately.
  // Screen size -> the iPhone models that share it, newest first. detectIPhoneGen
  // picks ONE generation for the chips; this gives the shopper the whole set of
  // plausible phones as one tap each, so an ambiguous size (393x852 is an
  // iPhone 16, 15 Pro, 15 or 14 Pro) doesn't send them into the full picker.
  var IPHONE_CANDIDATES = {
    '440x956': ['iPhone 18 Pro Max', 'iPhone 17 Pro Max', 'iPhone 16 Pro Max'],
    '402x874': ['iPhone 18 Pro', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro'],
    '420x912': ['iPhone 17 Air'],
    '430x932': ['iPhone 16 Plus', 'iPhone 15 Pro Max', 'iPhone 15 Plus', 'iPhone 14 Pro Max'],
    '393x852': ['iPhone 16', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 14 Pro'],
    '390x844': ['iPhone 14', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 12'],
    '428x926': ['iPhone 14 Plus', 'iPhone 13 Pro Max', 'iPhone 12 Pro Max'],
    '375x812': ['iPhone 13 mini', 'iPhone 12 mini', 'iPhone 11 Pro', 'iPhone X'],
    '414x896': ['iPhone 11', 'iPhone XR', 'iPhone 11 Pro Max'],
    '375x667': ['iPhone SE', 'iPhone 8', 'iPhone 7']
  };
  function iphoneCandidateModels() {
    try {
      if (!/iPhone/.test(navigator.userAgent || '')) return [];
      var key = Math.min(screen.width, screen.height) + 'x' + Math.max(screen.width, screen.height);
      var titles = IPHONE_CANDIDATES[key] || [];
      var models = stepConfig[1].models || [];
      var norm = function(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
      var out = [];
      titles.forEach(function(tt) {
        var m = models.find(function(x) { return norm(x.title) === norm(tt); });
        if (m) out.push(m);
      });
      return out;
    } catch (e) { return []; }
  }
  // Fills the "Is dit jouw iPhone?" block on the model picker. Chips carry the
  // same data-* as a model tile, so the delegated [data-model] handler treats a
  // tap exactly like picking the tile. Hidden when there is nothing to offer.
  function renderIphoneGuess() {
    var box = document.getElementById('xbb-iphone-guess');
    var host = document.getElementById('xbb-iphone-guess-chips');
    if (!box || !host) return;
    var cands = iphoneCandidateModels();
    if (!cands.length) { box.hidden = true; return; }
    host.innerHTML = cands.map(function(m) {
      return '<button type="button" class="xbb-guess__chip" data-model="' + esc(m.handle) + '" data-title="' + esc(m.title) + '" data-img="' + esc(m.image_url || '') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.6"/><circle cx="12" cy="18.4" r=".9"/></svg>' +
        '<span>' + esc(m.title) + '</span></button>';
    }).join('');
    box.hidden = false;
  }
  function detectIPhoneGen() {
    try {
      if (!/iPhone/.test(navigator.userAgent || '')) return null;
      var w = Math.min(screen.width, screen.height);
      var h = Math.max(screen.width, screen.height);
      var key = w + 'x' + h;
      var MAP = {
        '440x956': '16',
        '430x932': '17',
        '402x874': '17',
        '393x852': '17',
        '390x844': '16',
        '428x926': '13',
        '414x896': '11',
        '375x812': '13',
        '375x667': '7-8'
      };
      return MAP[key] || null;
    } catch (e) {
      return null;
    }
  }

  // Everything that can be left half-open when the page comes back from the
  // back/forward cache or a tab restore: the modals, the mobile drawer with its
  // backdrop AND the header-hiding class that travels with it, the filter bottom
  // sheet, the preload mask, the body scroll lock. Coming back to any of those
  // mid-state is what made the builder "feel buggy and stuck" after closing and
  // reopening the browser (the old reset covered the modals and drawer only).
  function resetTransientUi(opts) {
    opts = opts || {};
    document.body.style.overflow = '';
    ['xbb-qv', 'xbb-upsell', 'xbb-reveal'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.classList.remove('show', 'is-swapping');
        el.hidden = true;
        el.style.cssText = '';
        el.setAttribute('aria-hidden', 'true');
      }
    });
    qvActiveCard = null;
    _upsellOnContinue = null;
    var drawerEl = document.getElementById('xbb-drawer-mobile');
    if (drawerEl) drawerEl.classList.remove('expanded');
    var backdropEl = document.getElementById('xbb-drawer-backdrop');
    if (backdropEl) backdropEl.classList.remove('show');
    var toggleEl = document.getElementById('xbb-drawer-toggle');
    if (toggleEl) toggleEl.setAttribute('aria-expanded', 'false');
    var pr = document.querySelector('.xbb-prog');
    if (pr) pr.classList.remove('xbb-prog--set-open');
    if (_openFacetSheetEl) {
      try { closeFacetSheet(_openFacetSheetEl); } catch (e) { _openFacetSheetEl = null; }
    }
    $$('.xbb-facets__panels--open').forEach(function(h) {
      h.classList.remove('xbb-facets__panels--open', 'xbb-facets__panels--in');
    });
    // The ?product= landing owns the mask during init — leave it alone there.
    if (!opts.keepPreload) hidePreloadOverlay();
  }
  // A request the OS killed while the tab was parked can leave the grid on its
  // skeleton. On return, re-kick the loader for the step on screen when its grid
  // is still a skeleton and nothing is in flight for it. Step 1 dedupes through
  // _step1LoadToken, so a duplicate kick can never render twice.
  function recoverStalledGrids() {
    function stalled(id) {
      var g = document.getElementById(id);
      if (!g || !g.querySelector('.xbb-pcard__skeleton')) return false;
      var h = g.dataset.collectionHandle;
      return !(h && productInflight[h]);
    }
    if (S.step === 1 && S.model && stalled('xbb-step-1-products')) loadStep1Products();
    if (S.step === 2 && stalled('xbb-step-2-products')) loadCordTab(S.cordLength || 'short');
  }
  window.addEventListener('pageshow', function(ev) {
    if (!ev.persisted) return;
    resetTransientUi();
    recoverStalledGrids();
  });
  // Back after a real absence (screen off, app switch, browser closed and
  // reopened): the OS may have dropped in-flight requests. Never on a blink —
  // a quick app switch during the first load must not double-fetch anything.
  var _hiddenAt = 0;
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') { _hiddenAt = Date.now(); return; }
    if (_hiddenAt && Date.now() - _hiddenAt > 30000) recoverStalledGrids();
    _hiddenAt = 0;
  });

  // ─── Init ───────────────────────────────────────────
  // ─── Deep-link entry (from collection-page product-card icon / banners) ───
  // Reads ?model=<collection-handle> (required), ?product=<handle> (optional)
  // and ?cord=with|without (optional) off the URL. If the model matches a
  // configured phone, it preselects the brand / generation / model and lands
  // the customer straight on the case grid (step 1b), skipping the phone +
  // model picker. ?cord opens the "met koord" (with) or "zonder koord"
  // (without) tab directly; default is without (cordless), matching a normal
  // model click. ?product pre-selects (adds to the set) the specific case and
  // scrolls to / highlights it — and the product's own cord type wins over
  // ?cord (detected in preselectCaseFromDeepLink).
  // ─── "Where did you land?" model preselect ───────────
  // If the previous page was a phone-model collection, preselect that phone, so
  // a shopper browsing /collections/iphone-17-pro-max who then hits "Bundle
  // Builder" in the nav lands straight on that phone's cases instead of the
  // phone picker. Step 1b still shows "Wijzig model", so it's a shortcut, never
  // a lock-in.
  //
  // We match on a slug built from each model's TITLE ("iPhone 17 Pro Max" ->
  // "iphone-17-pro-max") rather than its own handle, because the configured
  // handles carry suffixes the collection URLs don't share
  // (iphone-17-pro-max-cord-cases vs /collections/iphone-17-pro-max).
  function modelSlug(title) {
    return String(title || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  // Pull the collection handle out of a same-origin URL. Locale-prefixed paths
  // (/de/collections/..., /fr/collections/...) work since we just look for the
  // /collections/ segment anywhere in the path.
  function collectionHandleFromUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.href);
      // Only trust our own storefront: a foreign referrer tells us nothing and
      // shouldn't be able to steer the builder.
      if (u.host !== window.location.host) return '';
      var m = u.pathname.match(/\/collections\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]).toLowerCase() : '';
    } catch (e) { return ''; }
  }
  // Longest slug FIRST is essential: "iphone-17-pro" is a substring of
  // "iphone-17-pro-max", so matching short-first would drop a Pro Max shopper on
  // the Pro grid. Padding both sides with "-" makes the test a clean
  // token-boundary match, which covers exact / prefix / suffix / middle
  // (iphone-17-pro-max, iphone-17-pro-max-cases, hoesjes-iphone-17-pro-max,
  // samsung-galaxy-s25-ultra) without matching "iphone-17" inside "iphone-170".
  // Accepted spellings for one model. Samsung needs aliases because the store's
  // collections are named "samsung-s21-ultra" while the configured model title
  // is "Galaxy S21 Ultra" — without the alias those collections never match.
  function modelSlugAliases(m) {
    var out = [];
    var t = modelSlug(m.title);
    if (!t) return out;
    out.push(t);
    if (t.indexOf('galaxy-') === 0) {
      var bare = t.replace(/^galaxy-/, '');
      out.push('samsung-' + bare);
      out.push(bare);
    }
    return out;
  }
  function matchModelByCollectionHandle(handle) {
    if (!handle) return null;
    var padded = '-' + handle + '-';
    var ranked = [];
    (stepConfig[1].models || []).forEach(function(m) {
      modelSlugAliases(m).forEach(function(slug) { ranked.push({ m: m, slug: slug }); });
    });
    ranked.sort(function(a, b) { return b.slug.length - a.slug.length; });
    for (var i = 0; i < ranked.length; i++) {
      if (padded.indexOf('-' + ranked[i].slug + '-') > -1) return ranked[i].m;
    }
    return null;
  }
  // Pull a product handle out of a same-origin /products/<handle> URL, so we can
  // also preselect from a PRODUCT page, not just a collection.
  function productHandleFromUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.href);
      if (u.host !== window.location.host) return '';
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]).toLowerCase() : '';
    } catch (e) { return ''; }
  }
  // A product page tells us the model two ways: the title's trailing segment
  // ("… - iPhone 15 Pro") and its per-model tag ("iPhone 15 Pro"). Try the title
  // first — it's the most specific — then the tags.
  function matchModelFromProductPayload(p) {
    if (!p) return null;
    var byTitle = matchModelByCollectionHandle(modelSlug(modelFromTitle(p.title)));
    if (byTitle) return byTitle;
    var tags = readTags(p);
    for (var i = 0; i < tags.length; i++) {
      var m = matchModelByCollectionHandle(modelSlug(tags[i]));
      if (m) return m;
    }
    return null;
  }
  // Async because the referring product's model lives in its payload, not its
  // URL. Calls back with true only once a model was actually applied.
  function applyLandingModelFromProduct(cb, explicitHandle) {
    // explicitHandle comes from ?product= (the PDP promo banner). Preferred over
    // the referrer, which privacy settings and iOS strip often enough that it
    // can't be the only signal.
    var handle = explicitHandle || productHandleFromUrl(document.referrer);
    if (!handle) { cb(false); return; }
    fetch(lp + '/products/' + encodeURIComponent(handle) + '.js',
          { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(p) {
        var model = matchModelFromProductPayload(p);
        if (!model) { cb(false); return; }
        applyLandingModelObject(model);
        cb(true);
      })
      .catch(function() { cb(false); });
  }

  // Shared by the collection and product paths.
  function applyLandingModelObject(model) {
    S.activeBrand = modelBrand(model.handle);
    S.activeGen   = model.gen;
    S.model       = { handle: model.handle, title: model.title, image_url: model.image_url };
    S.caseType    = 'without';   // same default as clicking the model by hand
    S.step        = 1;

    // Name the phone in the step-1b heading (a manual click does this via the
    // model tile handler; an inferred pick has to do it itself) …
    var titleEl = $('xbb-step-1b-title');
    if (titleEl) titleEl.textContent = model.title;
    // … and surface the "we chose this for you, change it here" notice — but
    // ONLY for the collection-referrer guess. When they clicked a specific
    // product's "start a bundle" (_isProductEntry), the model is obvious from
    // the case that's already selected, so the auto-pick notice is noise.
    var notice = $('xbb-autopick');
    var noticeModel = $('xbb-autopick-model');
    if (noticeModel) noticeModel.textContent = model.title;
    if (notice) notice.hidden = !!_isProductEntry;
    return true;
  }

  // Collection path — synchronous, so it can run inline during init.
  function applyLandingModel() {
    var model = matchModelByCollectionHandle(collectionHandleFromUrl(document.referrer));
    if (!model) return false;
    return applyLandingModelObject(model);
  }

  // Returns true when a valid deep-link was applied (overrides restored state).
  function applyDeepLink() {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return false; }
    var modelHandle = params.get('model');
    if (!modelHandle) return false;
    var model = (stepConfig[1].models || []).find(function(m) { return m.handle === modelHandle; });
    if (!model) return false;

    S.activeBrand = modelBrand(model.handle);
    S.activeGen   = model.gen;
    S.model       = { handle: model.handle, title: model.title, image_url: model.image_url };
    // Optional ?cord= chooses the landing tab. Accepts friendly aliases so the
    // links read cleanly. Default 'without' (cordless) matches a normal click.
    // Note: for Samsung models that only carry one type, loadStep1Products
    // auto-switches to whatever's available, so a "wrong" cord link still
    // lands on a populated grid rather than an empty one.
    var cordParam = (params.get('cord') || '').toLowerCase();
    if (/^(with|met|metkoord|met-koord|yes|1)$/.test(cordParam)) {
      S.caseType = 'with';
    } else {
      S.caseType = 'without';
    }
    S.step        = 1;

    var prod = params.get('product');
    if (prod) {
      _pendingHighlightHandle = prod;       // scroll to + pulse it once the grid renders
      _deepLinkPendingCordType = true;       // hold grid render until cord tab resolved
      preselectCaseFromDeepLink(prod);       // fetch product, set correct tab, add to set
    } else {
      _pendingScrollToGrid = true;           // model-only: scroll to the grid after it renders
    }

    var titleEl = $('xbb-step-1b-title');
    if (titleEl) titleEl.textContent = model.title;

    // Strip the params so a refresh / back-forward doesn't re-trigger the jump
    // and the persisted state can take over cleanly from here.
    try {
      history.replaceState(history.state, '', window.location.pathname + window.location.hash);
    } catch (e) { /* older browsers — harmless to leave the query in place */ }

    _arrivedViaDeepLink = true; // keep step-3 cords tile available this session
    return true;
  }

  // ─── PDP preselect: pin + confirm ────────────────────
  // When a PDP visitor arrives, the case they were viewing is added to their
  // bundle. Two things make that obvious:
  //   1. an add-to-cart-style confirmation card pops in and auto-dismisses;
  //   2. that case is pinned to the TOP of the case grid, wearing a persistent
  //      "Geselecteerd" ribbon, and scrolled into view — so the customer sees it
  //      selected in context, with every other case right below to switch to.
  var _pinnedCaseHandle = null;
  var _isProductEntry = false;   // arrived via ?product= (suppresses the model auto-pick notice)
  var _preselectedLine = null;   // the added case, shown as a confirmation once the grid is ready
  function pinPreselectedCase(handle) {
    _pinnedCaseHandle = handle || null;
    // Drive the existing scroll-to + pulse machinery at the same card.
    if (handle) _pendingHighlightHandle = handle;
  }
  function clearPinnedCase() { _pinnedCaseHandle = null; }
  // If the customer removes the pinned case (grid tap, drawer, tray), it's no
  // longer "the one from your product". Strip the pin treatment from the card in
  // the DOM as well — so the "Geselecteerd" badge is genuinely one-time and can't
  // reappear if they tap the same card again later.
  function syncPinnedCase() {
    if (!_pinnedCaseHandle) return;
    var still = S.cases.some(function(c) { return c.handle === _pinnedCaseHandle; });
    if (still) return;
    var grid = $('xbb-step-1-products');
    if (grid) {
      var card = grid.querySelector('.xbb-pcard[data-product-handle="' + cssEsc(_pinnedCaseHandle) + '"]');
      if (card) {
        card.classList.remove('xbb-pcard--pinned');
        var badge = card.querySelector('.xbb-pcard__pinned');
        if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
      }
    }
    clearPinnedCase();
  }

  // ─── Clean landing: preload mask ─────────────────────
  // Arriving via ?product= runs two fetches (model, then the case + its grid).
  // Without a mask the customer sees the raw first render — the model picker, a
  // step flip, a grid skeleton — before their case appears. A brief branded
  // overlay covers all of that and fades out only once the pinned card is on
  // screen, so the transition reads as one clean step.
  // The overlay itself is server-rendered in the section and switched on by an
  // inline script during HTML parsing, so it covers the very first frame. These
  // only manage its state — never create it, which is what made it late before.
  var PRELOAD_CLASS = 'xbb-case-loading';
  function showPreloadOverlay() {
    var el = document.getElementById('xbb-preload');
    document.documentElement.classList.add(PRELOAD_CLASS);
    if (el) el.classList.remove('xbb-preload--out');
    // Never let the mask get stuck if a fetch hangs. (The inline script carries
    // its own longer backstop in case this bundle never loads at all.)
    clearTimeout(showPreloadOverlay._fallback);
    showPreloadOverlay._fallback = setTimeout(hidePreloadOverlay, 6000);
  }
  // Drop the real case image into the loader as soon as the payload lands, so
  // the customer sees the case being prepared rather than a bare spinner.
  function setPreloadImage(src) {
    if (!src) return;
    var img = document.getElementById('xbb-preload-img');
    if (!img) return;
    var sk = document.getElementById('xbb-preload-skeleton');
    // Reveal the image only once it has ACTUALLY decoded — the shimmer covers the
    // load, then the case fades in cleanly. (Before, the skeleton was hidden and
    // the <img> shown the instant src was set, so a blank/broken frame flashed
    // while the file downloaded — the "takes a while / looks weird" part.)
    img.onload = function() {
      img.classList.add('is-loaded');
      if (sk) sk.style.display = 'none';
    };
    img.hidden = false;                 // in-flow (opacity 0) so onload can fire + fade
    // Smaller render than before (240 vs 320) → downloads faster; still crisp at
    // the 104px display size. High priority so it isn't queued behind other assets.
    try { img.fetchPriority = 'high'; } catch (e) {}
    img.src = cdnImg(src, 240);
  }
  function hidePreloadOverlay() {
    clearTimeout(showPreloadOverlay._fallback);
    var root = document.documentElement;
    var el = document.getElementById('xbb-preload');
    if (!el) { root.classList.remove(PRELOAD_CLASS); return; }
    // Fade first, then drop the class (which is what actually un-displays it and
    // releases the scroll lock).
    el.classList.add('xbb-preload--out');
    setTimeout(function() {
      root.classList.remove(PRELOAD_CLASS);
      el.classList.remove('xbb-preload--out');
    }, 440);
  }

  // Transient "Added to your bundle" confirmation — the add-to-cart-style visual.
  // Built on the fly and appended to <body> (so no ancestor clip/transform can
  // trap it), shown briefly, then it fades itself out.
  function showAddedConfirm(line) {
    if (!line) return;
    var host = document.getElementById('xbb-added');
    if (!host) {
      host = document.createElement('div');
      host.id = 'xbb-added';
      host.className = 'xbb-added';
      host.setAttribute('aria-hidden', 'true');
      document.body.appendChild(host);
    }
    var label = (lang === 'de') ? 'Zu deinem Bundle hinzugefügt'
              : (lang === 'fr') ? 'Ajouté à votre bundle'
              : (lang === 'en') ? 'Added to your bundle'
              : 'Toegevoegd aan je bundel';
    var imgHtml = line.image
      ? '<img src="' + esc(cdnImg(line.image, 200)) + '" alt="" decoding="async">'
      : '';
    host.innerHTML =
      '<div class="xbb-added__card">' +
        '<div class="xbb-added__media">' + imgHtml +
          '<span class="xbb-added__check" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          '</span>' +
        '</div>' +
        '<div class="xbb-added__text">' +
          '<span class="xbb-added__label">' + esc(label) + '</span>' +
          '<span class="xbb-added__name">' + esc(line.title || '') + '</span>' +
        '</div>' +
      '</div>';
    host.classList.remove('show');
    void host.offsetWidth;
    host.classList.add('show');
    clearTimeout(showAddedConfirm._t);
    showAddedConfirm._t = setTimeout(function() { host.classList.remove('show'); }, 1800);
  }

  // Fetch the exact case the customer clicked (?product=) straight from the
  // storefront and add it to the set. Uses /products/<handle>.js so it works
  // no matter which grid (cordless vs with-cord) would otherwise source it —
  // the case lands in the tray even if its card isn't on the current view.
  function preselectCaseFromDeepLink(handle) {
    if (!handle) return;
    fetch(lp + '/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !Array.isArray(p.variants) || !p.variants.length) { hidePreloadOverlay(); return; }
        var v = p.variants.filter(function(x) { return x.available; })[0] || p.variants[0];
        if (!v) { hidePreloadOverlay(); return; }
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
        var line = {
          handle: p.handle || handle,
          variantId: String(v.id),
          title: p.title,
          variantTitle: (v.title && v.title !== 'Default Title') ? v.title : '',
          image: img,
          price: v.price,   // /products/.js prices are already in cents
          qty: 1
        };
        if (productNeedsClip(p)) line.needsClip = true;
        // Show the case in the loader the moment we know what it looks like —
        // this lands well before the grid render finishes.
        setPreloadImage(img);
        // Same hard validation the click path uses — never add a €0/phantom line.
        if (!(line.variantId && line.title && Number(line.price) > 0)) { hidePreloadOverlay(); return; }

        // ── Open the CORRECT cord tab for this product ──────────────
        // applyDeepLink optimistically set caseType='without' and (when a
        // product is supplied) deferred the first grid render. Now that we
        // have the real product, detect whether it's a with-cord case, set
        // the tab, and render the grid exactly once — so the customer lands
        // straight on the right tab with no cordless-grid flash. (iPhone +
        // Samsung both.) Falls back to 'without' if detection is inconclusive.
        var detected = detectCordType(p);
        if ((detected === 'with' || detected === 'without') && S.step === 1) {
          if (detected !== S.caseType) {
            S.caseType = detected;
            syncCaseTypeButtons();
            updateProgressForCaseType();
            updateStep1NextLabel();
          }
        }
        // Pin this case to the top of the grid + arm the pulse BEFORE the render,
        // so renderGrid hoists it to the front and maybeHighlightPending scrolls
        // to it in the same pass.
        pinPreselectedCase(line.handle);
        if (_deepLinkPendingCordType) {
          _deepLinkPendingCordType = false;
          if (S.model && S.step === 1) loadStep1Products(); // single render → pins + highlights
        }

        var exists = S.cases.some(function(c) { return c.handle === line.handle && String(c.variantId) === line.variantId; });
        if (!exists) {
          S.cases.push(line);
          S.case = S.cases[0] || null;
          var nb = $('xbb-next-1'); if (nb) nb.disabled = !S.cases.length;
          // No black toast here — the rounded "Toegevoegd aan je bundel" card
          // (showAddedConfirm, fired once the grid is ready) is this flow's
          // confirmation. The old toast flashed through as the mask lifted.
        }
        refreshTray();
        refreshProductCardsSelectedState();
        persistState();
        // Hold the confirmation until the pinned card is actually on screen —
        // maybeHighlightPending fires it as it lifts the preload mask, so the
        // "added" card never floats over the loader or an unrendered grid.
        _preselectedLine = line;
      })
      .catch(function() {
        // Offline / 404 / blocked — never leave the grid stuck on a skeleton:
        // release the hold and render the provisional tab so the page works.
        if (_deepLinkPendingCordType) {
          _deepLinkPendingCordType = false;
          if (S.model && S.step === 1) loadStep1Products();
        }
        // And never leave the preload mask stuck if the fetch failed.
        hidePreloadOverlay();
      });
  }

  // ─── Scroll-to-top (only on long product grids) ─────
  // Appears once the customer has scrolled down a long grid (50+ products),
  // so they can jump back without thumb-marathon scrolling. On mobile it
  // floats just above the bundle drawer (measured) and tucks behind it when
  // the drawer is expanded (lower z-index) — never covering the cart CTA.
  var LONG_GRID_MIN = 50;        // collection size that warrants a back-to-top
  var SCROLLTOP_SHOW_AT = 600;   // px scrolled before it may appear

  function activeProductGridId() {
    if (S.step === 1) {
      var s1b = $('xbb-step-1b');
      return (s1b && s1b.classList.contains('active')) ? 'xbb-step-1-products' : null;
    }
    if (S.step === 2) return 'xbb-step-2-products';
    if (S.step === 3) {
      var s3b = $('xbb-step-3b');
      return (s3b && s3b.classList.contains('active')) ? 'xbb-step-3-products' : null;
    }
    return null;
  }
  function activeGridCount() {
    var id = activeProductGridId();
    if (!id) return 0;
    var full = fullProductLists[id];
    if (full && full.length) return full.length;
    var grid = $(id);
    return grid ? grid.querySelectorAll('.xbb-pcard').length : 0;
  }
  function positionScrollTop(fab) {
    // Anchor horizontally to the MAIN content column's right edge, so on
    // desktop it never overlaps the sidebar tray and on mobile it sits a
    // tidy inset from the screen edge.
    var main = document.querySelector('.xbb-main');
    if (main) {
      var mr = main.getBoundingClientRect();
      fab.style.right = Math.max(14, window.innerWidth - mr.right + 20) + 'px';
    }
    // Vertical: desktop has no bottom drawer; mobile floats just above the
    // collapsed drawer (measured). When the drawer is expanded it sits behind
    // it (lower z-index), so no need to move it then.
    if (window.innerWidth >= 1024) { fab.style.bottom = '24px'; return; }
    var drawer = $('xbb-drawer-mobile');
    var bottom = 18;
    if (drawer && drawer.classList.contains('visible') && !drawer.classList.contains('expanded')) {
      var rect = drawer.getBoundingClientRect();
      var visH = window.innerHeight - rect.top;
      if (visH > 0) bottom = visH + 14;
    }
    fab.style.bottom = bottom + 'px';
  }
  function updateScrollTop() {
    var fab = $('xbb-scrolltop'); if (!fab) return;
    var show = (window.pageYOffset > SCROLLTOP_SHOW_AT) && (activeGridCount() >= LONG_GRID_MIN);
    if (show) positionScrollTop(fab);
    fab.classList.toggle('visible', show);
  }
  function setupScrollTop() {
    var fab = $('xbb-scrolltop'); if (!fab) return;
    fab.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() { updateScrollTop(); ticking = false; });
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateScrollTop();
  }

  // Mobile progress header: full-size while sitting at the top of the page,
  // then compact once pinned so it doesn't cover the screen.
  //
  // Measured against a zero-height SENTINEL placed just above the header, not
  // against the header's own rect: a sticky element reports top<=0 whether it
  // just pinned or is long-pinned, and its height CHANGES when the class
  // toggles — measuring the element itself near the threshold can feed back
  // into layout and flap the class. The sentinel never moves with stickiness.
  //
  // Hysteresis: shrink only after scrolling 48px past the pin point, un-shrink
  // when back within 4px. The 44px dead band exceeds the ~40px height delta,
  // so the toggle can never oscillate, and the snap happens while the user is
  // already scrolling — reads as crisp, not glitchy. Toggling on desktop
  // (position:static there) is a harmless no-op.
  function setupStickyProgress() {
    var prog = document.querySelector('.xbb-prog');
    if (!prog || !prog.parentNode) return;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:0;margin:0;padding:0;border:0;';
    prog.parentNode.insertBefore(sentinel, prog);
    var ticking = false;
    function update() {
      ticking = false;
      var top = sentinel.getBoundingClientRect().top;
      var stuck = prog.classList.contains('xbb-prog--stuck');
      if (!stuck && top <= -48) {
        prog.classList.add('xbb-prog--stuck');
      } else if (stuck && top > -4) {
        prog.classList.remove('xbb-prog--stuck');
      }
      // The filter/sort row sticks directly under this bar, so publish the real
      // height — AFTER the class flip, or the row parks at the tall (pre-collapse)
      // height and leaves a gap the moment the bar actually collapses.
      try { document.documentElement.style.setProperty('--xbb-prog-h', Math.round(prog.getBoundingClientRect().height) + 'px'); } catch (e) {}
    }
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    update();
  }

  // Apply a saved snapshot to S. Shared by init() (page load with the resume
  // already confirmed in this tab) and resumeSavedBundle() (the banner button).
  function applySnapshot(snap) {
    // Restore only well-formed item data
    S.gridDensity = snap.gridDensity === '1' ? '1' : '2';
    S.gridSort = (snap.gridSort === 'price_asc' || snap.gridSort === 'price_desc') ? snap.gridSort : 'default';
    S.activeBrand = (snap.activeBrand === 'samsung') ? 'samsung' : 'iphone';
    S.extraCasesModel = snap.extraCasesModel || null;
    S.extraCasesCord = (snap.extraCasesCord === 'cord' || snap.extraCasesCord === 'nocord') ? snap.extraCasesCord : null;
    S.activeGen = snap.activeGen || S.activeGen;
    S.model = snap.model || null;
    S.caseType = (snap.caseType === 'with' || snap.caseType === 'without') ? snap.caseType : 'without';
    // Validate restored items: must have variantId AND a real title AND a real price.
    // Stops a corrupted snapshot (e.g. a phantom €0 cord from a prior session) from
    // resurfacing and silently inflating the discount-tier count.
    function isValidLine(x) {
      return !!(x && x.variantId && typeof x.title === 'string' && x.title.trim() && Number(x.price) > 0);
    }
    // Restore the cases array (multi-select). Falls back to the legacy
    // single `case` field for snapshots taken before the array existed.
    if (Array.isArray(snap.cases)) {
      S.cases = snap.cases.filter(isValidLine);
    } else if (isValidLine(snap.case)) {
      S.cases = [snap.case];
    } else {
      S.cases = [];
    }
    S.case = S.cases[0] || null;
    S.cordLength = snap.cordLength || S.cordLength;
    S.cords = Array.isArray(snap.cords) ? snap.cords.filter(isValidLine) : [];
    S.accessories = Array.isArray(snap.accessories) ? snap.accessories.filter(isValidLine) : [];
    // Validate step against state — invariants must hold or fall back to step 1
    var restoredStep = snap.step || 1;
    // Only force back to step 1 if the entire bundle is empty —
    // a skip-case bundle (cords/extras only) is a valid state for step 2/3.
    if (restoredStep >= 2 && S.cases.length === 0 && S.cords.length === 0 && S.accessories.length === 0) restoredStep = 1;
    if (restoredStep === 2 && S.caseType === 'with') restoredStep = 1; // with-cord skips step 2
    S.step = restoredStep;
    S.maxStep = Math.max(restoredStep, snap.maxStep || restoredStep);
    // Always land on the canonical sub-step of the restored step
    S.substep = null;

    // Resume ("Verder met je bundel"): surface the shopper's own case at the
    // TOP of the case grid, exactly like the PDP preselect — pin it so
    // renderGrid hoists it to the front with the "Geselecteerd" ribbon. Uses
    // only the pin (no confirmation card, no preload mask — those belong to the
    // PDP entry). The pin persists for the session and drives the hoist whenever
    // step-1's grid renders (now, or later when they navigate back to it); the
    // scroll-to is armed only if we're actually landing on the grid now.
    if (S.cases.length && S.cases[0] && S.cases[0].handle) {
      _pinnedCaseHandle = S.cases[0].handle;
      if (restoredStep === 1) _pendingHighlightHandle = S.cases[0].handle;
    }
  }
  function landOnRestoredStep(deepLinked, landedModel) {
    if (S.step && S.step !== 1) {
      showStep(S.step);
      if (S.step === 2) loadCordTab(S.cordLength || 'short');
      if (S.step === 3) showSubstep('xbb-step-3', 'xbb-step-3a');
    } else if (S.case || ((deepLinked || landedModel) && S.model)) {
      // Have a case (restored) OR arrived via a model deep-link / from a model
      // collection — show the case-grid substep so the customer sees every case
      // for this phone.
      showStep(1);
      showSubstep('xbb-step-1', 'xbb-step-1b');
    }
  }
  // "Verder met je bundel": restore the saved bundle IN PLACE. This used to set
  // a session flag and hard-reload the page — on a phone that meant fetching the
  // section, the styles and the whole products.json path again before anything
  // happened at all (the "lags out" report). Everything init() does after
  // applying a snapshot is repeated here on the live page instead, and the
  // session flag is still set so a refresh in this tab stays resumed.
  function resumeSavedBundle() {
    // Restoring is not an achievement: keep the discount notes quiet for the
    // renders this function triggers, then hand them back to the shopper.
    _discNotesArmed = false;
    var banner = document.getElementById('xbb-resume');
    if (banner) banner.hidden = true;
    var snap = loadPersistedState();
    _deferredResumePending = false;
    try { sessionStorage.setItem('xbb_resume_confirmed', '1'); } catch (e) {}
    if (!snap) return;
    applySnapshot(snap);
    var nextBtn = $('xbb-next-1');
    if (nextBtn) nextBtn.disabled = !S.cases.length;
    // No unlock celebration for a tier they already had.
    var st0 = computeDiscountState(itemCount());
    _lastAppliedPct = (st0.current && st0.current.pct) || 0;
    syncBrandButtons();
    renderGenChips();
    renderModels();
    syncGenChipActive();
    renderSubcats();
    renderAirpodsModels();
    syncCaseTypeButtons();
    updateProgressForCaseType();
    updateStep1NextLabel();
    applyGridDensity();
    if (S.model) loadStep1Products();
    landOnRestoredStep(false, false);
    refreshTray();
    refreshProductCardsSelectedState();
    persistState();
    _discNotesArmed = true;
  }

  function init() {
    // Defensive: clear any stuck modal / drawer / sheet state from a previous
    // navigation. localStorage may restore items but never mid-flight UI. The
    // preload mask is left alone here — the ?product= landing below owns it.
    resetTransientUi({ keepPreload: true });

    // Restore persisted bundle from a previous session (page refresh / nav back).
    // We only restore the *bundle contents* and the *step*, NOT sub-step / mid-
    // flight UI states — that prevents cross-contamination between persistence
    // and the navigation / discount-celebration / modal systems.
    var snap = loadPersistedState();
    var hasRestoredItems = false;
    if (snap) {
      // Pre-flight: did the snapshot actually contain a bundle?
      hasRestoredItems = !!((Array.isArray(snap.cases) && snap.cases.length) ||
        (snap.case && snap.case.variantId) ||
        (Array.isArray(snap.cords) && snap.cords.length) ||
        (Array.isArray(snap.accessories) && snap.accessories.length));
    }
    // A saved bundle is NOT applied on page load. We keep the builder fresh and
    // surface the "resume" banner instead; only when the shopper clicks
    // "Verder met je bundel" (which sets this session flag and reloads) do we
    // actually restore the items / step / totals. "Opnieuw beginnen" clears it.
    var resumeConfirmed = false;
    try { resumeConfirmed = sessionStorage.getItem('xbb_resume_confirmed') === '1'; } catch (e) {}
    var deferRestore = !!(snap && hasRestoredItems && !resumeConfirmed);
    // Block persistState from clobbering the saved bundle while it's deferred.
    _deferredResumePending = deferRestore;

    if (snap && !deferRestore) {
      applySnapshot(snap);
    } else {
      // User-agent based brand detection — flip the brand toggle to Samsung
      // for Android phones, otherwise iPhone heuristic still tries to guess gen.
      var ua = (navigator.userAgent || '');
      if (/SamsungBrowser|SM-[A-Z0-9]+|Galaxy/i.test(ua)) {
        S.activeBrand = 'samsung';
        S.activeGen = 'samsung-s25'; // most recent default
      } else {
        var detectedGen = detectIPhoneGen();
        if (detectedGen) {
          var hasGen = (stepConfig[1].models || []).some(function(m) { return m.gen === detectedGen; });
          if (hasGen) S.activeGen = detectedGen;
        }
      }
    }
    // Re-sync the "Volgende" button to the restored case count — otherwise
    // a customer who refreshed mid-flow lands on step 1 with cases already
    // selected but the CTA disabled.
    var nextBtn = $('xbb-next-1');
    if (nextBtn) nextBtn.disabled = !S.cases.length;

    // Suppress the unlock celebration on the very first render after restore.
    // Set BEFORE the first refreshTray so renderDiscount doesn't fire hearts.
    var initialState = computeDiscountState(itemCount());
    _lastAppliedPct = (initialState.current && initialState.current.pct) || 0;

    // Deep-link overrides restored state: a customer who clicked "build a
    // bundle" on a specific phone meant to start from that phone's cases.
    var deepLinked = applyDeepLink();

    // No explicit deep-link? Fall back to where they came from — arriving from a
    // phone-model collection preselects that phone. Skipped when a bundle is
    // already in progress, so the resume flow keeps ownership of the session; a
    // merely *stale* saved model (no items) is intentionally overridden, since
    // the collection they just browsed is the fresher signal.
    var landedModel = false;
    if (!deepLinked && !hasRestoredItems) {
      landedModel = applyLandingModel();
    }
    // Came from a PRODUCT page rather than a collection? The model isn't in the
    // URL there, so it needs a fetch — run it after the sync render below and
    // fold the result in when it lands.
    // The PDP promo banner links with ?product=<handle> and no ?model=: a
    // product page has no way to know our model handles, so the model gets
    // derived from the product itself. Same machinery as the referrer landing
    // above, but explicit — and it also drops that product into the set, which
    // is the entire point of the banner.
    var promoHandle = '';
    try { promoHandle = (new URLSearchParams(window.location.search)).get('product') || ''; }
    catch (e) { promoHandle = ''; }
    if (deepLinked) promoHandle = '';   // ?model= + ?product= is the older path
    // An explicit ?product= (the PDP promo click) is a clear "start a bundle with
    // THIS case" intent, so it OVERRIDES a restored session. Without this, a
    // returning visitor with a saved bundle (e.g. left off at step 3) had their
    // old session reopened and the clicked product silently ignored. Reset to a
    // clean step-1 start so the landing can preselect the clicked case.
    if (promoHandle) {
      S.cases = []; S.cords = []; S.accessories = []; S.case = null;
      S.step = 1; S.maxStep = 1; S.substep = null;
      // Also drop a stale restored model so the synchronous render below doesn't
      // flash the previous phone's grid before the product fetch sets the right
      // one (applyLandingModelFromProduct → applyLandingModelObject fills it in).
      S.model = null;
      var nb0 = $('xbb-next-1'); if (nb0) nb0.disabled = true;
      // Mark this as a product entry (suppresses the model auto-pick notice) and
      // drop a mask over the whole first render until the case is ready.
      _isProductEntry = true;
      showPreloadOverlay();
    } else if (document.documentElement.classList.contains('xbb-case-loading')) {
      // The inline script masks on any ?product=, but this render isn't the
      // promo-landing flow (e.g. ?model= was present too) — release it.
      hidePreloadOverlay();
    }
    // Referrer-based product landing (came from a PDP by normal browsing, no
    // ?product=) still defers to a saved session; only the explicit link overrides.
    var pendingProductLanding = (!deepLinked && !landedModel && (
      !!promoHandle ||
      (!hasRestoredItems && !!productHandleFromUrl(document.referrer))
    ));
    // Weakest signal, last in line: the phone they picked LAST time. Only when
    // nothing fresher chose one (deep link, collection/product they came from)
    // and the builder would otherwise open on the picker. Comes from the same
    // saved snapshot as the bundle, so it is also there while that bundle waits
    // behind the resume banner. ~40% of sessions never pick a model; a
    // returning visitor should not have to do it twice.
    // Two shapes: the snapshot was applied (no items -> not deferred, S.model set,
    // but the flow would still open on the picker), or it is waiting behind the
    // resume banner (S.model empty, snap.model there). Both land on the grid.
    var rememberedHandle = '';
    if (!deepLinked && !landedModel && !pendingProductLanding && S.step === 1 && !S.cases.length) {
      rememberedHandle = (S.model && S.model.handle) || (snap && snap.model && snap.model.handle) || '';
    }
    if (rememberedHandle) {
      var remembered = (stepConfig[1].models || []).find(function(m) { return m.handle === rememberedHandle; });
      if (remembered && applyLandingModelObject(remembered)) {
        landedModel = true;
        var eyebrow = $('xbb-autopick-eyebrow');
        if (eyebrow) {
          eyebrow.textContent = (lang === 'de') ? 'Deine letzte Wahl' : (lang === 'en') ? 'Your last choice' : (lang === 'fr') ? 'Votre dernier choix' : 'Jouw vorige keuze';
        }
      }
    }
    // Model picker: one-tap shortlist for iPhones whose screen fits several models.
    renderIphoneGuess();

    syncBrandButtons();
    renderGenChips();
    renderModels();
    syncGenChipActive();
    renderSubcats();
    renderAirpodsModels();
    syncCaseTypeButtons();
    updateProgressForCaseType();
    updateStep1NextLabel();
    applyGridDensity();

    if (S.model) {
      if (_deepLinkPendingCordType) {
        // Deep-link with a product: hold the grid on a skeleton until the
        // product fetch resolves the correct cord tab, then it renders once.
        var dlGrid = $('xbb-step-1-products');
        if (dlGrid) dlGrid.innerHTML = skeletonHtml(6);
      } else {
        loadStep1Products();
      }
    }

    // Restore step visibility — always to the canonical sub-step
    landOnRestoredStep(deepLinked, landedModel);
    refreshTray();

    // Product-page landing resolves after the first paint. If it finds a model,
    // apply it exactly like the collection path would have: show the case grid
    // and load it. Bails out if the customer already picked a phone in the
    // meantime, so we never yank the grid out from under them.
    if (pendingProductLanding) {
      applyLandingModelFromProduct(function(ok) {
        // Any bail-out here means the case never gets preselected, so the mask
        // must come down or the customer is staring at a loader forever.
        if (!ok || !S.model) { hidePreloadOverlay(); return; }
        if (S.step !== 1 || S.cases.length) { hidePreloadOverlay(); return; }
        showStep(1);
        showSubstep('xbb-step-1', 'xbb-step-1b');
        syncBrandButtons();
        renderGenChips();
        renderModels();
        syncGenChipActive();
        syncCaseTypeButtons();
        updateStep1NextLabel();
        updateProgressForCaseType();
        if (promoHandle) {
          // Hand the grid render to preselectCaseFromDeepLink: it resolves the
          // product's cord type FIRST and then renders once, so the customer
          // never sees the wrong tab flash. Skeleton until it lands.
          _deepLinkPendingCordType = true;
          var promoGrid = $('xbb-step-1-products');
          if (promoGrid) promoGrid.innerHTML = skeletonHtml(6);
          preselectCaseFromDeepLink(promoHandle);
          // Drop ?product= so removing the case and refreshing doesn't bring it
          // back. ?src= is left intact — entrySource() still needs to read it.
          try {
            var pu = new URL(window.location.href);
            pu.searchParams.delete('product');
            history.replaceState(history.state, '', pu.pathname + (pu.search || '') + pu.hash);
          } catch (e) { /* older browsers: harmless to leave it */ }
        } else {
          loadStep1Products();
        }
        refreshTray();
      }, promoHandle);
    }

    // Show the returning-shopper banner only while a saved bundle is waiting to
    // be resumed (deferred, not yet confirmed). Clicking "Verder met je bundel"
    // reloads with the confirm flag set, which restores the bundle and hides this.
    var resume = $('xbb-resume');
    if (resume && deferRestore) {
      resume.hidden = false;
    }

    setupScrollTop();
    setupStickyProgress();
    setupAutoLoadMore();

    // Arm step scrolling only now: everything above may call showStep/showSubstep
    // while restoring a saved bundle, and a page load must never scroll itself.
    _stepScrollArmed = true;
    // Everything above was the page assembling itself (including a restored
    // bundle), so no discount note fired. From here on, a change is the
    // shopper's own — the first add included.
    _discNotesArmed = true;
    // Did the shopper tap a phone on the early-painted grid, before this script
    // existed? Replay it through the real tile handler, so it behaves exactly as
    // if they had tapped it now.
    try {
      var pend = window.__xbbPendingModel;
      window.__xbbPendingModel = null;
      var grid0 = $('xbb-models-grid');
      if (grid0) grid0.removeAttribute('aria-busy');
      if (pend && !S.model && !S.cases.length) {
        var pendEl = grid0 && grid0.querySelector('.xbb-tile[data-model="' + cssEsc(pend) + '"]');
        if (pendEl) pendEl.click();
      }
    } catch (e) {}
    // Seed the entry we arrived on with the view we landed in, so the first
    // back press from a later step returns HERE (popstate ignores entries
    // without our state, which would otherwise make that press a no-op).
    try { history.replaceState(histState(), '', histUrl()); } catch (e) {}

    console.log('[xoxo-bundle] v2 ready', { lang: lang, models: (stepConfig[1].models || []).length, gen: S.activeGen, restored: !!snap });
  }
  // ─── Startup pre-load of the step-1 case data ─────────────────────
  // Measured 2026-10-26 on a 4x-throttled phone (4G): the cases took 5-6.5s
  // after the model tap, because the tap was what started the fetches. The
  // collections are the same for every model (the grid filters them per model),
  // so fetch them now, while the shopper reads the picker. The loaders join these
  // requests (productInflight / facetInflight), so nothing is fetched twice.
  // Skipped for Data Saver. A failure here is silent: the real call retries.
  function prewarmStep1() {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    } catch (e) {}
    var noop = function() {};
    if (caseSourceHandle) { fetchProductsJson(caseSourceHandle, 250, noop); loadFacets(caseSourceHandle); }
    if (normalCasesEnabled) { fetchProductsJson(normalCaseHandle, 250, noop); loadFacets(normalCaseHandle); }
  }
  function boot() {
    init();
    // after init, so a restored or deep-linked session's own loads go first
    setTimeout(prewarmStep1, 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();